/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {isNotEmpty, KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link, useNavigate, useParams} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CustomUseEffect from '../component/CustomUseEffect'
import swal from 'sweetalert'
import {CloseButton, Spinner} from 'react-bootstrap'
import AddRemoveJadwal from './AddRemoveJadwal'
import {useTranslation, initReactI18next} from 'react-i18next'
import {getAccesses, getStockAvailability, nonSalesList} from '../../../api/modules/order'
import {
  getOrderDetail,
  reject,
  revision,
  approve,
  negoAll,
  updateSales,
  getPriceList,
  editChild,
  getScheduleOrder,
  getCommentOrder,
  getChatOrder,
  postChatOrder,
  rollbackOrder,
  resubmitOrder,
} from '../../../api/modules/order'
import Accordion from 'react-bootstrap/Accordion'
import {create, getFile, deleteFile, getFileByOrder} from '../../../api/modules/file'
import {getCommodities, getStock} from '../../../api/modules/getdatalist'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {setNotifOrder, setGetNotif} from '../../../_metronic/redux/content'
import i18next from 'i18next'
import Select from 'react-select'
import CurrencyInput from 'react-currency-input-field'
import {getCusGrup, getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {
  getProductName,
  getSalesArea,
  getProvince,
  getEndUser,
  getAllEndUser,
  getSector,
  getIncoterm,
  getProvince3,
  getCity,
  getPlant,
  getPayment,
  getProductType,
  getAllPaymentList,
  getProdusen,
} from '../../../api/modules/getdatalist'
import InputGroup from 'react-bootstrap/InputGroup'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {setItemNego} from '../../../_metronic/redux/content'
import axios from 'axios'
import {MultiSelect} from 'react-multi-select-component'
import {PopoverText} from '../../../components/Popover/Popover'
import {parse, format, parseISO} from 'date-fns'
import {appSelector, setOrderSubDetail} from '../../../redux/slices/appSlices'
import {useAppSelector} from '../../../redux/hooks'
import {HakAkses, UserSegment} from '../../../components/mikro/getHakAkses'
import {isUndefined} from 'util'
import {authSelector} from 'src/redux/slices/authSlices'
import {AnyARecord} from 'dns'
import {ActionIcon, AppButton} from 'src/components'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {SkeletonOrderDetail} from './SkeletonOrderDetail'
import {SkeletonModal} from './../../../components/SkeletonModal/SkeletonModal'
import dateformat from 'src/utils/dateformat'
import getCurrentFormattedDate from 'src/utils/Today'
import * as TableUI from '../../../components/Table/Table'
import { FormDetailAddProduct } from './components/FormDetailAddProduct'
import { fetchCheckStock } from 'src/services/fetcher'
import { ShowStock } from './components/ShowStock'
import { InputFile } from 'src/app/components/InputFile'
import { base64ToBlob, handleDownloadAttachment } from 'src/app/helpers/file'

const OrderDetail: React.FC = () => {
  const intl = useIntl()
  const {roleId} = useAppSelector(authSelector)
  const hakAkses = HakAkses()
  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)
  const [show4, setShow4] = useState(false)
  const [show5, setShow5] = useState(false)
  const [show6, setShow6] = useState(false)
  const [showCustomerProfile, setShowCustomerProfile] = useState(false)

  const [destinationProvince, setDestinationProvince] = useState<any>(null)
  const [destinationProvinceDesc, setDestinationProvinceDesc] = useState('')
  const [destinationCity, setDestinationCity] = useState<any>(null)
  const [destinationCityDesc, setDestinationCityDesc] = useState('')
  const [fullDestinationCity, setFullDestinationCity] = useState<any[]>([])

  const [showAttac, setShowAttac] = useState(false)
  const [showStock, setShowStock] = useState(false)
  const [showUpdate, setShowUpdate] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)

  const isRetail = (sector: any): boolean => (sector == 2 || sector == 4) 

  const [statusAmandemen, setStatusAmandemen] = useState('')

  const handleShow1 = async (paramm: any, id: any) => {
    ambilAttachment(paramm, id)
    setShowUpload(true)
  }
  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)
  const handleClose3 = () => setShow3(false)
  const handleShow3 = (id: any) => {
    sessionStorage.setItem('id', id)
    setShow3(true)
  }
  const handleClose4 = () => setShow4(false)
  const handleShow4 = () => {
    setShow4(true)
  }
  const handleClose5 = () => setShow5(false)
  const handleShow5 = () => setShow5(true)
  const handleClose6 = () => setShow6(false)

  const params = useParams()

  const handleShow6 = async () => {
    setBtnLoading(true)

    // if (regarding == 'PO002') {
    if (!showPurchaseForm) {
      let tempPayload: any = {}
      let tempArray: any[] = []

      if (nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202') {
        detailOrder.forEach((item: any) => {
          if (itemIndex.find((element) => item.id == element) == item.id) {
            tempArray.push({
              id: item.id,
              sales_org_code: item.produsen?.code,
              sector_id: item.sector_id,
              end_user: item.end_user,
              incoterm1_id: item.incoterm1?.id,
              material_number: item.material_number,
              unit: item.unit,
              product_name: item.product_name,
              product_type: item.product_type,
              request_price: parseFloat(item.request_price),
              request_quantum: parseFloat(item.request_quantum),
              province_id: parseInt(item.province?.id) || 0,
              city_id: item.city_id,
              notes: item.notes,
              include_ppn: item.include_ppn,
              fixed_price: parseFloat(item.fixed_price2),
              fixed_quantum: parseFloat(item.fixed_quantum2),
              end_user_multiple: idSektor != 1 ? false : !isNoEnduser,
            })
          }
        })
      } else {
        detailOrder.forEach((item: any) => {
          if (itemIndex.find((element) => item.id == element) == item.id) {
            tempArray.push({
              id: item.id,
              sales_org_code: item.produsen?.code,
              sector_id: item.sector_id,
              product_name: item.product_name,
              product_type: item.product_type,
              material_number: item.material_number,
              unit: item.unit,
              end_user: item.end_user,
              notes: item.notes,
              end_user_multiple: idSektor != 1 ? false : !isNoEnduser,
            })
          }
        })
      }

      tempPayload = {
        regarding: regarding,
        non_sales_regarding: nonpenjualan,
        customer_code: customerCode,
        customer_account_group: cusAcountGroup,
        distribution_channel: disctribution,
        order_submissions: tempArray,
        lang: i18next.language,
      }

      await approve(params.id, tempPayload)
        .then((res) => {
          swal({
            title: `${t('Order Aprrove Success')}`,
            icon: 'success',
          }).then(() => {
            // window.location.reload();
            setButtonFlag(false)
            if (regarding == 'PO002' || isRetail(idSektor)) navigate('/management/order/all')
            else getDetail()

            disabledCheckbox()
            disableBtn()
            setShow5(false)
            dispath(setGetNotif(!notif))
          })
        })
        .catch((error) => {
          const msg = error.response.data.message.match('approved quantum')
            ? 'Kuantum Disetujui Wajib Diisi'
            : error.response.data.message
          swal({
            title: `${t(msg)}`,
            icon: 'error',
          })
        })
        .finally(() => setBtnLoading(false))
    } else {
      let tempSubmit: any[] = []

      for (let idx of indexItem) {
        const tmpItem = detailOrder.find((v: any) => v.id == idx || v.generatedId == idx) ?? null

        tempSubmit.push(tmpItem)
      }
      let tempPayload: any[] = []
      tempSubmit.forEach((item: any) => {
        const tempfiles: any[] = []
        item.attachments?.forEach((file: any, _index: any) => {
          tempfiles.push(file)
          if (tempfiles?.length > -1) {
            const temp = file?.file_r.split(',')
            if (temp[1] != undefined) tempfiles[_index].file_r = temp[1]
          }
        })
        let temp = {
          id: item.id || undefined,
          sales_org_code: item.produsen.code,
          incoterm1_id: item.incoterm1.id,
          incoterm2_id: item.incoterm2_id,
          product_type: item.product_type,
          product_type_desc: item.product_type_desc,
          product_name: item.product_name,
          product_spec: item.product_spec,
          request_price: item.request_price,
          request_quantum: item.request_quantum,
          fixed_price: nonPurchaseButPurchase ? item.fixed_price : null,
          fixed_quantum: nonPurchaseButPurchase ? item.fixed_quantum : null,
          payment_type_1: item.payment_type_1,
          payment_type_1_desc: item.payment_type_1_desc,
          payment_type_2: item.payment_type_2,
          payment_type_2_desc: item.payment_type_2_desc,
          province_id: parseInt(item.province?.id) || 0,
          city_id: parseInt(item.city?.id) || 0,
          shipping_tolerance: item.shipping_tolerance,
          sector_id: item.sector_id,
          end_user: item.end_user,
          notes: item.notes,
          material_number: item.material_number,
          unit: item.unit,
          segment_code: item.segment_code,
          segment_name: item.segment_name,
          include_ppn: item.include_ppn,
          payment_note: item.payment_note,
          attachments: tempfiles.length > 0 ? tempfiles : undefined,
          schedules: item.schedules?.length > 0 ? item.schedules : undefined,
          end_user_multiple: item.end_user_multiple,
          is_formulated_price: item.is_formulated_price,
          province_dest_id: item.province_dest?.id,
          city_dest_id: item.city_dest?.id,
          plant: item.plant,
          plant_desc: item.plant_desc,
          moda_angkut_name: item?.moda_angkut_name,
          moda_angkut_type: item?.moda_angkut_type,
          moda_angkut_type_en: item?.moda_angkut_type_en,
        }
        tempPayload.push(temp)
      })

      approve(params.id, {
        regarding,
        non_sales_regarding: nonpenjualan,
        order_submission_ids: itemIndex,
        order_submissions: tempPayload,
        lang: i18next.language,
      })
        .then((res) => {
          const message = (regarding == 'PO002' || isRetail(sektorID)) ? 'Order Aprrove Success' : 'Approve Negotiate'
          swal({
            title: `${t(message)}`,
            icon: 'success',
          }).then(() => {
            // window.location.reload();
            setButtonFlag(false)
            if (regarding == 'PO002' || isRetail(sektorID)) navigate('/management/order/all')
            else {
              if (res.data.data.flag) {
                dispath(setItemNego({id: res.data.data.id, type: res.data.data.flag, id_PO: orderNumber}))
                navigate('/negotiate')
              } else {
                getDetail()
              }
            }

            disabledCheckbox()
            disableBtn()
            setShow5(false)
            dispath(setGetNotif(!notif))
          })
        })
        .catch((error) => {
          const msg = error.response.data.message.match('approved quantum')
            ? 'Kuantum Disetujui Wajib Diisi'
            : error.response.data.message
          swal({
            title: `${t(msg)}`,
            icon: 'error',
          })
        })
        .finally(() => setBtnLoading(false))
    }
  }
  const handleShow62 = () => setShow6(true)
  const [allFile, setAllFiles] = useState<any[]>([])
  const [showJadwal, setShowJadwal] = useState(false)

  const [fixedQuantum2, setFixedQuantum2] = useState<any>(0)
  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum2(temp)
  }

  const handleJadwal = (item: any) => {
    setTempData(item)
    setAllJadwal(item?.schedules)

    if (item?.schedules?.length == undefined) {
      setTaking(0)
    } else {
      setTaking(item?.schedules?.length)
    }

    setShowJadwal(true)
  }

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)
  const [btnStock, setBtnStock] = useState(false)
  const [loadedStock, setLoadedStock] = useState(false)
  const [btnProfile, setBtnProfile] = useState(false)
  const user = localStorage.getItem('role-flag')

  const [rejectNote, setRejectNote] = useState('')
  const [revisionNote, setRevisionNote] = useState('')
  const notif = useSelector((state: any) => state.notif.getNotif)

  const [detailOrder, setDetailOrder] = useState<any[]>([])
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [files3, setFiles3] = useState<any>()
  const [indexAttac, setIndexAttac] = useState(0)

  const [roleUser, setRoleUser] = useState('')
  const [itemIndex, setItemIndex] = useState<any[]>([])
  const [indexItem, setIndexItem] = useState<any[]>([])
  const [buttonFlag, setButtonFlag] = useState(false)
  const [sektorID, setSektorID] = useState(0)
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [status, setStatus] = useState(0)
  const [ID, setID] = useState(0)
  const [statusOrder, setStatusOrder] = useState(0)

  const [updatePrice, setUpdatePrice] = useState(0)
  const [updateQuantum, setUpdateQuantum] = useState(0)
  const [allStock, setAllStock] = useState([])

  const dispath = useDispatch()

  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerTitle, setCustomerTitle] = useState('')
  const [orderNumber, setOrderNumber] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [PICCust, setPICCust] = useState('')
  const [emailCust, setEmailCust] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [param, setParam] = useState('')
  const [paymentTest, setPaymentTest] = useState<any>('')
  const [subOrderID, setSubOrderID] = useState(0)
  const [downloadOnly, setDownloadOnly] = useState(false)
  const [showUpload, setShowUpload] = useState(false)
  const [fullSegment, setFullSegment] = useState<any[]>([])
  const [segment, setSegment] = useState('')
  const [segmentDesc, setSegmentDesc] = useState('')
  const [includePpn, setIncludePpn] = useState(false)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [retailFlag, setRetailFlag] = useState(false)
  const [loadDetail, setLoadDetail] = useState(false)

  //#region
  const [produsen, setProdusen] = useState('')
  const [enduser, setEnduser] = useState('')
  const [sektor, setSektor] = useState('')
  const [idSektor, setIDSector] = useState<any>(0)
  const [commodity, setCommodity] = useState('')
  const [incoterm1, setIncoterm1] = useState(0)
  const [incoterm2, setIncoterm2] = useState(0)
  const [province, setProvince] = useState(0)
  const [country, setCountry] = useState('')
  const [city, setCity] = useState(0)
  const [warehouse, setWarehouse] = useState('')
  const [warehouseDesc, setWarehouseDesc] = useState('')
  const [ptype, setPtype] = useState('')
  const [ptype2, setPtype2] = useState('')
  const [pname, setPname] = useState('')
  const [pnumber, setPnumber] = useState('')
  const [punit, setPunit] = useState('')
  const [pspec, setPspec] = useState('')
  const [subprice, setSubprice] = useState<any>(0)
  const [subpriceApp, setSubpriceApp] = useState<any>(0)
  const [quantum, setQuantum] = useState<any>(0)
  const [quantumApp, setQuantumApp] = useState<any>(0)
  const [note, setNote] = useState('')
  const [pay1, setPay1] = useState('')
  const [pay2, setPay2] = useState('')
  const [disctribution, setDistribution] = useState('')
  const [cusAcountGroup, setCusAcountGroup] = useState('')
  const [shipping, setShipping] = useState(0)
  const [subID, setSubID] = useState(0)
  const [subSektorID, setSubSektorID] = useState(0)
  const [formulaPrice, setFormulaPrice] = useState(false)
  const [isProdusen, setIsProdusen] = useState(false)

  const [produsenDesc, setProdusenDesc] = useState('')
  const [produsenCode, setProdusenCode] = useState(0)
  const [regarding, setRegarding] = useState('')
  const [enduserDesc, setEnduserDesc] = useState('')
  const [sektorDesc, setSektorDesc] = useState('')
  const [incoterm1Desc, setIncoterm1Desc] = useState(0)
  const [incoterm2Desc, setIncoterm2Desc] = useState(0)
  const [provinceDesc, setProvinceDesc] = useState('')
  const [countryDesc, setCountryDesc] = useState('')
  const [cityDesc, setCityDesc] = useState('')
  const [pay1Desc, setPay1Desc] = useState('')
  const [pay2Desc, setPay2Desc] = useState('')
  const [keterangan, setketerangan] = useState('')
  const [allJadwal, setAllJadwal] = useState<any[]>([])
  const [plantcity, setPlantcity] = useState('')

  const [language, setLanguage] = useState<any>()
  const [salesArea, setSalesArea] = useState<any[]>([])
  const [fullEndUser, setFullEndUser] = useState<any[]>([])
  const [fullProdusen, setFullProdusen] = useState<any>([])
  const [fullSector, setFullSector] = useState<any[]>([])
  const [fullIncoterm, setFullIncoterm] = useState<any>([])
  const [fullIncoterm2, setFullIncoterm2] = useState<any>([])
  const [fullProvince, setFullProvince] = useState<any[]>([])
  const [fullProvinceDest, setFullProvinceDest] = useState<any[]>([])
  const [fullCity, setFullCity] = useState<any>([])
  const [fullPlant, setFullPlant] = useState<any>([])
  const [fullPayment, setFullPayment] = useState([])
  const [fullProductType, setFullProductType] = useState([])
  const [fullProductName, setFullProductName] = useState([])
  const [showReason, setShowReason] = useState(false)
  const [reason, setReason] = useState('')

  const [showEdit, setShowEdit] = useState(false)
  const [tempData, setTempData] = useState<any>({})
  const [tempData2, setTempData2] = useState<any>({})
  const [tempDetail, setTempDetail] = useState<any>({})
  const [tempEdit, setTempEdit] = useState<any>({})
  const [idxDetail, setIdxDetail] = useState(0)
  const [nonpenjualan, setNonPenjualan] = useState('')
  const [submitOrder, setSubmitOrder] = useState<any>([])
  const [change, setChange] = useState(false)
  const [btnCancel, setBtnCancel] = useState(false)

  const [isAmandemend] = useState<any>(sessionStorage.getItem('amandemen')!)
  const [showAmandemend, setShowAmandemend] = useState(false)
  const [isDisable, setIsDisable] = useState(false)
  const [arrayEnduser, setEnduserArray] = useState([])
  const [is_amendment, setisAmandment] = useState('false')
  const [showJadwal2, setShowJadwal2] = useState(false)
  const [numberRevised, setNumberRevised] = useState(0)

  const [isNoEnduser, setIsNoEnduser] = useState(false)
  const [allFilesByOrder, setAllFilesByOrder] = useState<any[]>([])

  const [fullcomment, setFullComment] = useState<any>([])
  const [showCommentCust, setShowCommentCust] = useState(false)

  const [fullChat, setFullChat] = useState<any>([])
  const [showFullChat, setShowFullChat] = useState(false)
  const [tempChat, setTempChat] = useState('')
  const [tempId, setTempId] = useState(0)

  const [showAddProduct, setShowAddProduct] = useState(false)
  const [disableAdd, setDisableAdd] = useState(false)
  const [buttonAdd, setButtonAdd] = useState(false)
  const [custStatus, setCustStatus] = useState<any>({})
  const [showAttachmentRevisi, setShowAttachmentRevisi] = useState(false)
  const [listNonSales, setListNonSales] = useState<any>([])
  const [nonSalesRegardingLabel, setNonSalesRegardingLabel] = useState('')
  const [loadingEdit, setLoadingEdit] = useState<any>([])
  const [orderSub, setOrderSub] = useState<any>()

  const [commodities, setCommodities] = useState<any>([])

  useEffect(() => {
    setListCommodities()
  }, [])

  const setListCommodities = async () => {
    const response = await getCommodities();
    
    setCommodities(response.data?.data.map((item: any) => {
      return {
        value: item.name,
        label: item.name,
      }
    }))
  }

  const [colorList] = useState<any>({
    // Red: '#274070',
    Red: '#ff0000',
    Green: '#48CE86',
    Yellow: '#F0C94A',
    Black: '#000000',
  })

  const [totalInvoices, setTotalInvoices] = useState<any[]>([0, 0, 0, 0])

  const [invoices, setInvoices] = useState<any[]>([
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
  ])

  const [isGetCommentLoading, setIsGetCommentLoading] = useState(false)
  const handleGetComment = (id: any, status: any) => {
    let temp = 'order'
    if (status) temp = 'amendment_notes'
    else temp = 'order'

    setIsGetCommentLoading(true)

    getCommentOrder(id, temp)
      .then((res) => {
        setFullComment(res.data.data)
        setShowCommentCust(true)
      })
      .finally(() => {
        setIsGetCommentLoading(false)
      })
  }

  const [isGetChatLoading, setIsGetChatLoading] = useState(false)
  const handleGetChat = (id: any) => {
    setIsGetChatLoading(true)
    getChatOrder(id, 'order_submission')
      .then((res) => {
        setFullChat(res.data.data)
        setShowFullChat(true)
      })
      .finally(() => {
        setIsGetChatLoading(false)
      })
  }

  const handlePostChat = async () => {
    await postChatOrder(
      language,
      {
        parent_id: tempId,
        user_id: localStorage.getItem('user-id'),
        comment: tempChat,
        credentials: localStorage.getItem('credential'),
      },
      'order_submission'
    )
      .then((res) => {
        swal({
          title: `${t('Chat Berhasil Ditambahkan')}`,
          icon: 'success',
        }).then(() => {
          handleGetChat(tempId)
          setTempChat('')
          const areacomment = document.getElementById('areachat') as HTMLInputElement
          if (areacomment != null) areacomment.value = ''
        })
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
  }

  const handleClick = (data: any) => {
    try{
      const parsedDate = parseISO(data)
      const formattedTime = format(parsedDate, 'dd MMM yyyy, HH:mm')
      return formattedTime
    }catch(e:any){
      return "-"
    }
  }

  const handleUser = (data: any) => {
    let result: any[] = []
    data.forEach((data: any) => {
      result.push(data.value)
    })
    return result
  }

  const getAllFileOrder = async (id: any) => {
    await getFileByOrder(id)
      .then((res: any) => {
        setAllFilesByOrder(res.data.data)
      })
      .catch((error) => {})
      .finally(() => setShowUpload3(true))
  }

  const Reject = async () => {
    setBtnLoading(true)
    await reject({reason: rejectNote, order_submission_ids: itemIndex, lang: i18next.language})
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('Order Rejected Success')}`,
            icon: 'success',
          })
          handleClose4()
          disabledCheckbox()
          disableBtn()
          dispath(setGetNotif(!notif))
          // window.location.reload();
          setButtonFlag(false)
          if (regarding == 'PO002') navigate('/management/order/all')
          else getDetail()
        } else {
          swal({
            title: `${t(res.data.message)}`,
            icon: 'error',
          })
        }
      })
      .catch((error) => {
        swal({
          title: `${t(error.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const [showUpload2, setShowUpload2] = useState(false)

  const handleShowUpload2 = async (id: any, id2: any) => {
    setShowUpload2(true)
    let res = await getFile('order-item', id, localStorage.getItem('credential')!)
    let res2 = await getFile('amandemen', id2, localStorage.getItem('credential')!)
    let tempArray: any[] = []
    tempArray = tempArray.concat(res.data.data, res2.data.data)
    setAllFiles(tempArray)
  }

  const [isGetAttachmentLoading, setIsGetAttachmentLoading] = useState(false)
  const ambilAttachment = async (paramm: any, id: any) => {
    setIsGetAttachmentLoading(true)

    try {
      if (paramm == 'header') {
        const res = await getFile(paramm, parseInt(params.id!), localStorage.getItem('credential')!)
        setAllFiles(res.data.data)
      } else if (paramm == 'order-item') {
        const res = await getFile(paramm, id, localStorage.getItem('credential')!)
        setAllFiles(res.data.data)
      } else if (paramm == 'amandemen') {
        const res = await getFile(paramm, id, localStorage.getItem('credential')!)
        setAllFiles(res.data.data)
      }
    } finally {
      setIsGetAttachmentLoading(false)
    }
  }

  const handleShowAttachment = (data: any) => {
    // let tmp: any[] = []

    // let idUser = localStorage?.getItem('user-id')

    // data.forEach((item: any) => {
    //   if (item.private) {
    //     if (accesses?.attachment) {
    //       tmp.push(item)
    //     } else if (idUser == item?.user_id) {
    //       tmp.push(item)
    //     } else { }
    //   } else {
    //     tmp.push(item)
    //   }
    // })
    setAllFiles(data)
  }

  const Revision = async () => {
    setBtnLoading(true)
    const res = await revision({
      reason: revisionNote,
      order_submission_ids: itemIndex,
      lang: i18next.language,
    })
      .then(() => {
        dispath(setGetNotif(!notif))
        swal({
          title: `${t('Order Revision Success')}`,
          icon: 'success',
        }).then(() => {
          disabledCheckbox()
          disableBtn()
          setBtnLoading(false)
          // window.location.reload();
          setButtonFlag(false)
          setShow6(false)
          if (regarding == 'PO002' || isRetail(idSektor)) navigate('/management/order/all')
          else getDetail()
        })
      })
      .catch((err) => {
        setBtnLoading(false)
        swal({
          title: `${t(err.response.data.message)}`,
          icon: 'error',
        })
      })
  }

  const disableBtn = () => {
    const reject = document.getElementById(`btn-reject`) as HTMLInputElement
    const approve = document.getElementById(`btn-approve`) as HTMLInputElement
    const revision = document.getElementById(`btn-revision`) as HTMLInputElement

    if (reject != null) {
      reject.disabled = true
      reject.hidden = true
    }

    if (approve != null) {
      approve.disabled = true
      approve.hidden = true
    }

    if (revision != null) {
      revision.disabled = true
      revision.hidden = true
    }
  }

  const [listAmandemen, setListAmandemen] = useState<any[]>([])
  const [keychange, setKeychange] = useState(0)
  const [isLoadingPage, setIsLoadingPage] = useState(true)

  const getDetail = () => {
    setButtonAdd(false)
    setShowChatHistory(false);
    setIsLoadingPage(true)
    getOrderDetail(params.id, localStorage.getItem('credential'))
      .then(async (res) => {
        setPaymentTest(res.data.data?.children[0]?.payment_type_1_desc)
        let tempArray: any[] = []

        if(
          res.data.data.have_negotiate
        ){
          setShowChatHistory(true);
        }
        res.data.data.children.forEach((data: any) => {
          let tempobject = data
          tempobject.comment = []
          tempobject.attachments = []
          tempobject.fixed_quantum = ([0,1,2,5].includes(data.status)) ? (![2,4].includes(data.sector_id) ? 0 : data.request_quantum) : data.fixed_quantum
          tempobject.fixed_price = ([0,1,2,5].includes(data.status)) ? (![2,4].includes(data.sector_id) ? 0 : data.request_price) : data.fixed_price
          tempArray.push(tempobject)

        })
        await nonSalesList().then((response) => {
          response.data.forEach((element: any) => {
            if (element.code == res.data.data.non_sales_regarding)
              setNonSalesRegardingLabel(element.desc)
          })
        })
        setOrderSub(res.data.data)
        setKeychange(keychange + 1)
        setDetailOrder(tempArray)
        setRegarding(res.data.data.regarding)
        setNonPenjualan(res.data.data.non_sales_regarding)
        setStatus(res.data.data.status)
        setStatusOrder(res.data.data.status)
        setID(res.data.data.id)
        setOrderNumber(res.data.data.po_number)
        setSektorID(res.data.data.sector_id)
        setCustomerCode(res.data.data.customer?.customer_code)
        setCustomerName(res.data.data.customer?.name)
        setCustomerTitle(res.data.data.customer?.title)
        setCustomerAddress(res.data.data.customer?.address)
        setPhoneNumber(res.data.data.customer?.user?.mobile_number)
        setPICCust(res.data.data.customer?.name4)
        setEmailCust(res.data.data.customer?.user?.email)
        setDistribution(res.data.data.distribution_channel)
        setCusAcountGroup(res.data.data.customer_account_group)
        setNumberRevised(res.data.data.item_revisied)
        for (let item of res.data.data.children) {
          if (item.status === 1 || item.status === 0) {
            setButtonAdd(true)
          }
        }
        const temp: any[] = []
        res.data.data.children.forEach((data: any) => {
          if (data.amendment_orders?.length >= 1) temp.push(data.id)
        })

        setListAmandemen(temp)
        if (user == 'salesAdmin') {
          dispath(setGetNotif(!notif))
        }
      })
      .finally(() => setIsLoadingPage(false))
  }

  const rollback = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (accept) => {
      if (accept) {
        setBtnLoading(true)
        await rollbackOrder(id, language)
          .then((res) => {
            if (!res.data.error) {
              swal({
                title: `${t('Rollback Berhasil')}`,
                icon: 'success',
              }).then(() => {
                dispath(setGetNotif(!notif))
                getDetail()
                // const itemAmend = detailOrder.filter((item: any) => (item.id != id && item.is_amendment))
                // if ((res.data.data.is_amendment || res.data.data.amandment_flag) && itemAmend.length == 0) {
                //   sessionStorage.setItem('amandemen', 'true')
                //   navigate('/management/order/amandemen/' + ID)
                // } else {
                // getDetail()
                // }
              })
            } else
              swal({
                title: `${res.data}`,
                icon: 'error',
              })
          })
          .catch(function (error) {
            if (error.response) {
              swal({
                title: `${error.response.data.message}`,
                icon: 'error',
              })
            }
          })
          .finally(() => {
            setBtnLoading(false)
          })
      }
    })
  }

  const handleProfileCustomer = () => {
    setBtnProfile(true)
    const curpo_AllAndalan = async () => {
      let tempaging: any[] = []
      let tempoutstanding: any[] = []
      let tempinvoices: any[] = invoices
      let temptotal: any[] = totalInvoices
      const res = await axios.get(
        `${process.env.REACT_APP_PI_BACKEND_API_MASTERDATA}/customer/profiling/${customerCode}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )

      setCustStatus({
        customer_address: res.data.data.customerprofile?.customer_address,
        customer_id: res.data.data.customerprofile?.customer_id,
        customer_name: res.data.data.customerprofile?.customer_name,
        status: res.data.data.customerprofile?.status,
      })

      // res.data.data.forEach((element: any) => {
      //   if (element.type == 'aging') tempaging.push(element)
      //   else if (element.type == 'outstanding so') tempoutstanding.push(element)
      //   else if (element.type == 'status') {
      //     setCustStatus(element)
      //   }
      // })
      if (res.data.data.customerprofile?.billing_due.length > 0) {
        res.data.data.customerprofile?.billing_due.forEach((element: any) => {
          if (element.aging == '0 - 30 days') {
            element.invoice.forEach((elementInvoice: any) => {
              if (elementInvoice.company == 'B000')
                tempinvoices[0].B000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'C000')
                tempinvoices[0].C000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'D000')
                tempinvoices[0].D000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'E000')
                tempinvoices[0].E000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'F000')
                tempinvoices[0].F000 = elementInvoice.billing_due_count
            })
          } else if (element.aging == '31 - 90 days') {
            element.invoice.forEach((elementInvoice: any) => {
              if (elementInvoice.company == 'B000')
                tempinvoices[1].B000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'C000')
                tempinvoices[1].C000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'D000')
                tempinvoices[1].D000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'E000')
                tempinvoices[1].E000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'F000')
                tempinvoices[1].F000 = elementInvoice.billing_due_count
            })
          } else if (element.aging == '91 - 365 days') {
            element.invoice.forEach((elementInvoice: any) => {
              if (elementInvoice.company == 'B000')
                tempinvoices[2].B000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'C000')
                tempinvoices[2].C000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'D000')
                tempinvoices[2].D000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'E000')
                tempinvoices[2].E000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'F000')
                tempinvoices[2].F000 = elementInvoice.billing_due_count
            })
          } else if (element.aging == '>365 days') {
            element.invoice.forEach((elementInvoice: any) => {
              if (elementInvoice.company == 'B000')
                tempinvoices[3].B000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'C000')
                tempinvoices[3].C000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'D000')
                tempinvoices[3].D000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'E000')
                tempinvoices[3].E000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'F000')
                tempinvoices[3].F000 = elementInvoice.billing_due_count
            })
          }
        })
      }
      tempinvoices.forEach((element: any, index: any) => {
        temptotal[index] += element.B000
        temptotal[index] += element.C000
        temptotal[index] += element.D000
        temptotal[index] += element.E000
        temptotal[index] += element.F000
      })
      setInvoices(tempinvoices)
      setTotalInvoices(temptotal)
      setShowCustomerProfile(true)
    }

    curpo_AllAndalan()
      .then(() => {
        setShow2(true)
      })
      .catch((error: any) => {
        if (error.response) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        } else {
          swal({
            title: t(error.message),
            icon: 'error',
          })
        }
      })
      .finally(() => setBtnProfile(false))
  }

  const [showUpload3, setShowUpload3] = useState(false)

  const handleNonSalesIDChange = async (id: any) => {
    let res = await getFile('order-item', id, localStorage.getItem('credential')!)
    handleShowAttachment(res.data.data)
  }

  const handleCommentClick = (value: any) => {
    const areacomment = document.getElementById('areacomment') as HTMLInputElement
    if (areacomment != null) areacomment.defaultValue = value
  }

  const handleShowJadwalAmandemen = async (id: any, id2: any) => {
    let res = await getScheduleOrder(id, 'false')
    let res2 = await getScheduleOrder(id2, 'true')
    let tempArray: any[] = []
    tempArray = tempArray.concat(res.data.data.schedules, res2.data.data.schedules)
    setAllJadwal(tempArray)
    setShowJadwal2(true)
  }

  const [accesses, setAccesses] = useState<any>()

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDay(today.getDate())
    setMonth(today.getMonth() + 1)
    setYear(today.getFullYear())
    setDateNow(dd + '-' + mm + '-' + yyyy)
    setDaysInMonth(getDaysInMonth(today.getFullYear(), today.getMonth() + 1))

    const handleYear = () => {
      let year = []
      const aYearFromNow = new Date()
      year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear())).getFullYear())
      for (let i = 0; i < 2; i++) {
        year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)).getFullYear())
      }
      setListYear(year)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    handleYear()
    getAccessMenu()
    role()
    getAllRoleList()
    getDetail()
  }, [])

  const [day, setDay] = useState<any>(0)
  const [month, setMonth] = useState<any>(0)
  const [year, setYear] = useState<any>(0)
  const [datenow, setDateNow] = useState('')
  const [orderItemFiles, setOrderItemsFiles] = useState<any[]>([])
  const [statusItem, setStatusItem] = useState(0)
  const [files, setFiles] = useState({file: null})
  const [files2, setFiles2] = useState<any>()
  const [fileBox, setFileBox] = useState<any>({})

  const clearInputUpload = () => {
    const inputPrivate1 = document.getElementById('isPrivate1') as HTMLInputElement
    if (inputPrivate1 != null) inputPrivate1.checked = false

    const inputPrivate2 = document.getElementById('isPrivate2') as HTMLInputElement
    if (inputPrivate2 != null) inputPrivate2.checked = false

    const inputPrivate3 = document.getElementById('isPrivate3') as HTMLInputElement
    if (inputPrivate3 != null) inputPrivate3.checked = false

    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    if (input1 != null) input1.value = ''
    const input1_2 = document.getElementById('uploadketerangan2') as HTMLInputElement
    if (input1_2 != null) input1_2.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    if (input2 != null) input2.value = ''
    const input2_2 = document.getElementById('upload2') as HTMLInputElement
    if (input2_2 != null) input2_2.value = ''
    const input2_1 = document.getElementById('upload11') as HTMLInputElement
    if (input2_1 != null) input2_1.value = ''

    // const input3 = document.getElementById("uploadnama") as HTMLInputElement
    // input3.value = ''
    // const input4 = document.getElementById("uploadjenis") as HTMLInputElement
    // input4.value = t('Select file type')
  }

  const removeFileState = () => {
    setFiles({file: null})
    setFiles2('')
    setNamaFile('')
    setDescription('')
    setDataType('')
    setIsPrivate(false)
    setTempRole([])
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            if (param == 'order-item') ambilAttachment(param, subOrderID)
            else ambilAttachment(param, params.id)
          })
          .catch((error) => {
            swal({
              title: t(error.response.data),
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    if (param == 'header') formdata.append('attach_parent', params.id!)
    else if (param == 'order-item') formdata.append('attach_parent', String(subOrderID))
    else if (param == 'amandemen') formdata.append('attach_parent', String(subOrderID))
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('credentials', localStorage.getItem('credential')!)
    formdata.append('roles', JSON.stringify(temparray))
    await create(param, formdata)
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('document uploaded successfully')}`,
            icon: 'success',
          })
          if (param == 'order-item' || param == 'amandemen') ambilAttachment(param, subOrderID)
          else ambilAttachment(param, params.id)
          clearInputUpload()
          removeFileState()
        } else {
          swal({
            title: t(res.data.message),
            icon: 'error',
          })
        }
      })
      .catch(function (error) {
        if (error) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const disabledCheckbox = () => {
    indexItem.forEach((element: any) => {
      const isChecked = document.getElementById(`checkbox${element}`) as HTMLInputElement
      if (isChecked != null) isChecked.disabled = true
    })
    setIndexItem([])
    setItemIndex([])
  }

  const [amandemenPresent, setAmandemenPresent] = useState(false)

  const onclickCheckBox = (index: any) => {
    const isChecked = document.getElementById(`checkbox${index}`) as HTMLInputElement
    const temp = isChecked.value.split('~#~')

    let tempIndex: string[] = [...indexItem]
    let tempArray: string[] = [...itemIndex]
    if (isChecked.checked) {
      if (!temp[0].startsWith('Uid')) {
        tempArray.push(temp[0])
      }
      tempIndex.push(temp[0].replace('Uid', ''))!

      setItemIndex(tempArray)
      setIndexItem(tempIndex)
    } else {
      tempArray = tempArray.filter((item) => item !== temp[0].replace('Uid', ''))
      tempIndex = tempIndex.filter((item) => item !== temp[0].replace('Uid', ''))

      setItemIndex(tempArray)
      setIndexItem(tempIndex)
    }
    tempArray.forEach((data: any) => {
      let temp = 0
      temp = listAmandemen.findIndex((item: any) => item == data)
      if (temp != 0) {
        setAmandemenPresent(true)
        return
      } else {
        setAmandemenPresent(false)
      }
    })

    if (tempIndex.length != 0) setButtonFlag(true)
    else setButtonFlag(false)
  }

  const onclickCheckBox2 = (index: any) => {
    const isChecked = document.getElementById(`checkbox${index}`) as HTMLInputElement

    const tempIndex: string[] = indexItem
    if (isChecked.checked) {
      tempIndex.push(index)
      setIndexItem(tempIndex)
    } else {
      const tempIndexindex = tempIndex.indexOf(isChecked.value)
      tempIndex.splice(tempIndexindex, 1)
      setIndexItem(tempIndex)
    }
    if (tempIndex.length != 0) setButtonFlag(true)
    else setButtonFlag(false)
  }

  const toNego = async (id: any, PO: any) => {
    dispath(setItemNego({id, type: 'single', url: '/management/order/all', id_PO: PO}))
    navigate('/negotiate')
  }

  // const toNegoAll = async () => {
  //   await negoAll(ID)
  //   navigate('/negotiate')
  // }

  const handleUpdate = async () => {
    setBtnLoading(true)
    await updateSales(ID, {fixed_price: updatePrice, fixed_quantum: updateQuantum})
      .then((res) => {
        swal({
          title: t('dataBerhasilDiupdate'),
          icon: 'success',
        })
        getDetail()
        setShowUpdate(false)
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: t('dataGagalDiupdate'),
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const loadDetailStock = () => {
    setBtnStock(true)
    setLoadedStock(true)

    const temp = {data: [{}]}
    temp.data.splice(0, 1)
    detailOrder.forEach((data) => {
      if (data.is_amendment == true)
        temp.data.push({
          material_number: data.amendment_orders[0]?.material_number,
          unit: data.amendment_orders[0]?.unit,
          plant: data.amendment_orders[0]?.plant,
          product_type: data.amendment_orders[0]?.product_type
        })
      else temp.data.push({
        material_number: data.material_number, 
        unit: data.unit, 
        plant: data.plant,
        product_type: data.product_type
      })
    })

    fetchCheckStock(temp)
      .then((res) => {
        setAllStock(res.data.data)
      })
      .catch((error: any) => {
        if (error.response) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        } else {
          swal({
            title: t(error.message),
            icon: 'error',
          })
        }
      })
      .finally(() => setBtnStock(false))
  }

  const handleStock = async () => {
    setShowStock(true)
    
    if(!loadedStock) loadDetailStock()
  }

  const checkStock = async () => {
    try{
      setBtnLoading(true)
      const resp = await getStockAvailability({
        credentials: localStorage.getItem('credential'),
        material_number: parseInt(pnumber+''),
        unit: punit,
        plant: warehouse,
        quantum: parseFloat(quantum)
      })
      setBtnLoading(false)

      if(resp.data.data) return true
      swal({
        title: t('Failed, stock not available!'),
        icon: 'error',
      })
      return false
    }catch(e){
      setBtnLoading(false)
      swal({
        title: t('Failed, stock not available!'),
        icon: 'error',
      })
      return false;
    }
}

  const handleAddProduct = async () => {
    const mandatoryCheck = checkMandatoryAddProduct()

    if (mandatoryCheck == 'nothing') {

      if(isRetail(idSektor)) {
        const isAvailable = await checkStock()
        if(!isAvailable) return
      }

      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      }).then((yes) => {
        if (yes) {
          let enduser1: any = []
          let enduser2: any = []
          if(isRetail(sektorID)){
            enduser1 = enduserDesc
            enduser2 = enduserDesc
          }else{
            if (!isNoEnduser) {
              arrayEnduser.forEach((data: any) => {
                enduser1.push(data.value)
                enduser2.push(data.label)
              })
            } else {
              enduser1 = enduserDesc
              enduser2 = enduserDesc
            }
          }
          let tempprice = 0
          if (subprice == '' || isNaN(parseFloat(subprice))) tempprice = 0
          else tempprice = parseFloat(subprice)
          const temp = {
            is_amendment: false,
            generatedId: Date.now().toString(),
            sales_org_code: produsenCode,
            sales_org_code_desc: produsenDesc,
            incoterm1_id: incoterm1,
            incoterm1: {code: incoterm1Desc, id: incoterm1},
            incoterm1_desc: incoterm1Desc,
            incoterm2: incoterm2 === 0 ? null : {code: incoterm2Desc, id: incoterm2},
            incoterm2_id: incoterm2 === 0 ? null : incoterm2,
            produsen: {code: produsenCode, name: produsenDesc},
            product_type: ptype,
            product_type_desc: ptype2,
            product_name: pname,
            product_spec: pspec,
            request_price: formulaPrice ? 0 : tempprice,
            fixed_price: formulaPrice ? 0 : tempprice,
            fixed_quantum: parseFloat(quantum),
            request_quantum: parseFloat(quantum),
            shipping_tolerance: shipping,
            province: {id: province, region_name: provinceDesc},
            province_id: province,
            province_desc: provinceDesc,
            province_dest_id: parseInt(destinationProvince),
            province_dest: {
              id: parseInt(destinationProvince),
              region_name: destinationProvinceDesc
            },
            city: {id: city, city_name: cityDesc},
            city_id: city,
            city_dest_id: parseInt(destinationCity),
            city_dest: {
              id: parseInt(destinationCity),
              city_name: destinationCityDesc
            },
            city_desc: cityDesc,
            sector_id: sektorID,
            end_user: enduser2.toString(),
            notes: note,
            sector: {name: sektorID === 1 ? 'Domestik Korperasi' : (isRetail(sektorID) ? 'Domestik Retail' : 'Export')},
            material_number: pnumber,
            unit: punit,
            segment_code: segment,
            segment_name: segmentDesc,
            include_ppn: includePpn,
            is_formulated_price: formulaPrice,
            payment_type_1: pay1,
            payment_type_1_desc: pay1Desc,
            payment_type_2: pay2,
            payment_type_2_desc: pay2Desc,
            payment_note: keterangan,
            status: 1,
            end_user_multiple: sektorID != 1 ? false : !isNoEnduser,
            is_new: true,
            schedules: [],
            attachments: [],
            plant: warehouse,
            plant_desc: warehouseDesc,
            city_plant: plantcity,
          }
          setDetailOrder((data: any[]) => [...data, temp])
          clearState()
          setShowAddProduct(false)
        } else return
      })
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
  }

  const handleDeleteItems = (index: number, id: string) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((del) => {
      if (del) {
        let tmp = [...detailOrder]
        tmp.splice(index, 1)
        setDetailOrder(tmp)
        let tmpsend = [...indexItem]
        const result = tmpsend.filter((item) => item !== id)
        setIndexItem(result)
        swal({
          closeOnClickOutside: false,
          title: t('deleted successfully'),
          icon: 'success',
        })
      }
    })
  }

  const handleSaveDetail = (data: any) => {
    const mandatoryCheck = checkMandatoryDetail(data)

    if (mandatoryCheck == 'nothing') {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      }).then((yes) => {
        if (yes) {
          setDetailOrder((data: any[]) =>
            data.map((item, idx) => {
              if (idx == idxDetail) {
                return tempDetail
              }
              return item
            })
          )
          setSubmitOrder((data: any[]) => {
            const result = data.filter((item) => item.id !== tempDetail.id)
            return [
              ...result,
              {
                id: tempDetail.id,
                sales_org_code: tempDetail.produsen?.code,
                sector_id: tempDetail.sector_id,
                end_user: tempDetail.end_user,
                end_user_multiple: tempDetail.end_user_multiple,
                incoterm1_id: tempDetail.incoterm1?.id,
                incoterm2_id: tempDetail.incoterm2_id || 0,
                material_number: tempDetail.material_number,
                unit: tempDetail.unit,
                product_name: pname || tempDetail.product_name,
                product_type: tempDetail.product_type,
                product_type_desc: tempDetail.product_type_desc,
                product_spec: tempDetail.product_spec,
                request_price: tempDetail.is_formulated_price
                  ? 0
                  : parseFloat(tempDetail.request_price),
                request_quantum: parseFloat(tempDetail.request_quantum),
                payment_type_1: tempDetail.payment_type_1,
                payment_type_1_desc: tempDetail.payment_type_1_desc,
                payment_type_2: tempDetail.payment_type_2,
                payment_type_2_desc: tempDetail.payment_type_2_desc,
                province_id: parseInt(tempDetail.province?.id) || 0,
                city_id: tempDetail.city_id,
                notes: tempDetail.notes,
                segment_code: tempDetail.segment_code,
                segment_name: tempDetail.segment_name,
                shipping_tolerance: tempDetail.shipping_tolerance,
                include_ppn: tempDetail.include_ppn,
                payment_note: tempDetail.payment_note,
                is_formulated_price: tempDetail.is_formulated_price,
                fixed_quantum: parseFloat(tempDetail.fixed_quantum),
                fixed_price: parseFloat(tempDetail.fixed_price),
              },
            ]
          })
          handleClose()
        } else return
      })
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
  }

  const handleEditDetailNonSales = () => {
    const mandatoryCheck = checkMandatory()
    if (mandatoryCheck == 'nothing') {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      }).then((resubmit) => {
        let temp: any = [...detailOrder]
        if (resubmit) {
          setBtnLoading(true)
          temp[temporaryIndex].fixed_price2 = subpriceApp
          temp[temporaryIndex].fixed_quantum2 = quantumApp
          setDetailOrder(temp)
          setBtnLoading(false)
          setShow(false)
        } else return
      })
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
  }

  const handleSaveDetailNonSales = () => {
    const mandatoryCheck = checkMandatory()
    if (mandatoryCheck == 'nothing') {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      }).then((yes) => {
        if (yes) {
          setDetailOrder((data: any[]) =>
            data.map((item, idx) => {
              if (idx == idxDetail) {                
                return {
                  ...tempDetail,
                  product_spec: pspec,
                }
              }
              return item
            })
          )

          setSubmitOrder((data: any[]) => {
            const result = data.filter((item) => item.id !== tempDetail.id)
            return [
              ...result,
              {
                id: tempDetail.id,
                sales_org_code: tempDetail.produsen?.code,
                sector_id: tempDetail.sector_id,
                end_user: tempDetail.end_user,
                end_user_multiple: tempDetail.end_user_multiple,
                incoterm1_id: tempDetail.incoterm1?.id,
                material_number: tempDetail.material_number,
                unit: tempDetail.unit,
                product_name: pname || tempDetail.product_name,
                product_type: tempDetail.product_type,
                product_spec: pspec,
                request_price: parseFloat(tempDetail.request_price),
                request_quantum: parseFloat(tempDetail.request_quantum),
                province_id: parseInt(tempDetail.province?.id) || 0,
                city_id: tempDetail.city_id,
                notes: tempDetail.notes,
                include_ppn: tempDetail.include_ppn,
                fixed_price: parseFloat(tempDetail.fixed_price),
                fixed_quantum: parseFloat(tempDetail.fixed_quantum),
              },
            ]
          })
          handleClose()
        } else return
      })
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
  }

  const handleSaveDetailNonSalesType = () => {
    const mandatoryCheck = checkMandatoryNonSales()
    if (mandatoryCheck == 'nothing') {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      }).then((yes) => {
        if (yes) {
          setDetailOrder((data: any[]) =>
            data.map((item, idx) => {
              if (idx == idxDetail) {
                return tempDetail
              }
              return item
            })
          )
          handleClose()
        } else return
      })
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
  }

  let productTypeDetail = ''
  let regionDetail = ''
  let produsenDetail = ''

  const handleClickAddProduct = async (sector: any) => {
    setDisableAdd(true)
    clearState()
    setShowAddProduct(true)
    await getProdusen().then((res) => {
      setFullProdusen(
        res.data.data.map((item: any) => {
          return {
            label: item.name,
            value: item.code + '~#~' + item.name,
          }
        })
      )
    })

    await getIncoterm().then((res) => {
      let temparray: any[] = [{value: 0 + '~#~', label: t('Pilih-incoterm')}]
      res.data.data.forEach((item: any) => {
        temparray.push({value: item.id + '~#~' + item.code, label: item.code})
      })
      setFullIncoterm(
        res.data.data.map((item: any) => {
          return {
            value: item.id + '~#~' + item.code,
            label: item.code,
          }
        })
      )
    })

    let options: Record<string, any> = {}
    if(sector == 2) options.customer_code = localStorage.getItem("cust-code")
    await getProvince3(options).then((res) => {
      setFullProvince(
        res.data.data.map((item: any) => {
          return {
            value: item.sales_office + '~#~' + item.controlling_area,
            label: item.controlling_area,
            number: item.sales_office,
          }
        })
      )
    })

    await getAllEndUser().then((res) => {
      setFullEndUser(res.data.data)
    })

    await getProductType('').then((res) => {
      setFullProductType(res.data.data.filter((item: any) => item.material_group !== '8105'))
    })

    if (sector !== 3) {
      await getCity(regionDetail).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
    }
    const productNameData = async () => {
      let tempsektor = ''
      if (sektorID != 0) tempsektor = String(sektorID)
      let tempwarehouse = warehouse
      if (!isRetail(idSektor)) tempwarehouse = ''
      await getProductName(
        tempwarehouse,
        disctribution,
        productTypeDetail,
        produsenDetail,
        sektorID
      ).then((res) => {
        setFullProductName(
          res.data.data.map((item: any) => {
            return {
              value: item.material_number + '~#~' + item.material_description,
              label: parseInt(item.material_number) + " - " + item.material_description,
              truevalue: parseInt(item.material_number),
            }
          })
        )
        setDisableAdd(false)
      })
    }
    productNameData()
    await getAllPaymentList(sektorID).then((res) => {
      setFullPayment(res.data.data)
    })

    await getCusGrup().then((res) => {
      setFullSegment(res.data.data)
    })
  }

  const handleDetailClick = async (sector: any) => {
    handleShow()
    setLoadDetail(true)
    setQuantumApp(tempDetail.fixed_price2 >= 0 ? tempDetail.fixed_price2 : '0')
    setSubpriceApp(tempDetail.fixed_quantum2 >= 0 ? tempDetail.fixed_quantum2 : '0')

    await getProdusen().then((res) => {
      setFullProdusen(
        res.data.data.map((item: any) => {
          return {
            label: item.name,
            value: item.code + '~#~' + item.name,
          }
        })
      )
    })

    await getAllEndUser().then((res) => {
      setFullEndUser(res.data.data)
    })

    await getIncoterm().then((res) => {
      let temparray: any[] = [{value: 0 + '~#~', label: t('Pilih-incoterm')}]
      res.data.data.forEach((item: any) => {
        temparray.push({value: item.id + '~#~' + item.code, label: item.code})
      })
      setFullIncoterm(
        res.data.data.map((item: any) => {
          return {
            value: item.id + '~#~' + item.code,
            label: item.code,
          }
        })
      )
    })

    if (sector !== 3) {
      await getProvince3().then((res) => {
        setFullProvince(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office + '~#~' + item.controlling_area,
              label: item.controlling_area,
              number: item.sales_office,
            }
          })
        )
      })
    }

    await getProductType('').then((res) => {
      setFullProductType(res.data.data.filter((item: any) => item.material_group !== '8105'))
    })

    const productNameData = async () => {
      let tempsektor = ''
      if (sektorID != 0) tempsektor = String(sektorID)
      let tempwarehouse = warehouse
      if (!isRetail(idSektor)) tempwarehouse = ''
      await getProductName(
        tempwarehouse,
        disctribution,
        productTypeDetail,
        produsenDetail,
        sektorID
      ).then((res) => {
        setFullProductName(
          res.data.data.map((item: any) => {
            return {
              value: item.material_number + '~#~' + item.material_description,
              label: parseInt(item.material_number) + " - " + item.material_description,
              truevalue: parseInt(item.material_number),
            }
          })
        )
        setLoadDetail(false)
      })
    }
    productNameData()

    if (sector !== 3) {
      await getCity(regionDetail).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
    }
    await getAllPaymentList(sektorID).then((res) => {
      setFullPayment(res.data.data)
    })

    await getCusGrup().then((res) => {
      setFullSegment(res.data.data)
    })
  }

  useEffect(() => {
    const getFUllCity = async () => {
      await getCity(province).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
    }

    getFUllCity()
  }, [province])
  useEffect(() => {
    const getFUllCity = async () => {
      await getCity(destinationProvince).then((res) => {
        setFullDestinationCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
    }

    getFUllCity()
  }, [destinationProvince])

  const reloadData = async () => {
    const cred = localStorage.getItem('cust-code')
    try {
      await getSector(disctribution).then((res) => {
        setFullSector(res.data.data)
      })
    } catch {}

    try {
      await getIncoterm().then((res) => {
        let temparray: any[] = [{value: 0 + '~#~', label: t('Pilih-incoterm')}]
        res.data.data.forEach((item: any) => {
          temparray.push({value: item.id + '~#~' + item.code, label: item.code})
        })
        setFullIncoterm(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.code,
              label: item.code,
            }
          })
        )
        // console.log(temparray)
        setFullIncoterm2(temparray)
      })
    } catch {}

    try {
      await getProductType('').then((res) => {
        setFullProductType(res.data.data.filter((item: any) => item.material_group !== '8105'))
      })
    } catch {}
  }

  CustomUseEffect(() => {
    if (isRetail(idSektor)) setRetailFlag(true)
    else setRetailFlag(false)
  }, [idSektor])

  const getprov = async () => {
    
    let options: Record<string, any> = {}

    if(isRetail(idSektor)) {
      options.customer_code = localStorage.getItem("cust-code")
      options.sales_org_code = produsen
    }

    await getProvince3(options).then((res) => {
      setFullProvince(
        res.data.data.map((item: any) => {
          return {
            value: item.sales_office + '~#~' + item.controlling_area,
            label: item.controlling_area,
            number: item.sales_office,
          }
        })
      )
    })

  }

  const cityData = async (value: any) => {
    const tempName = value.split('~#~')
    setProvince(parseInt(tempName[0]))
    setProvinceDesc(tempName[1])
    try {
      await getCity(tempName[0]).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
      fieldClearer('province')
    } catch {}
  }

  const plantData = async () => {
    let temp: string[] = []
    if (sektor != '') {
      temp = sektor.split('~#~')
    }
    // setIDSector(parseInt(temp[0]))
    // console.log("prod ", produsen, ", sektor ", sektor, ", city ", city)
    try {
      if (produsen != '') {
        await getPlant(produsen, disctribution, province, {
          city_code: city
        }).then((res) => {
          setFullPlant(
            res.data.data.map((item: any) => {
              return {
                value: item.plant + '~#~' + item.plant_name + '~#~' + item.city_name,
                label: item.plant + '-' + item.plant_name,
              }
            })
          )
        })
      }
    } catch {}
  }

  useEffect(() => {
    setFullPlant([])
    const loadPlant = async () => {
      await getPlant(produsenCode, disctribution, parseInt(province + ''), {
        city_code: city
      }).then((res) => {
        setFullPlant(
          res.data.data.map((item: any) => {
            return {
              value: item.plant + '~#~' + item.plant_name + '~#~' + item.city_name,
              label: item.plant + '-' + item.plant_name,
            }
          })
        )
      })
    }
      
    if(produsenCode && province){
    loadPlant()
    }
  }, [produsenCode, disctribution, province])

  const productTypeChange = (value: any) => {
    const tempType = value.split('~#~')
    // if(tempType[1] == 'P13'){
    //   const ckbox = document.getElementById('noenduser') as HTMLInputElement
    //   if (ckbox != null) ckbox.checked = true
    //   // console.log(ckbox)
    //   setIsNoEnduser(true)
    // }
    setPtype2(tempType[0])
    setPtype(tempType[1])
    fieldClearer('tipe')
  }

  const productNameChange = (value: any) => {
    const tempName = value.split('~#~')
    const productName = tempName.filter((val: string, key: number) => key != 0).join('~#~')
    if (tempName[0] != '0') setPname(productName)

    setPnumber(tempName[0])
    setPunit(tempName[2])
    // console.log(tempName)
    // fieldClearer(1)
  }

  const productNameChangedetail = (value: any) => {
    const tempName = value.split('~#~')
    if (tempName[0] != '0') setPname(tempName[1])

    setPnumber(tempName[0])
    setPunit(tempName[2])
  }

  const plantChange = (value: any) => {
    const tempName = value.split('~#~')
    setWarehouse(tempName[0])
    setWarehouseDesc(tempName[1])
    setPlantcity(tempName[2])
    fieldClearer('warehouse')
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const checkMandatory = () => {
    if (regarding == 'PO001') {
      if(tempDetail.status == 0 || tempDetail.status == 1){
        if((subpriceApp == 0 || !subpriceApp))
          return t('isi') + t('sub-order-hargaD')
        else {
          tempDetail['request_price'] = subpriceApp
          return 'nothing'
        };
      }

      if (produsen == '') return t('isi') + t('Sales Org')
      else if (
        !isRetail(idSektor) && ((arrayEnduser.length < 1 && isNoEnduser == false) || (isNoEnduser == true && enduser == ''))
      )
        return t('isi') + t('End Customer')
      // else if (enduser == '' || enduser == '0') return t('isi') + t('End User')
      else if (idSektor == 0) return t('isi') + t('Sector')
      else if (incoterm1 == 0) return t('isi') + t('Incoterm 1')
      else if (idSektor != 3 && province == 0) return t('isi') + t('Province')
      else if (idSektor != 3 && city == 0) return t('isi') + t('City')
      else if (ptype == '') return t('isi') + t('Product Type')
      else if (pnumber == '') return t('isi') + t('Product Name')
      else if ((subprice == 0 || !subprice) && !formulaPrice)
        return t('isi') + t('Submission Price')
      else if (quantum == 0 || !quantum) return t('isi') + t('Quantum')
      else if (pay1 == '') return t('isi') + t('Payment 1')
      else if (idSektor == 1 && segment == '') return t('isi') + 'segment'
      // else if (idSektor == 2 && !pspec) return t('isi') + t('sub-order-spek')
      // else if ((shipping == 0 || Number.isNaN(shipping)) && idSektor != 2) return t('isi') + t('Shipping Tolerance')
      // else if (Number.isNaN(shipping)) return t('shipping harus angka')
      else if (shipping < 0) return t('shipping tolerance tidak boleh minus')
      else if (shipping > 100) return t('Shipping tolerance melebihi 100%')
      else return 'nothing'
    } else if (nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202') {
      if (produsen == '') return t('isi') + t('Sales Org')
      // else if (enduser == '' || enduser == '0') return t('isi') + t('End Customer')
      else if (
        (arrayEnduser.length < 1 && isNoEnduser == false) ||
        (isNoEnduser == true && enduser == '')
      )
        return t('isi') + t('End Customer')
      else if (idSektor == 0) return t('isi') + t('Sector')
      else if (incoterm1 == 0) return t('isi') + 'Incoterm 1'
      else if (province == 0 && idSektor != 3) return t('isi') + t('Province')
      else if (city == 0 && idSektor != 3) return t('isi') + t('City')
      else if (ptype == '') return t('isi') + t('Product Type')
      else if (pnumber == '') return t('isi') + t('Product Name')
      else if (subprice == 0 || subprice == '' || !subprice) return t('isi') + t('Submission Price')
      else if (quantum == 0 || quantum == '' || !quantum) return t('isi') + t('Kuantum Pengajuan')
      else return 'nothing'
    } else {
      if (produsen == '') return t('isi') + t('Sales Org')
      else if (idSektor == 0) return t('isi') + t('Sector')
      else if (ptype == '') return t('isi') + t('Product Type')
      else if (
        (arrayEnduser.length < 1 && isNoEnduser == false) ||
        (isNoEnduser == true && enduser == '')
      )
        return t('isi') + t('End Customer')
      else if (pnumber == '') return t('isi') + t('Product Name')
      else return 'nothing'
    }
  }

  const checkMandatoryAddProduct = () => {
    if (regarding == 'PO001') {
      if (produsenDesc == '') return t('isi') + t('Sales Org')
      else if (
        (idSektor == 1 && arrayEnduser.length < 1 && isNoEnduser == false) ||
        (!isRetail(idSektor) && isNoEnduser == true && enduser == '') ||
        (idSektor == 3 && enduser == '')
      )
        return t('isi') + t('End Customer')
      else if (sektorID == 0) return t('isi') + t('Sector')
      else if (incoterm1 == 0) return t('isi') + t('Incoterm 1')
      else if (province == 0) return t('isi') + t('Province')
      else if (sektorID != 3 && city == 0) return t('isi') + t('City')
      else if (ptype == '') return t('isi') + t('Product Type')
      else if (pname == '' || pnumber == '') return t('isi') + t('Product Name')
      else if ((subprice == 0 || !subprice) && !formulaPrice)
        return t('isi') + t('Submission Price')
      else if (quantum == 0 || !quantum) return t('isi') + t('Quantum')
      else if (pay1 == '') return t('isi') + t('Payment 1')
      else if (sektorID == 1 && segment == '') return t('isi') + 'segment'
      // else if (sektorID == 2 && !pspec) return t('isi') + t('sub-order-spek')
      // else if ((shipping == 0 || Number.isNaN(shipping)) && idSektor != 2) return t('isi') + t('Shipping Tolerance')
      // else if (Number.isNaN(shipping)) return t('shipping harus angka')
      if (produsenCode == 0) return t('isi') + t('Sales Org')
      // else if (enduser == '' || enduser == '0') return t('isi') + t('End Customer')
      else if (
        (sektorID == 1 && arrayEnduser.length < 1 && isNoEnduser == false) ||
        (isNoEnduser == true && enduser == '') ||
        (sektorID != 1 && enduser == '')
      )
        return t('isi') + t('End Customer')
      else if (sektorID == 0) return t('isi') + t('Sector')
      else if (incoterm1 == 0) return t('isi') + 'Incoterm 1'
      else if (province == 0 && sektorID != 3) return t('isi') + t('Province')
      else if (city == 0 && sektorID != 3) return t('isi') + t('City')
      else if (ptype == '') return t('isi') + t('Product Type')
      else if (pnumber == '') return t('isi') + t('Product Name')
      // else if (subprice == 0 || subprice == '') return t('isi') + t('Submission Price')
      else if (quantum == 0 || quantum == '') return t('isi') + t('Quantum')
      else return 'nothing'
    } else {
      if (produsenCode == 0) return t('isi') + t('Sales Org')
      else if (sektorID == 0) return t('isi') + t('Sector')
      else if (ptype == '') return t('isi') + t('Product Type')
      else if (
        (sektorID == 1 && arrayEnduser.length < 1 && isNoEnduser == false) ||
        (isNoEnduser == true && enduser == '') ||
        (sektorID != 1 && enduser == '')
      )
        return t('isi') + t('End Customer')
      else if (pnumber == '') return t('isi') + t('Product Name')
      else return 'nothing'
    }
  }

  const checkMandatoryNonSales = () => {
    if (tempDetail.produsen.code == '') return t('isi') + t('Sales Org')
    else if (tempDetail.end_user === '' || tempDetail.end_user === null)
      return t('isi') + t('End User')
    else if (tempDetail.product_type == '') return t('isi') + t('Product Type')
    else if (tempDetail.material_number == '') return t('isi') + t('Product Name')
    else return 'nothing'
  }

  const checkMandatoryDetail = (data: any) => {
    // if (regarding == 'PO001') {
    if (showPurchaseForm) {
      if (produsen == '') return t('isi') + t('Sales Org')
      else if (data.end_user == '') return t('isi') + t('End User')
      else if (data.sector_id == 0) return t('isi') + t('Sector')
      else if (data.incoterm1.id == 0) return t('isi') + t('Incoterm 1')
      else if (data.province.id == 0 || data.province.id === null) return t('isi') + t('Province')
      else if (data.sector_id != 3 && data.city.city_name === null) return t('isi') + t('City')
      else if (data.product_type_desc == '') return t('isi') + t('Product Type')
      else if (data.material_number == null) return t('isi') + t('Product Name')
      else if (data.request_quantum == 0 || !data.request_quantum) return t('isi') + t('Quantum')
      else if (
        data.sector_id == 2 &&
        ((data.request_price == 0 || !data.request_price) && !data.is_formulated_price))
        return t('isi') + t('Submission Price')
      else if (data.payment_type_1 == '') return t('isi') + t('Payment 1')
      else if (idSektor == 1 && data.segment_code == '') return t('isi') + 'segment'
      // else if ((shipping == 0 || Number.isNaN(shipping)) && !isRetail(idSektor)) return t('isi') + t('Shipping Tolerance')
      // else if (Number.isNaN(shipping)) return t('shipping harus angka')
      else if (shipping < 0) return t('shipping tolerance tidak boleh minus')
      else if (shipping > 100) return t('Shipping tolerance melebihi 100%')
      else return 'nothing'
    } else {
      // if (type == 'simple'){
      //   if (ptype == '') return t('isi') + t('Product Type')
      //   else if (pname == '' || pnumber == '') return t('isi') + t('Product Name')
      //   else return 'nothing'
      // } else {
      // if (incoterm1 == 0) return t('isi') + t('Incoterm')
      // else if (enduser == '' || enduser == '0') return t('isi') + t('End User')
      // else if (idSektor != 3 && province == 0) return t('isi') + t('Province')
      // else if (idSektor != 3 && city == 0) return t('isi') + t('City')
      // else if (ptype == '') return t('isi') + t('Product Type')
      // else if (pname == '' || pnumber == '') return t('isi') + t('Product Name')
      // else if (subprice == 0) return t('isi') + t('Submission Price')
      // else if (quantum == 0) return t('isi') + t('Quantum')
      if (subpriceApp == 0 || !subpriceApp) return t('isi') + t('sub-order-hargaD')
      else if (quantumApp == 0 || !quantumApp) return t('isi') + t('Kuantum PengajuanD')
      else return 'nothing'
      // }
    }
  }

  const fieldClearer = (status: any) => {
    if (status > 0) {
      const hargap = document.getElementById('hargap') as HTMLInputElement
      if (hargap != null) hargap!.value = ''
      setSubprice(0)
      const kuantum = document.getElementById('kuantum') as HTMLInputElement
      if (kuantum != null) kuantum!.value = ''
      setQuantum(0)
      const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
      if (ckbox != null) ckbox.checked = false
      const shipping = document.getElementById('shipping') as HTMLInputElement
      if (shipping != null) shipping!.value = ''
      setShipping(0)
      if (status > 1) {
        setPname('')
        setPnumber('')
        setFullProductName([])
        if (status > 2) {
          const jenis = document.getElementById('jenis') as HTMLSelectElement
          if (jenis != null) jenis!.selectedIndex = 0
          setPtype('')
          setPtype2('')
          if (status > 3) {
            setWarehouse('')
            setWarehouseDesc('')
            setPlantcity('')
            if (status > 4) {
              // setCity(0)
              // setCityDesc('')
              if (status > 5) {
                // setProvince(0)
                // setProvinceDesc('')
                setCountry('')
                setCountryDesc('')
                if (status > 6) {
                  const note = document.getElementById('note') as HTMLInputElement
                  if (note != null) note!.value = ''
                  setNote('')
                  const pay1 = document.getElementById('payment1') as HTMLSelectElement
                  if (pay1 != null) pay1!.selectedIndex = 0
                  const pay2 = document.getElementById('payment2') as HTMLSelectElement
                  if (pay2 != null) pay2!.selectedIndex = 0
                  const segmen = document.getElementById('segment') as HTMLInputElement
                  if (segmen != null) segmen!.value = ''
                  setSegment('')
                  setSegmentDesc('')
                  setPay1('')
                  setPay2('')
                  setPay1Desc('')
                  setPay2Desc('')
                  const enduser = document.getElementById('enduser') as HTMLInputElement
                  if (enduser != null) enduser!.value = ''
                  const enduser2 = document.getElementById('enduser2') as HTMLSelectElement
                  if (enduser2 != null) enduser2!.selectedIndex = 0
                  setEnduser('')
                  setEnduserDesc('')
                  setIsNoEnduser(false)

                  const spek = document.getElementById('spek') as HTMLInputElement
                  if (spek != null) spek!.value = ''
                  setPspec('')
                  const keterangan = document.getElementById('keterangan') as HTMLInputElement
                  if (keterangan != null) keterangan!.value = ''
                  setketerangan('')
                  // setIncoterm1(0)
                  // setIncoterm2(0)
                  // setIncoterm1Desc(0)
                  // setIncoterm2Desc(0)
                  if (status > 7) {
                    // const sektor = document.getElementById('sektor') as HTMLSelectElement
                    // if (sektor != null) sektor!.selectedIndex = 0
                    // setIDSector(0)
                    // setSektorDesc('')
                  }
                }
              }
            }
          }
        }
      }
    } else if (status == 'province') {
      setCity(0)
      setCityDesc('')
      setWarehouse('')
      setWarehouseDesc('')
      setPlantcity('')
    } else if (status == 'pickup-city') {
      setWarehouse('')
      setWarehouseDesc('')
      setPlantcity('')
    } else if (status == 'tipe') {
      setPname('')
      setPnumber('')
    } else if (status == 'warehouse') {
      setPname('')
      setPnumber('')
      setFullProductName([])
      const jenis = document.getElementById('jenis') as HTMLSelectElement
      if (jenis != null) jenis!.selectedIndex = 0
      setPtype('')
      setPtype2('')
    }
  }

  const separateValue = (state: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
  }

  const separateValue3 = (state: any, value: any, desc: any, name: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
    name(temp[2])
  }

  const separateValue2 = (state: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    state(parseInt(temp[0]))
    desc(temp[1])
  }

  const separateValueProdusen = (state: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
  }

  const getSectorDesc = (id: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    id(temp[0])
    desc(temp[2])
  }

  const separator2 = (value: any, state1: any, state2: any) => {
    const temp = value.split('~#~')
    // if(temp[0] == 'P13'){
    //   const ckbox = document.getElementById('noenduser') as HTMLInputElement
    //   if (ckbox != null) ckbox.checked = true
    //   // console.log(ckbox)
    //   setIsNoEnduser(true)
    // }
    state1(temp[0])
    state2(temp[1])
  }

  const priceListData = async () => {
    if (pnumber != '') {
      await getPriceList(localStorage.getItem('cust-code'), produsen, pnumber, city, warehouse, incoterm1Desc).then((res) => {
        setSubprice(res.data.data || 0)
      })
    }
  }

  //#region
  CustomUseEffect(() => {
    if (retailFlag) priceListData()
    else return
  }, [produsen])

  CustomUseEffect(() => {
    if (retailFlag) {
      setSubprice(0)
      priceListData()
    } else return
  }, [pnumber])

  CustomUseEffect(() => {
    if (retailFlag) {
      setSubprice(0)
      fieldClearer('warehouse')
    } else return
  }, [incoterm1])
  
  CustomUseEffect(() => {
    if (retailFlag) {
      setSubprice(0)
      fieldClearer('pickup-city')
      fieldClearer('warehouse')

      plantData()
    } else return
  }, [city])
  //#endregion

  // console.log(ptype, addProduct.product_type)

  CustomUseEffect(() => {
    const productNameData = async () => {
      let tempsektor = ''
      if (sektorID != 0) tempsektor = String(sektorID)
      let tempwarehouse = warehouse
      if (!isRetail(idSektor)) tempwarehouse = ''
      await getProductName(tempwarehouse, disctribution, ptype, produsenCode, tempsektor).then(
        (res) => {
          setFullProductName(
            res.data.data.map((item: any) => {
              return {
                value: item.material_number + '~#~' + item.material_description,
                label: parseInt(item.material_number) + " - " + item.material_description,
                truevalue: parseInt(item.material_number),
              }
            })
          )
        }
      )
    }
    productNameData()
  }, [isProdusen])

  const productNameData3 = async () => {
    let tempsektor = ''
    if (sektorID != 0) tempsektor = String(sektorID)
    let tempwarehouse = warehouse
    if (!isRetail(idSektor)) tempwarehouse = ''
    await getProductName(
      warehouse,
      disctribution,
      ptype,
      produsen || produsenCode,
      tempsektor,
      {
        city: city,
        incoterm: incoterm1Desc,
        customer_code: localStorage.getItem('cust-code')
      }
    ).then((res) => {
      setFullProductName(
        res.data.data.map((item: any) => {
          return {
            value: item.material_number + '~#~' + item.material_description,
            label: parseInt(item.material_number) + " - " + item.material_description,
            truevalue: parseInt(item.material_number),
          }
        })
      )
    })
  }

  CustomUseEffect(() => {
    productNameData3()
  }, [ptype])

  CustomUseEffect(() => {
    reloadData()
    getprov()
    if (localStorage.getItem('cust-group') == 'AR06') plantData()
  }, [produsen])

  CustomUseEffect(() => {
    plantData()
  }, [province, country])

  CustomUseEffect(() => {
    const paymentData = async () => {
      await getAllPaymentList(sektorID).then((res) => {
        setFullPayment(res.data.data)
      })
    }

    paymentData()
  }, [sektorID])

  const handleEdit = async (data: any) => {
  console.log(data)
    try {
      setLoadingEdit(true)
      await getProdusen().then((res) => {
        setFullProdusen(
          res.data.data.map((item: any) => {
            return {
              label: item.name,
              value: item.code + '~#~' + item.name,
            }
          })
        )
      })
      await getSalesArea(localStorage.getItem('cust-code')).then((res) => {
        setSalesArea(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_org + '~#~' + item.distribution_channel + '~#~' + item.produsen?.name,
              label: item.produsen?.name,
            }
          })
        )
      })
      let tempsektor = ''
      if (sektorID != 0) tempsektor = String(sektorID)
      await getEndUser('').then((res) => {
        setFullEndUser(res.data.data)
      })
      await getCity(data?.province?.id).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
      if(data?.province_dest){
        await getCity(data?.province_dest?.id).then((res) => {
          setFullDestinationCity(
            res.data.data.map((item: any) => {
              return {
                value: item.id + '~#~' + item.value,
                label: item.value,
              }
            })
          )
        })
      }
      await getPlant(data?.produsen?.code, disctribution, parseInt(data?.province?.id), {
        city_code: data?.city_id
      }).then((res) => {
        setFullPlant(
          res.data.data.map((item: any) => {
            return {
              value: item.plant + '~#~' + item.plant_name + '~#~' + item.city_name,
              label: item.plant + '-' + item.plant_name,
            }
          })
        )
      })
      await getCusGrup().then((res) => {
        setFullSegment(res.data.data)
      })
      let options: Record<string, any> = {}
      if(isRetail(data?.sector_id)) {
        options.customer_code = localStorage.getItem("cust-code")
        options.sales_org_code = produsen
      }
      await getProvince3(options).then((res) => {
        setFullProvince(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office + '~#~' + item.controlling_area,
              label: item.controlling_area,
              number: item.sales_office,
            }
          })
        )
      })
      await getProvince3().then((res) => {
        setFullProvinceDest(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office + '~#~' + item.controlling_area,
              label: item.controlling_area,
              number: item.sales_office,
            }
          })
        )
      })
      await getProductName(
        data?.plant,
        disctribution,
        data?.product_type,
        data?.produsen?.code,
        tempsektor,
        {
          city: data?.city_id,
          incoterm: data?.incoterm1?.code,
          customer_code: localStorage.getItem('cust-code')
        }
      ).then((res) => {
        setFullProductName(
          res.data.data.map((item: any) => {
            return {
              value: item.material_number + '~#~' + item.material_description,
              label: parseInt(item.material_number) + " - " + item.material_description,
              truevalue: parseInt(item.material_number),
            }
          })
        )
      })
      // if (localStorage.getItem('cust-group') == 'AR06')
      //   plantData()
      // if (localStorage.getItem('cust-group') != undefined) {
      //   if (localStorage.getItem('cust-group') == 'AR03') setRetailFlag(true)
      // }
      setLoadingEdit(false)
    } catch {
      setLoadingEdit(false)
    }
  }

  function download_file(fileURL: any, fileName: any) {
    const [header, base64] = fileURL.split(",");
    const mime = header.match(/:(.*?);/)[1];

    const blob = base64ToBlob(base64, mime);
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, "_blank");
  }

  //accsess delete fileBox
  const accsessDelete = useSelector(
    (state: any) => state.appPersistedReducer.selectedMenu.attachment_delete
  )

  const handleDeleteUploadHeader = (index: any, data: any, setData: any, type: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          const tempArray = [...data]
          tempArray[temporaryIndex].attachments?.splice(index, 1)

          setData(tempArray)
          swal({
            closeOnClickOutside: false,
            title: t('deleted successfully'),
            icon: 'success',
          })
        }
      })
      .catch((err) => {
        swal({
          title: `${t('Data Failed to Delete')}`,
          icon: 'error',
        })
      })
  }

  const handleDeleteUploadAttac = (index: any, data: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          const tempArray = [...data]
          tempArray?.splice(index, 1)

          setDetailOrder((attc: any[]) => {
            attc[indexAttac].attachments = tempArray
            return attc
          })
          swal({
            closeOnClickOutside: false,
            title: t('deleted successfully'),
            icon: 'success',
          })
          setChange(!change)
        }
      })
      .catch((err) => {
        swal({
          title: `${t('Data Failed to Delete')}`,
          icon: 'error',
        })
      })
  }

  const validasiFile = () => {
    if (files2 == null || files2 == '') return 'File'
    else if (description == '') return 'File Information'
    else return 'nothing'
  }

  const validasiFile3 = () => {
    if (files3 == null || files3 == '') return 'File'
    else if (description == '') return 'File Information'
    else return 'nothing'
  }

  const handleUpload2 = async () => {
    const checkvalidasi = validasiFile()
    if (checkvalidasi == 'nothing') {
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }
      let tempObject = {
        file_r: files2,
        name: namaFile,
        description: description,
        file_type: dataType,
        private: isPrivate,
        roles: temparray,
      }
      let temp: any[] = detailOrder
      temp[temporaryIndex].attachments.push(tempObject)
      setOrderItemsFiles(temp)

      clearInputUpload()
      removeFileState()
    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }

  const handleUpload3 = async () => {
    const checkvalidasi = validasiFile3()
    if (checkvalidasi == 'nothing') {
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }
      let tempObject = {
        file_r: files3,
        name: namaFile,
        description: description,
        private: isPrivate,
        roles: temparray,
      }
      let tempArray = [...detailOrder]
      let temp: any[] = tempData?.attachments
      if (temp == null) {
        const temp2 = []
        temp2.push(tempObject)
        temp = temp2
      } else {
        temp.push(tempObject)
      }
      // tempArray.push(tempObject);
      tempArray[indexAttac].attachments = temp

      setDetailOrder(tempArray)
      clearInputUpload()
      removeFileState()
      swal({
        title: `${t('document uploaded successfully')}`,
        icon: 'success',
      })
      // setShow1(false)
    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }

  const [daysInMonth, setDaysInMonth] = useState(0)
  const [tempMinggu, setTempMinggu] = useState(0)
  const [tempTanggal, setTempTanggal] = useState(0)
  const [tempBulan, setTempBulan] = useState(0)
  const [tempTahun, setTempTahun] = useState(0)
  const [tempTon, setTempTon] = useState(0)
  const [taking, setTaking] = useState(0)
  const [tempJadwal, setTempJadwal] = useState<any>([])
  const [index2, setIndex2] = useState(0)
  const [fixedQuantum, setFixedQuantum] = useState(0)

  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]

  const [listYear, setListYear] = useState<any[]>([])

  // console.log(roleUser, regarding, param)

  const clearStateJadwal = () => {
    setTempTanggal(0)
    setTempBulan(0)
    setTempTahun(0)
    setTempTon(0)
  }

  const clearInputJadwal = () => {
    const input1 = document.getElementById('jadwalminggu') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('jadwalbulan') as HTMLSelectElement
    input2.selectedIndex = 0
    const input3 = document.getElementById('jadwaltahun') as HTMLSelectElement
    input3.selectedIndex = 0
    const input4 = document.getElementById('jadwalton') as HTMLInputElement
    input4.value = ''
    const input5 = document.getElementById('jadwaltanggal') as HTMLSelectElement
    if (input5 != null) input5.selectedIndex = 0
    const input6 = document.getElementById('jadwaltanggal1') as HTMLSelectElement
    if (input6 != null) input6.selectedIndex = 0
  }

  const validasiJadwal = () => {
    if (tempTanggal == 0) return t('Tanggal ke-')
    else if (tempBulan == 0) return t('Bulan ke-')
    else if (tempTahun == 0) return t('Tahun ke-')
    else if (tempTon == 0) return t('Tonnage')
    else return 'nothing'
  }

  useEffect(() => {
    if (tempTahun != 0 && tempBulan != 0) setDaysInMonth(getDaysInMonth(tempTahun, tempBulan))
  }, [tempTahun, tempBulan])

  function getDaysInMonth(year: any, month: any) {
    return new Date(year, month, 0).getDate()
  }

  function loopTanggal(jumlah: any) {
    var indents = []
    for (let i = 0; i < jumlah; i++) {
      indents.push(<option value={i + 1}>{i + 1}</option>)
    }
    return indents
  }

  const checktaking = () => {
    let tempdetail = detailOrder
    let temp: any[] = tempdetail[temporaryIndex].schedules
    let tempindex = 0

    if (temp == null) tempindex = 0
    else tempindex = temp.length

    if (tempTahun > year + 1) return 'Tahun tidak boleh melebihi tahun ini'
    if (tempTanggal > getDaysInMonth(tempTahun, tempBulan)) return 'Tanggal melebihi'

    if (tempindex != 0) {
      if (temp[tempindex - 1].year <= tempTahun) {
        if (temp[tempindex - 1].year < tempTahun) {
          if (tempTahun == year) {
            if (tempBulan == month) {
              if (tempTanggal >= day) return 'nothing'
              else return 'Week must be greater than or equal to current week'
            } else if (tempBulan > month) return 'nothing'
            else return 'Month must be greater than or equal to current month'
          } else if (tempTahun > year) return 'nothing'
          else return 'Year must be greater than or equal to current year'
        } else if (temp[tempindex - 1].month <= tempBulan) {
          if (temp[tempindex - 1].month < tempBulan) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else if (temp[tempindex - 1].date < tempTanggal) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else return 'Week must be greater than previous week'
        } else return 'Month must be greater than previous month'
      } else return 'Year must be greater than previous year'
    } else {
      if (tempTahun == year) {
        if (tempBulan == month) {
          if (tempTanggal >= day || day > 28) return 'nothing'
          else return 'Week must be greater than or equal to current week'
        } else if (tempBulan > month) return 'nothing'
        else return 'Month must be greater than or equal to current month'
      } else if (tempTahun > year) return 'nothing'
      else return 'Year must be greater than or equal to current year'
    }
  }

  const [editedIndex, setEditedIndex] = useState<any>()

  const rubahSchedule = (index: any, tonnage: any, tonlama: any) => {
    let tempoquantum = 0
    let tempdetail = detailOrder
    tempdetail[temporaryIndex].schedules?.forEach((element: any) => {
      tempoquantum = tempoquantum + element?.tonnage
    })
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        if (tempTon != 0) {
          if (fixedQuantum >= tempoquantum - tonlama + tempTon) {
            tempdetail[temporaryIndex].schedules[index].tonnage = tonnage
            setDetailOrder(tempdetail)
            setEditedIndex(null)
            swal({
              title: `${t('Success updating schedule')}`,
              icon: 'success',
            })
          } else {
            swal({
              title: t('Melebihi Tonase!'),
              icon: 'error',
            })
          }
        } else {
          swal({
            title: t('isi') + t('Tonnage'),
            icon: 'error',
          })
        }
      } else return setEditedIndex(null)
    })
  }

  const rubahScheduleNewProduct = (index: any, tonnage: any, tonlama: any) => {
    let tempoquantum = 0
    detailOrder[index2]?.schedules?.forEach((element: any) => {
      tempoquantum = tempoquantum + element?.tonnage
    })
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        if (tempTon != 0) {
          if (detailOrder[index2]?.request_quantum >= tempoquantum - tonlama + tempTon) {
            let tempArray: any[] = detailOrder[index2]?.schedules
            tempArray[index].tonnage = tonnage
            setTempJadwal(tempArray)
            setDetailOrder((sched: any[]) => {
              sched[index2].schedules = tempArray
              return sched
            })
            setEditedIndex(null)
            swal({
              title: `${t('Success updating schedule')}`,
              icon: 'success',
            })
          } else {
            swal({
              title: t('Melebihi Tonase!'),
              icon: 'error',
            })
          }
        } else {
          swal({
            title: t('isi') + t('Tonnage'),
            icon: 'error',
          })
        }
      } else return setEditedIndex(null)
    })
  }

  const hapusSchedule = (index: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        let tempArray: any[] = detailOrder
        tempArray[temporaryIndex].schedules.splice(index, 1)
        setDetailOrder(tempArray)
        const temptaking = taking - 1
        setTaking(temptaking)
        setEditedIndex(null)
        clearInputJadwal()
        clearStateJadwal()

        swal({
          closeOnClickOutside: false,
          title: t('Success deleting schedule'),
          icon: 'success',
        })
      } else return setEditedIndex(null)
    })
  }

  const hapusScheduleNewProduct = (index: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        let tempArray: any[] = detailOrder[index2]?.schedules
        tempArray.splice(index, 1)
        setTempJadwal(tempArray)
        const temptaking = taking - 1
        setTaking(temptaking)
        setEditedIndex(null)
        setDetailOrder((sched: any[]) => {
          sched[index2].schedules = tempArray
          return sched
        })
        clearInputJadwal()
        clearStateJadwal()
        swal({
          closeOnClickOutside: false,
          title: t('Success deleting schedule'),
          icon: 'success',
        })
      } else return setEditedIndex(null)
    })
  }

  // console.log(regarding == 'PO002' && roleUser == 'salesAdmin' && (nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202'))

  const sendJadwal = () => {
    let tempoquantum = 0
    let tempdetail = detailOrder
    tempdetail[temporaryIndex].schedules?.forEach((element: any) => {
      tempoquantum = tempoquantum + element?.tonnage
    })

    const CheckTaking = checktaking()
    const checkMandatory = validasiJadwal()
    if (CheckTaking == 'nothing') {
      if (checkMandatory == 'nothing') {
        if (fixedQuantum >= tempoquantum + tempTon) {
          let temp: any = tempdetail[temporaryIndex].schedules
          const temptaking = tempdetail[temporaryIndex].schedules.length
          const tempobject = {
            sort: temptaking + 1,
            date: tempTanggal,
            month: tempBulan,
            year: tempTahun,
            tonnage: tempTon,
          }

          temp.push(tempobject)
          tempdetail[temporaryIndex].schedules = temp
          setDetailOrder(tempdetail)
          clearInputJadwal()
          clearStateJadwal()
          // setShowJadwal(false)
        } else {
          swal({
            title: t('Melebihi Tonase!'),
            icon: 'error',
          })
        }
      } else {
        swal({
          title: t('isi') + checkMandatory,
          icon: 'error',
        })
      }
    } else {
      swal({
        title: t(CheckTaking),
        icon: 'error',
      })
    }
  }

  const sendJadwalNewProduct = () => {
    let tempoquantum = 0
    allJadwal?.forEach((element) => {
      tempoquantum = tempoquantum + element?.tonnage
    })
    const checkMandatory = validasiJadwal()
    const CheckTaking = checktaking()
    if (CheckTaking == 'nothing') {
      if (checkMandatory == 'nothing') {
        if (detailOrder[index2]?.request_quantum >= tempoquantum + tempTon) {
          let temp: any[] = detailOrder[index2]?.schedules
          let sort = detailOrder[index2]?.schedules?.length
          const tempobject = {
            sort: sort + 1,
            date: tempTanggal,
            month: tempBulan,
            year: tempTahun,
            tonnage: tempTon,
          }

          if (temp == null) {
            const temp2 = []
            temp2.push(tempobject)
            temp = temp2
          } else {
            temp.push(tempobject)
          }
          const temptaking = taking + 1
          setTaking(temptaking)
          setTempJadwal(temp)
          clearInputJadwal()
          clearStateJadwal()
        } else {
          swal({
            title: t('Melebihi Tonase!'),
            icon: 'error',
          })
        }
      } else {
        swal({
          title: t('isi') + checkMandatory,
          icon: 'error',
        })
      }
    } else {
      swal({
        title: t(CheckTaking),
        icon: 'error',
      })
    }
  }

  const [tempPayload, setTempPayload] = useState<any>({})
  const [temporaryIndex, setTemporaryIndex] = useState(0)
  const [revisiIndex, setRevisiIndex] = useState(0)

  const editOrderRevisi = async () => {
    const mandatoryCheck = checkMandatory()
    
    if (mandatoryCheck == 'nothing') {

      if(isRetail(idSektor)) {
        const isAvailable = await checkStock()
        if(!isAvailable) return
      }

      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      }).then((resubmit) => {
        let enduser1: any = []
        let enduser2: any = []
        if (!isNoEnduser) {
          arrayEnduser.forEach((data: any) => {
            enduser1.push(data.value)
            enduser2.push(data.label)
          })
        } else {
          enduser1 = enduserDesc
          enduser2 = enduserDesc
        }
        let temp: any = [...detailOrder]
        if (resubmit) {
          if (regarding == 'PO001') {
            setBtnLoading(true)
            const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
            let ppn = false
            if (ckbox != null) {
              if (ckbox.checked) ppn = true
              else ppn = false
            }
            let temptol = shipping
            if (isNaN(temptol)) temptol = 0
            else temptol = shipping
            setRevisiIndex(temporaryIndex + 1)
            temp[temporaryIndex].sales_org_code = produsen
            temp[temporaryIndex].produsen!.code = produsen
            temp[temporaryIndex].produsen!.name = produsenDesc
            temp[temporaryIndex].incoterm1_id = incoterm1
            temp[temporaryIndex].incoterm1!.code = incoterm1Desc
            if (!isRetail(subSektorID)) temp[temporaryIndex].incoterm2_id = incoterm2Desc
            else temp[temporaryIndex].incoterm2_id = plantcity
            if (temp[temporaryIndex].incoterm2 != null)
              temp[temporaryIndex].incoterm2!.code = incoterm2Desc
            temp[temporaryIndex].product_type = ptype
            temp[temporaryIndex].product_type_desc = ptype2
            temp[temporaryIndex].product_name = pname
            temp[temporaryIndex].segment_code = segment
            temp[temporaryIndex].segment_name = segmentDesc
            temp[temporaryIndex].product_spec = pspec
            temp[temporaryIndex].request_price = formulaPrice ? 0 : parseFloat(subprice)
            temp[temporaryIndex].fixed_price = formulaPrice ? 0 : parseFloat(subprice)
            temp[temporaryIndex].fixed_quantum = parseFloat(quantum)
            temp[temporaryIndex].request_quantum = parseFloat(quantum)
            temp[temporaryIndex].province_id = province
            temp[temporaryIndex].so_qty_realized = 0
            if (temp[temporaryIndex].province != null) {
              temp[temporaryIndex].province.region_name = provinceDesc
              temp[temporaryIndex].province.id = province
            }
            if (temp[temporaryIndex].city != null) temp[temporaryIndex].city.city_name = cityDesc
            temp[temporaryIndex].city_id = city
            temp[temporaryIndex].sector_id = idSektor
            temp[temporaryIndex].include_ppn = ppn
            temp[temporaryIndex].end_user = enduser1 ? enduser1.toString() : null
            temp[temporaryIndex].plant = warehouse
            temp[temporaryIndex].city_plant = plantcity
            temp[temporaryIndex].notes = note
            temp[temporaryIndex].payment_type_1 = pay1
            temp[temporaryIndex].payment_type_2 = pay2
            temp[temporaryIndex].shipping_tolerance = temptol
            temp[temporaryIndex].material_number = pnumber
            temp[temporaryIndex].payment_type_1_desc = pay1Desc
            temp[temporaryIndex].payment_type_2_desc = pay2Desc
            temp[temporaryIndex].payment_note = keterangan
            temp[temporaryIndex].country = country
            temp[temporaryIndex].country_desc = countryDesc
            temp[temporaryIndex].plant_desc = warehouseDesc
            temp[temporaryIndex].end_user_multiple = !isNoEnduser
            temp[temporaryIndex].is_formulated_price = formulaPrice
            temp[temporaryIndex].ischanged = true

            if (isRetail(idSektor)) {
              temp[temporaryIndex].province_dest_id = destinationProvince
              temp[temporaryIndex].city_dest_id = destinationCity

              if (temp[temporaryIndex].province_dest != null) {
                temp[temporaryIndex].province_dest.id = destinationProvince
                temp[temporaryIndex].province_dest.region_name = destinationProvinceDesc
              }
              if (temp[temporaryIndex].city_dest != null) {
                temp[temporaryIndex].city_dest.id = destinationCity
                temp[temporaryIndex].city_dest.city_name = destinationCityDesc
              }
            }

            if (idSektor == 4) {
              temp[temporaryIndex].commodity = commodity
            }

            setDetailOrder(temp)
            setBtnCancel(true)
            setBtnLoading(false)
            setShowEdit(false)
          } else {
            const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
            let ppn = false
            if (ckbox != null) {
              if (ckbox.checked) ppn = true
              else ppn = false
            }
            const newTemp = {...tempEdit, is_revisi: true}
            setRevisiIndex(temporaryIndex + 1)
            if (nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202') {
              temp[temporaryIndex].produsen!.code = produsen
              temp[temporaryIndex].produsen!.name = produsenDesc
              temp[temporaryIndex].end_user = enduser1.toString()
              temp[temporaryIndex].incoterm1 = {code: incoterm1Desc, id: incoterm1}
              temp[temporaryIndex].incoterm1_id = incoterm1
              temp[temporaryIndex].product_type = ptype
              temp[temporaryIndex].product_type_desc = ptype2
              temp[temporaryIndex].product_name = pname
              temp[temporaryIndex].material_number = pnumber
              temp[temporaryIndex].province_id = province
              temp[temporaryIndex].province = {region_name: provinceDesc, id: province}
              temp[temporaryIndex].city = {city_name: cityDesc, id: city}
              temp[temporaryIndex].city_id = city
              temp[temporaryIndex].request_price = parseInt(subprice)
              temp[temporaryIndex].request_quantum = parseFloat(quantum)
              temp[temporaryIndex].fixed_price = parseFloat(quantum)
              temp[temporaryIndex].fixed_quantum = parseFloat(quantum)
              temp[temporaryIndex].notes = note
              temp[temporaryIndex].include_ppn = ppn
              temp[temporaryIndex].end_user_multiple = !isNoEnduser
              temp[temporaryIndex].ischanged = true

              setDetailOrder(temp)
            } else {
              temp[temporaryIndex].produsen!.code = produsen
              temp[temporaryIndex].produsen!.name = produsenDesc
              temp[temporaryIndex].end_user = enduser1.toString()
              temp[temporaryIndex].product_type = ptype
              temp[temporaryIndex].product_type_desc = ptype2
              temp[temporaryIndex].product_name = pname
              temp[temporaryIndex].material_number = pnumber
              temp[temporaryIndex].notes = note
              temp[temporaryIndex].end_user_multiple = !isNoEnduser
              temp[temporaryIndex].ischanged = true

              setDetailOrder(temp)
            }
            setBtnCancel(true)
            setShowEdit(false)
          }
        } else return
      })
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
  }

  const postEdit = async () => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (post) => {
      if (post) {
        let ordersubmission: any = []
        if (indexItem.length > 0) {
          indexItem.forEach((data: any) => {
            const tempfiles: any[] = []
            detailOrder[data].attachments?.forEach((file: any, _index: any) => {
              tempfiles.push(file)
              if (tempfiles?.length > -1) {
                const temp = file?.file_r.split(',')
                if (temp[1] != undefined) tempfiles[_index].file_r = temp[1]
              }
            })
            if (regarding == 'PO001') {
              let tempobject = {
                id: detailOrder[data].id,
                sales_org_code: detailOrder[data].produsen.code,
                incoterm1_id: detailOrder[data].incoterm1_id,
                incoterm2_id: detailOrder[data].incoterm2_id,
                product_type: detailOrder[data].product_type,
                product_type_desc: detailOrder[data].product_type_desc,
                product_name: detailOrder[data].product_name,
                product_spec: detailOrder[data].product_spec,
                request_price: detailOrder[data].request_price,
                request_quantum: detailOrder[data].request_quantum,
                province_id: parseInt(detailOrder[data].province_id),
                province_dest_id: parseInt(detailOrder[data].province_dest_id),
                city_id: detailOrder[data].city_id,
                city_dest_id: parseInt(detailOrder[data].city_dest_id),
                sector_id: detailOrder[data].sector_id,
                include_ppn: detailOrder[data].include_ppn,
                end_user: detailOrder[data].end_user,
                segment_code: detailOrder[data].segment_code,
                segment_name: detailOrder[data].segment_name,
                plant: detailOrder[data].plant,
                city_plant: detailOrder[data].city_plant,
                notes: detailOrder[data].notes,
                payment_type_1: detailOrder[data].payment_type_1,
                payment_type_2: detailOrder[data].payment_type_2,
                shipping_tolerance: detailOrder[data].shipping_tolerance,
                material_number: detailOrder[data].material_number,
                unit: detailOrder[data].unit,
                payment_type_1_desc: detailOrder[data].payment_type_1_desc,
                payment_type_2_desc: detailOrder[data].payment_type_2_desc,
                payment_note: detailOrder[data].payment_note,
                country: detailOrder[data].country,
                country_desc: detailOrder[data].country_desc,
                plant_desc: detailOrder[data].plant_desc,
                end_user_multiple: detailOrder[data].end_user_multiple,
                schedules: detailOrder[data].schedules,
                attachments: tempfiles,
                commodity: detailOrder[data].commodity
              }
              ordersubmission.push(tempobject)
            } else {
              if (nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202') {
                let tempobject = {
                  id: detailOrder[data].id,
                  sales_org_code: detailOrder[data].produsen.code,
                  sector_id: detailOrder[data].sector_id,
                  incoterm1_id: detailOrder[data].incoterm1_id,
                  product_type: detailOrder[data].product_type,
                  product_name: detailOrder[data].product_name,
                  material_number: detailOrder[data].material_number,
                  unit: detailOrder[data].unit,
                  province_id: parseInt(detailOrder[data].province_id),
                  city_id: detailOrder[data].city_id,
                  end_user: detailOrder[data].end_user,
                  request_price: detailOrder[data].request_price,
                  request_quantum: detailOrder[data].request_quantum,
                  notes: detailOrder[data].notes,
                  end_user_multiple: detailOrder[data].end_user_multiple,
                  include_ppn: detailOrder[data].include_ppn,
                  attachments: tempfiles,
                }
                ordersubmission.push(tempobject)
              } else {
                let tempobject = {
                  id: detailOrder[data].id,
                  sales_org_code: detailOrder[data].produsen.code,
                  sector_id: detailOrder[data].sector_id,
                  product_type: detailOrder[data].product_type,
                  product_name: detailOrder[data].product_name,
                  material_number: detailOrder[data].material_number,
                  unit: detailOrder[data].unit,
                  end_user: detailOrder[data].end_user,
                  end_user_multiple: detailOrder[data].end_user_multiple,
                  attachments: tempfiles,
                }
                ordersubmission.push(tempobject)
              }
            }
          })
          let payload = {}
          if (regarding == 'PO001') {
            payload = {
              credentials: localStorage.getItem('credential'),
              order_submissions: ordersubmission,
            }
          } else {
            payload = {
              credentials: localStorage.getItem('credential'),
              order_submissions: ordersubmission,
              regarding: regarding,
              non_sales_regarding: nonpenjualan,
            }
          }

          await resubmitOrder(ID, i18next.language, payload)
            .then((res) => {
              swal({
                title: t(res.data.message),
                icon: 'success',
              }).then(() => {
                setRevisiIndex(0)
                navigate('/management/order/all')
              })
            })
            .catch((error) => {
              if (error.response.data.message.match(':')) {
                const msg = error.response.data.message
                swal({
                  closeOnClickOutside: false,
                  title: t(msg.split(':')[0]) + t(msg.split(': ')[1]),
                  icon: 'error',
                })
              } else {
                swal({
                  closeOnClickOutside: false,
                  title: t(error.response.data.message),
                  icon: 'error',
                })
              }
            })
            .finally(() => setBtnLoading(false))
        }
      } else return
    })
  }

  const [disableCKBOX, setDisableCKBOX] = useState(false)

  const separateValue4 = (value: any, state: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
    if (temp[0] != 0) setDisableCKBOX(true)
    else setDisableCKBOX(false)
  }

  const setState = (item: any, type: string) => {
    if (isAmandemend == 'true') {
      setShowAmandemend(true)
    } else if (type == 'app' && roleUser == 'salesAdmin') {
    } else {
      setShowEdit(true)
    }
    // console.log(parseInt(item.material_number))
    setLoading(true)

    clearState()
    // if (item.end_user_detail) setDisableCKBOX(true)
    // else setDisableCKBOX(false)
    if (item.end_user_multiple) setIsNoEnduser(false)
    else setIsNoEnduser(true)
    setProdusen(item.sales_org_code)
    setProdusenDesc(item.produsen?.name)
    if (!item.end_user_multiple) {
      setEnduserArray([])
      setEnduser(item.end_user)
      setEnduserDesc(item.end_user)
    } else {
      const tempenduser = item.end_user.split(',')
      // console.log(submitDesc[index].end_user)
      const temparray: any = []
      tempenduser.forEach((items: any, _index: any) => {
        let temp = {label: items, value: items}
        temparray.push(temp)
      })
      setEnduserArray(temparray)
    }
    setIDSector(item.sector_id)
    setSegment(item.segment_code)
    setSegmentDesc(item.segment_name)
    setIncoterm1(item.incoterm1_id)
    setIncoterm2(item.incoterm2_id)
    setIncoterm1Desc(item.incoterm1?.code)
    // if (item.end_user_detail?.name) setEnduserDesc(item.end_user_detail?.name)
    // else setEnduserDesc(item.end_user)
    if (item.incoterm2 == null) setIncoterm2Desc(item.incoterm2_id)
    else setIncoterm2Desc(item.incoterm2?.code)
    setProvince(item.province_id)
    setCountry(item.country)
    setCountryDesc(item.country_desc)
    setCity(item.city_id)
    setCityDesc(item.city?.city_name)
    setWarehouse(item.plant)
    setWarehouseDesc(item.plant_desc)
    setPnumber(item.material_number)
    setPunit(item.unit)
    setPtype(item.product_type)
    setPtype2(item.product_type_desc)
    setNote(item.notes)
    setProvinceDesc(item.province?.region_name)
    setketerangan(item.payment_note)
    setPname(item.product_name)
    setPspec(item.product_spec)
    setSubprice(item.request_price)
    setQuantum(item.request_quantum)
    setPay1(item.payment_type_1)
    setPay2(item.payment_type_2)
    setPay1Desc(item.payment_type_1_desc)
    setPay2Desc(item.payment_type_2_desc)
    setPlantcity(item.city_plant)
    setShipping(item.shipping_tolerance)
    setFormulaPrice(item.is_formulated_price)
    setDestinationProvince(item.province_dest?.id)
    setDestinationProvinceDesc(item.province_dest?.region_name)
    setDestinationCity(item.city_dest?.id)
    setDestinationCityDesc(item.city_dest?.city_name)
    setLoading(false)
    reloadData()
    setLoading(false)
    
  }

  const clearState = () => {
    setProdusen('')
    setProdusenCode(0)
    setProdusenDesc('')
    setEnduser('')
    setIDSector(0)
    setIncoterm1(0)
    setIncoterm2(0)
    setIncoterm2Desc(0)
    setProvince(0)
    setProvinceDesc('')
    setCountry('')
    setCountryDesc('')
    setCity(0)
    setCityDesc('')
    setSegment('')
    setSegmentDesc('')
    setWarehouse('')
    setWarehouseDesc('')
    setPtype('')
    setPname('')
    setPnumber('')
    setPspec('')
    setSubprice(0)
    setQuantum(0)
    setPay1('')
    setPay2('')
    setketerangan('')
    setShipping(0)
    setPlantcity('')
    setIncludePpn(false)
    setFormulaPrice(false)
    setEnduserArray([])
    if (localStorage.getItem('cust-group') == 'AR06') {
      setIDSector(3)
      setSektorDesc('Export')
    }
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const handleShowEndUser = (enduser: any, multipleend: any) => {
    if (multipleend) {
      let temparray: any[] = enduser.split(',')
      let temp = ''
      temparray.forEach((element: any, index: any) => {
        if (index + 1 == temparray.length) temp = temp + element
        else temp = temp + element + ', '
      })
      return <label>{temp}</label>
    } else return ''
  }

  const handleShowValue = (enduser: any, multipleend: any) => {
    if (multipleend) {
      let temparray: any[] = enduser?.split(',')
      let temp = ''
      temparray?.forEach((element: any, index: any) => {
        if (index + 1 == temparray.length) temp = temp + element
        else temp = temp + element + ', '
      })
      return temp
    } else return ''
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  function handleShowRoleNameFromState(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length)
        temp = temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label
      else
        temp =
          temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label + ', '
    })
    return temp
  }

  const handleShowAttachmentRevisi = (
    id: number,
    status: any,
    item_new: boolean,
    attachment: any
  ) => {
    if (status == 2) ambilAttachment('order-item', id)
    else setAllFiles([])
    setShowAttachmentRevisi(true)
  }

  const [showChatHistory, setShowChatHistory] = useState(false)

  const redirectToChatHistory = () => {
    navigate('/negotiate/history/' + params.id)
  }

  // const redirectToChatHistory = async () => {

  //     let idxNego = null
  
  //     const handleNego = (items: any) => {
  //       let tmpNego = 0
  //       items.forEach((item: any, idx: any) => {
  //         console.log(item)
  //         if ([0,1,2,8,13,5].includes(item.status)) {
  //           idxNego = idx
  //           tmpNego += 1
  //         }
  //       })
  
  //       return tmpNego
  //     }
  
  //     if (handleNego(orderSub.children) > 1) {
  //       dispath(setItemNego({id: orderNumber, type: 'multiple', url: '/management/order/all', id_PO: orderNumber}))
  //       navigate('/negotiate')
  //     } else {
  //       dispath(setItemNego({id: orderSub.id, type: 'parent', idx: idxNego, url: '/management/order/all', id_PO: orderNumber}))
  //       navigate('/negotiate')
  //     }
  //   }

  const changeDestinationProvince = (value: any) => {
    const val = value ? value.split('~#~') : null;
    if (value) setDestinationProvince(parseInt(val[0]))
    if (value) setDestinationProvinceDesc(val[1])

    setDestinationCity(null)
    setDestinationCityDesc('')
  }

  const nonPurchaseButPurchase = (regarding == 'PO002' && ['INF-201', 'INF-202'].includes(nonpenjualan))
  const showPurchaseForm = regarding == 'PO001' || nonPurchaseButPurchase

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {sessionStorage.getItem('amandemen')! == 'true'
          ? t('MANAGEMENT_ORDER_DETAIL_AMANDEMENT.TITLE')
          : t('MANAGEMENT_ORDER_DETAIL.TITLE')}
      </PageTitle>
      <div className='card' key={keychange}>
        {/* begin::Header */}

        {isLoadingPage ? (
          <div className='card-body p-5'>
            <SkeletonOrderDetail />
          </div>
        ) : (
          <>
            {roleUser == null || roleUser == 'null' ? (
              <div className='card-body'>
                <Row>
                  <Col md={6}>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 me-2'>{t('order-perihal')}</p>
                      </Col>
                      <Col md={8} key={nonSalesRegardingLabel}>
                        {regarding == 'PO002' ? (
                          <Form.Control
                            value={t('Non-penjualan') + ' - ' + t(nonSalesRegardingLabel)}
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control value={t('penjualan')} disabled size='sm' />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control type='text' value={customerCode} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control type='text' value={customerName} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Address')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control as='textarea' value={customerAddress} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 me-2'>{t('order-lampiran')}</p>
                      </Col>
                      <Col md={8}>
                        <AppButton
                          text={t('order-lampiran')}
                          isLoading={isGetAttachmentLoading}
                          onClick={() => {
                            setParam('header')
                            setisAmandment('false')
                            setDownloadOnly(false)
                            handleShow1('header', params.id)
                          }}
                        />
                      </Col>
                    </Row>
                    { regarding == 'PO001' && showChatHistory && <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4'>{t('chat-history')}</p>
                      </Col>
                      <Col lg={7}>
                        <Button onClick={redirectToChatHistory} className='btn btn-primary'>
                          {t('order-lihat')}
                        </Button>
                      </Col>
                    </Row> }
                  </Col>
                  <Col md={6}>
                    <Row className='mb-3'>
                      <Col lg={4}>
                        <p className='fs-4 mt-2'>{t('Order Number')}</p>
                      </Col>
                      <Col lg={8}>
                        <Form.Control
                          type='text'
                          value={orderNumber == '' ? '' : '10' + orderNumber}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Phone Number')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control value={phoneNumber} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Email')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control value={emailCust} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('PIC Customer')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control value={PICCust} disabled size='sm' />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <div
                  className='my-5'
                  hidden={
                    numberRevised > 0 && roleUser == 'null' && regarding == 'PO001' ? false : true
                  }
                >
                  <Button
                    className='btn btn-primary me-2'
                    onClick={() => handleClickAddProduct(sektorID)}
                  >
                    {t('+tambah product')}
                  </Button>
                </div>

                <div className='table-responsive bdr'>
                  {/* Table Head */}
                  <TableUI.TableDetail colSpan={14}>
                    <TableUI.TableWrapper style={{marginBottom: 0}}>
                      <TableUI.Table>
                        {showPurchaseForm ? (
                          <>
                            <TableUI.THead>
                              <tr style={{backgroundColor: '#274070'}}>
                                <th hidden={numberRevised > 0 ? false : true}>{t('pilih')}</th>
                                <th>{t('sub-order-item')}</th>
                                <th>Status</th>
                                <th>{t('order-aksi')}</th>
                                <th>Sales Org</th>
                                <th>{t('sub-order-incoterm')}</th>
                                <th>{t('sub-order-wilayah')}</th>
                                {sektorID == 1 && <th>{t('segment')}</th>}
                                <th>{t('End Customer')}</th>
                                <th>{t('sub-order-jenis')}</th>
                                <th>{t('Product Code')}</th>
                                <th>{t('sub-order-produk')}</th>
                                <th>{t('sub-order-spek')}</th>
                                <th>{t('Kuantum Pengajuan')}</th>
                                {!isRetail(sektorID) && <th>{t('Kuantum PengajuanD')}</th>}
                                <th>{t('Harga Pengajuan')}</th>
                                {!isRetail(sektorID) && <th>{t('sub-order-hargaD')}</th>}
                                {sektorID == 1 && <th>Status {t('Price')}</th>}
                                {isRetail(sektorID) && <th>{t('sub-order-gudang')}</th>}
                              </tr>
                            </TableUI.THead>
                            <TableUI.TBody>
                              {detailOrder.map((item, _index) => (
                                <>
                                  {item.is_amendment == false ? (
                                    <tr
                                      key={item?.id ?? _index}
                                      className={
                                        !item.ischanged || (!item.is_new && numberRevised == 0)
                                          ? ''
                                          : 'bg-secondary'
                                      }
                                    >
                                      <td hidden={numberRevised > 0 ? false : true}>
                                        <input
                                          className='form-check-input'
                                          type='checkbox'
                                          id={'checkbox' + _index}
                                          disabled={item.ischanged || item.is_new ? false : true}
                                          value={_index}
                                          onClick={() => onclickCheckBox2(_index)}
                                        />
                                        {/* <span>check 1</span> */}
                                      </td>
                                      <td>
                                        <div>{_index + 1}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {item['status_text'] == 'Pengajuan Amandemen' ||
                                          item['status_text'] == 'Amandemen' ||
                                          item['status_text'] == 'Telah Diamandemen' ||
                                          item['status_text'] ==
                                            'Menunggu Persetujuan Amandemen' ? (
                                            <span className='badge badge-light-info'>
                                              {t('Amandemen')}
                                            </span>
                                          ) : item['status'] == '0' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '1' ? (
                                            <span className='badge badge-light-primary'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '2' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '3' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '4' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '5' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '6' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '7' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : (
                                            <span className='badge badge-light-danger'>
                                              {t(item['status_text'])}
                                            </span>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div
                                          style={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            gap: 4,
                                          }}
                                        >
                                          <ActionIcon
                                            title='Detail'
                                            iconPath='/media/icons/duotune/file-text-fill.svg'
                                            onClick={() => {
                                              setisAmandment('false')
                                              setTempDetail(item)
                                              handleShow()
                                            }}
                                          />

                                          <ActionIcon
                                            title={t('order-lampiran')}
                                            iconPath='/media/icons/duotune/archive-fill.svg'
                                            isLoading={isGetAttachmentLoading}
                                            onClick={() => {
                                              setisAmandment('false')
                                              setRevisiIndex(
                                                item.is_new || item.status == 2 ? 1 : 0
                                              )
                                              setStatusAmandemen(item.status_text)
                                              setStatusItem(item.is_new ? 2 : item.status)
                                              setSubOrderID(item.id)
                                              setParam(
                                                item.is_new_item ? 'amandemen' : 'order-item'
                                              )
                                              setTemporaryIndex(_index)
                                              setDownloadOnly(false)
                                              setFileBox(item)
                                              if (item.status == 2 || item.is_new)
                                                handleShowAttachmentRevisi(
                                                  item.id,
                                                  item.status,
                                                  item.is_new,
                                                  item.attachments
                                                )
                                              else
                                                handleShow1(
                                                  item.is_new_item ? 'amandemen' : 'order-item',
                                                  item.id
                                                )
                                            }}
                                          />

                                          {regarding == 'PO001' && (
                                            <ActionIcon
                                              title={t('Jadwal')}
                                              iconPath='/media/icons/duotune/calendar-check-fill.svg'
                                              onClick={() => {
                                                setSektorID(item.sector_id)
                                                setProvinceDesc(item.province?.region_name)
                                                setCityDesc(item.city?.city_name)
                                                setPname(item.product_name)
                                                formattingTon(item.fixed_quantum)
                                                setisAmandment(item.is_new_item ? 'true' : 'false')
                                                item['status_text'] == 'Pengajuan Amandemen' ||
                                                item['status_text'] == 'Amandemen' ||
                                                item['status_text'] == 'Diamandemen Customer' ||
                                                item['status_text'] == 'Telah Diamandemen' ||
                                                item['status_text'] ==
                                                  'Menunggu Persetujuan Amandemen'
                                                  ? setIsDisable(true)
                                                  : setIsDisable(false)
                                                setFixedQuantum(item.fixed_quantum)
                                                setStatusItem(item.status)
                                                setSubOrderID(
                                                  item.id == undefined ? item.generatedId : item.id
                                                )
                                                setTemporaryIndex(_index)

                                                item.status_text == 'Telah Diamandemen'
                                                  ? sessionStorage.setItem('sales', 'true')
                                                  : sessionStorage.setItem('sales', 'false')
                                                if (item.is_new_item)
                                                  handleShowJadwalAmandemen(0, item.id)
                                                else
                                                  handleShow3(
                                                    item['id'] != undefined
                                                      ? item.id
                                                      : item.generatedId
                                                  )
                                                sessionStorage.setItem('isCustomer', 'true')
                                              }}
                                            />
                                          )}

                                          <ActionIcon
                                            title={t('ubah')}
                                            iconPath='/media/icons/duotune/pencil-fill.svg'
                                            hidden={
                                              (item.status == 2 || item.is_new) &&
                                              item.is_new_item != true
                                                ? false
                                                : true
                                            }
                                            onClick={() => {
                                              setisAmandment('false')
                                              setTempData(item)
                                              setTemporaryIndex(_index)
                                              setSubID(item.id)
                                              handleEdit(item)
                                              setSubSektorID(item.sector?.id)
                                              setState(item, 'edit')
                                            }}
                                          />

                                          {/* <ActionIcon
                                            title={t('Comment')}
                                            iconPath='/media/icons/duotune/chat-left-text-fill.svg'
                                            hidden={item.is_new ? true : false}
                                            isLoading={isGetCommentLoading}
                                            onClick={() => {
                                              handleGetComment(item.id, false)
                                            }}
                                          /> */}

                                          <ActionIcon
                                            title={t('Chat')}
                                            iconPath='/media/icons/duotune/chat-dots-fill.svg'
                                            hidden={item.is_new ? true : false}
                                            isLoading={isGetChatLoading}
                                            onClick={() => {
                                              setTempId(item.id)
                                              handleGetChat(item.id)
                                            }}
                                          />

                                          <ActionIcon
                                            title={t('Hapus')}
                                            iconPath='/media/icons/duotune/trash-fill.svg'
                                            hidden={item.is_new ? false : true}
                                            onClick={() =>
                                              handleDeleteItems(_index, item.generatedId)
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item.produsen?.name}</div>
                                      </td>
                                      {isRetail(item.sector?.id) ? (
                                        <>
                                          {item.incoterm2 == null ? (
                                            <td>
                                              <div>
                                                {item.incoterm1?.code}-{item.incoterm2_id}
                                              </div>
                                            </td>
                                          ) : (
                                            <td>
                                              <div>
                                                {item.incoterm1?.code}-{item.incoterm2?.code}
                                              </div>
                                            </td>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {item.incoterm2 == null ? (
                                            <td>
                                              <div>
                                                {item.incoterm1?.code}
                                                {item.incoterm2_id == null ||
                                                item.incoterm2_id == '0' ||
                                                item.incoterm2_id == ''
                                                  ? ''
                                                  : '-' + item.incoterm2_id}
                                              </div>
                                            </td>
                                          ) : (
                                            <td>
                                              <div>
                                                {item.incoterm1?.code}-{item.incoterm2?.code}
                                              </div>
                                            </td>
                                          )}
                                        </>
                                      )}
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={
                                              item['province']?.region_name +
                                              (item['city']?.city_name
                                                ? ', ' + item['city']?.city_name
                                                : '')
                                            }
                                            index={_index}
                                            className='spec-sliceee'
                                          />
                                        </div>
                                      </td>

                                      {sektorID == 1 && (
                                        <td>
                                          <div>{t(item.segment_name)}</div>
                                        </td>
                                      )}
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={
                                              item?.end_user_multiple
                                                ? handleShowValue(
                                                    item?.end_user,
                                                    item?.end_user_multiple
                                                  )
                                                : item?.end_user
                                            }
                                            index={_index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>{t(item['product_type_desc'])}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {parseInt(item.material_number) == 0 ? (
                                            <label className=''>-</label>
                                          ) : (
                                            item['material_number']?.slice(-7)
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item['product_name']}</div>
                                      </td>
                                      <td>
                                        {item['product_spec'] ? (
                                          <div>
                                            <PopoverText
                                              content={item['product_spec']}
                                              index={_index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        ) : (
                                          <label className=''>-</label>
                                        )}
                                      </td>
                                      <td>
                                        <div>
                                          {i18next.language === 'en'
                                            ? item['request_quantum']?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : item['request_quantum']?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              })}{' '}
                                          {item.sector_id === 3 ? 'MT' : 'Ton'}
                                        </div>
                                      </td>
                                      {!isRetail(sektorID) && (
                                        <td>
                                          <div>
                                            {(
                                                ![0,1,2,5,13].includes(item.status)
                                              ) &&
                                            item.sales_id != null ? (
                                              <>
                                                {i18next.language === 'en'
                                                  ? item['fixed_quantum']?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : item['fixed_quantum']?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })}{' '}
                                                {item.sector_id === 3 ? 'MT' : 'Ton'}
                                              </>
                                            ) : (
                                              <label className=''>-</label>
                                            )}
                                          </div>
                                        </td>
                                      )}

                                      {item.is_formulated_price ? (
                                        <>
                                          <td>
                                            <div>{t('Formulated Price')}</div>
                                          </td>
                                        </>
                                      ) : (
                                        <>
                                          <td>
                                            <div>
                                              {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                                (i18next.language === 'en'
                                                  ? item['request_price']?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : item['request_price']?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })) +
                                                (sektorID != 3 ? '/Ton' : '/MT')}
                                            </div>
                                          </td>
                                        </>
                                      )}
                                      {!isRetail(sektorID) && (
                                        <td>
                                          <div>
                                            {(
                                                ![0,1,2,5,13].includes(item.status)
                                              ) &&
                                            item.sales_id != null ? (
                                              <>
                                                {(sektorID == 1 ? 'Rp ' : 'USD ') +
                                                  (i18next.language === 'en'
                                                    ? item['fixed_price']?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : item['fixed_price']?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })) +
                                                  (sektorID == 1 ? '/Ton' : '/MT')}
                                              </>
                                            ) : (
                                              <label className=''>-</label>
                                            )}
                                          </div>
                                        </td>
                                      )}

                                      {item.sector_id == 1 && (
                                        <td>
                                          <div>
                                            {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                                          </div>
                                        </td>
                                      )}

                                      {isRetail(item.sector_id) && (
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={item['plant'] + ' - ' + item['plant_desc']}
                                              index={_index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                      )}
                                    </tr>
                                  ) : (
                                    <tr
                                      key={item?.id ?? _index}
                                      className={
                                        !item.ischanged || (!item.is_new && numberRevised == 0)
                                          ? ''
                                          : 'bg-secondary'
                                      }
                                    >
                                      <td hidden={numberRevised > 0 ? false : true}>
                                        <div>
                                          <input
                                            className='form-check-input'
                                            type='checkbox'
                                            id={'checkbox' + _index}
                                            value={_index}
                                            disabled={item.ischanged || item.is_new ? false : true}
                                            onClick={() => onclickCheckBox2(_index)}
                                          />
                                          {/* <span>check 2</span> */}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{_index + 1}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {item.amendment_orders[0]?.['status_text'] ==
                                            'Pengajuan Amandemen' ||
                                          item.amendment_orders[0]?.['status_text'] ==
                                            'Amandemen' ||
                                          item.amendment_orders[0]?.['status_text'] ==
                                            'Diamandemen Customer' ||
                                          item.amendment_orders[0]?.['status_text'] ==
                                            'Telah Diamandemen' ||
                                          item.amendment_orders[0]?.['status_text'] ==
                                            'Menunggu Persetujuan Amandemen' ? (
                                            <span className='badge badge-light-info'>
                                              {t('Amandemen')}
                                            </span>
                                          ) : item.amendment_orders[0]?.['status'] == '0' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item.amendment_orders[0]?.['status_text'])}
                                            </span>
                                          ) : item.amendment_orders[0]?.['status'] == '1' ? (
                                            <span className='badge badge-light-primary'>
                                              {t(item.amendment_orders[0]?.['status_text'])}
                                            </span>
                                          ) : item.amendment_orders[0]?.['status'] == '2' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item.amendment_orders[0]?.['status_text'])}
                                            </span>
                                          ) : item.amendment_orders[0]?.['status'] == '3' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item.amendment_orders[0]?.['status_text'])}
                                            </span>
                                          ) : item.amendment_orders[0]?.['status'] == '4' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item.amendment_orders[0]?.['status_text'])}
                                            </span>
                                          ) : item.amendment_orders[0]?.['status'] == '5' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item.amendment_orders[0]?.['status_text'])}
                                            </span>
                                          ) : item.amendment_orders[0]?.['status'] == '6' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item.amendment_orders[0]?.['status_text'])}
                                            </span>
                                          ) : item.amendment_orders[0]?.['status'] == '7' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : (
                                            <span className='badge badge-light-danger'>
                                              {t(item.amendment_orders[0]?.['status_text'])}
                                            </span>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div
                                          style={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            gap: 4,
                                          }}
                                        >
                                          <ActionIcon
                                            className='me-1'
                                            title='Detail'
                                            iconPath='/media/icons/duotune/file-text-fill.svg'
                                            onClick={() => {
                                              setisAmandment('true')
                                              setTempData2(item)
                                              setTempData(item.amendment_orders[0])
                                              setTempDetail(item.amendment_orders[0])
                                              setShow(true)
                                            }}
                                          />

                                          <ActionIcon
                                            className='me-1'
                                            title={t('order-lampiran')}
                                            iconPath='/media/icons/duotune/archive-fill.svg'
                                            isLoading={isGetAttachmentLoading}
                                            onClick={() => {
                                              handleShowUpload2(
                                                item.id,
                                                item.amendment_orders[0]?.id
                                              )
                                              setSubOrderID(item.amendment_orders[0]?.id)
                                              setParam('amandemen')
                                              setDownloadOnly(false)
                                              setTemporaryIndex(_index)
                                            }}
                                          />

                                          {regarding == 'PO001' && (
                                            <ActionIcon
                                              className='me-1'
                                              title={t('Jadwal')}
                                              iconPath='/media/icons/duotune/calendar-check-fill.svg'
                                              onClick={() => {
                                                setSektorID(item.amendment_orders[0]?.sector_id)
                                                setProvinceDesc(
                                                  item.amendment_orders[0]?.province?.region_name
                                                )
                                                item['status_text'] == 'Pengajuan Amandemen' ||
                                                item['status_text'] == 'Amandemen' ||
                                                item['status_text'] == 'Diamandemen Customer' ||
                                                item['status_text'] == 'Telah Diamandemen' ||
                                                item['status_text'] ==
                                                  'Menunggu Persetujuan Amandemen'
                                                  ? setIsDisable(true)
                                                  : setIsDisable(false)
                                                setCityDesc(
                                                  item.amendment_orders[0]?.city?.city_name
                                                )
                                                setPname(item.amendment_orders[0]?.product_name)
                                                formattingTon(
                                                  item.amendment_orders[0]?.fixed_quantum
                                                )
                                                setisAmandment('true')
                                                setTemporaryIndex(_index)
                                                handleShowJadwalAmandemen(
                                                  item.id,
                                                  item.amendment_orders[0]?.id
                                                )
                                                setSubOrderID(item.amendment_orders[0]?.id)
                                              }}
                                            />
                                          )}

                                          {/* <ActionIcon
                                            className='me-1'
                                            title={t('Comment')}
                                            iconPath='/media/icons/duotune/chat-left-text-fill.svg'
                                            isLoading={isGetCommentLoading}
                                            onClick={() => {
                                              handleGetComment(item.amendment_orders[0]?.id, true)
                                            }}
                                          /> */}

                                          <ActionIcon
                                            className='s-1'
                                            hidden={item.is_new ? true : false}
                                            title={t('Chat')}
                                            iconPath='/media/icons/duotune/chat-dots-fill.svg'
                                            isLoading={isGetChatLoading}
                                            onClick={() => {
                                              setTempId(item.id)
                                              handleGetChat(item.id)
                                            }}
                                          />
                                          <ActionIcon
                                            onClick={() =>
                                              handleDeleteItems(_index, item.generatedId)
                                            }
                                            hidden={item.is_new ? false : true}
                                            title={t('Hapus')}
                                            iconPath='/media/icons/duotune/trash-fill.svg'
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item.amendment_orders[0]?.produsen?.name}</div>
                                      </td>
                                      {isRetail(item.amendment_orders[0]?.sector?.id) ? (
                                        <>
                                          {item.amendment_orders[0]?.incoterm2 == null ? (
                                            <td>
                                              <div>
                                                {item.amendment_orders[0]?.incoterm1?.code}-
                                                {item.amendment_orders[0]?.incoterm2_id}
                                              </div>
                                            </td>
                                          ) : (
                                            <td>
                                              <div>
                                                {item.amendment_orders[0]?.incoterm1?.code}-
                                                {item.amendment_orders[0]?.incoterm2?.code}
                                              </div>
                                            </td>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {item.amendment_orders[0]?.incoterm2 == null ? (
                                            <td>
                                              <div>
                                                {item.amendment_orders[0]?.incoterm1?.code}
                                                {item.amendment_orders[0]?.incoterm2_id == null ||
                                                item.amendment_orders[0]?.incoterm2_id == '0'
                                                  ? ''
                                                  : '-' + item.amendment_orders[0]?.incoterm2_id}
                                              </div>
                                            </td>
                                          ) : (
                                            <td>
                                              <div>
                                                {item.amendment_orders[0]?.incoterm1?.code}-
                                                {item.amendment_orders[0]?.incoterm2?.code}
                                              </div>
                                            </td>
                                          )}
                                        </>
                                      )}
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={
                                              item.amendment_orders[0]?.['province']?.region_name +
                                              (item.amendment_orders[0]?.['city']?.city_name
                                                ? ', ' +
                                                  item.amendment_orders[0]?.['city']?.city_name
                                                : '')
                                            }
                                            index={_index}
                                            className='spec-sliceee'
                                          />
                                        </div>
                                      </td>
                                      {sektorID == 1 && (
                                        <td>
                                          <div>{t(item.amendment_orders[0]?.segment_name)}</div>
                                        </td>
                                      )}
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={
                                              item?.end_user_multiple
                                                ? handleShowValue(
                                                    item?.end_user,
                                                    item?.end_user_multiple
                                                  )
                                                : item?.end_user
                                            }
                                            index={_index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item.amendment_orders[0]?.['product_type_desc']}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {item.amendment_orders[0]?.['material_number']?.slice(-7)}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item.amendment_orders[0]?.['product_name']}</div>
                                      </td>
                                      <td>
                                        {item.amendment_orders[0]?.['product_spec'] ? (
                                          <div>
                                            <PopoverText
                                              content={item.amendment_orders[0]?.['product_spec']}
                                              index={_index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        ) : (
                                          <label className=''>-</label>
                                        )}
                                      </td>
                                      <td>
                                        <div>
                                          {i18next.language === 'en'
                                            ? item.amendment_orders[0]?.[
                                                'request_quantum'
                                              ]?.toLocaleString('en', {maximumFractionDigits: 4})
                                            : item.amendment_orders[0]?.[
                                                'request_quantum'
                                              ]?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              })}{' '}
                                          {item.amendment_orders[0]?.sector_id === 3 ? 'MT' : 'Ton'}
                                        </div>
                                      </td>

                                      {!isRetail(sektorID) && (
                                        <td>
                                          {item.amendment_orders[0]?.['fixed_quantum'] ? (
                                            <div>
                                              {(![0,1,2,5,13].includes(item.status)) &&
                                              item.sales_id != null ? (
                                                <>
                                                  {i18next.language === 'en'
                                                    ? item.amendment_orders[0]?.[
                                                        'fixed_quantum'
                                                      ]?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : item.amendment_orders[0]?.[
                                                        'fixed_quantum'
                                                      ]?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })}{' '}
                                                  {item.amendment_orders[0]?.sector_id === 3
                                                    ? 'MT'
                                                    : 'Ton'}
                                                </>
                                              ) : (
                                                <label className=''>-</label>
                                              )}
                                            </div>
                                          ) : (
                                            <label className=''>-</label>
                                          )}
                                        </td>
                                      )}
                                      <td>
                                        <div>
                                          {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? item.amendment_orders[0]?.[
                                                  'request_price'
                                                ]?.toLocaleString('en', {maximumFractionDigits: 4})
                                              : item.amendment_orders[0]?.[
                                                  'request_price'
                                                ]?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                })) +
                                            (sektorID != 3 ? '/Ton' : '/MT')}
                                        </div>
                                      </td>

                                      {!isRetail(sektorID) && (
                                        <td>
                                          <div>
                                            {(![0,1,2,5,13].includes(item.status)) &&
                                            item.sales_id != null ? (
                                              <>
                                                {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                                  (i18next.language === 'en'
                                                    ? item.amendment_orders[0]?.[
                                                        'fixed_price'
                                                      ]?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : item.amendment_orders[0]?.[
                                                        'fixed_price'
                                                      ]?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })) +
                                                  (sektorID != 3 ? '/Ton' : '/MT')}
                                              </>
                                            ) : (
                                              <label className=''>-</label>
                                            )}
                                          </div>
                                        </td>
                                      )}
                                      {item.amendment_orders[0]?.sector_id == 1 && (
                                        <td>
                                          <div>
                                            {item.amendment_orders[0]?.include_ppn
                                              ? 'Include PPN'
                                              : 'Exclude PPN'}
                                          </div>
                                        </td>
                                      )}
                                      {isRetail(item.amendment_orders[0]?.sector_id) ? (
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={item.amendment_orders[0]?.['plant_desc']}
                                              index={_index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        ''
                                      )}
                                    </tr>
                                  )}
                                </>
                              ))}
                            </TableUI.TBody>
                          </>
                        ) : (
                          <>
                            {nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202' ? (
                              <>
                                <TableUI.THead>
                                  <tr style={{backgroundColor: '#274070'}}>
                                    <th hidden={numberRevised > 0 ? false : true}>{t('pilih')}</th>
                                    <th>{t('sub-order-item')}</th>
                                    <th>Status</th>
                                    <th>{t('order-aksi')}</th>
                                    <th>Sales Org</th>
                                    <th>{t('sub-order-incoterm')}</th>
                                    {sektorID != 3 ? <th>{t('sub-order-wilayah')}</th> : ''}
                                    <th>{t('End Customer')}</th>
                                    <th>{t('sub-order-jenis')}</th>
                                    <th>{t('Product Code')}</th>
                                    <th>{t('sub-order-produk')}</th>
                                    <th>{t('Kuantum Pengajuan')}</th>
                                    <th>{t('Kuantum PengajuanD')}</th>
                                    <th>{t('Harga Pengajuan')}</th>
                                    <th>{t('sub-order-hargaD')}</th>
                                    <th>Status {t('Price')}</th>
                                  </tr>
                                </TableUI.THead>
                                <TableUI.TBody>
                                  {detailOrder.map((item, _index) => (
                                    <tr
                                      key={item?.id ?? _index}
                                      className={
                                        !item.ischanged || (!item.is_new && numberRevised == 0)
                                          ? ''
                                          : 'bg-secondary'
                                      }
                                    >
                                      <td hidden={numberRevised > 0 ? false : true}>
                                        <div>
                                          <input
                                            className='form-check-input'
                                            type='checkbox'
                                            id={'checkbox' + _index}
                                            disabled={item.ischanged || item.is_new ? false : true}
                                            value={_index}
                                            onClick={() => onclickCheckBox2(_index)}
                                          />
                                          {/* <span>check 3</span> */}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{_index + 1}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {item['status_text'] == 'Pengajuan Amandemen' ||
                                          item['status_text'] == 'Amandemen' ||
                                          item['status_text'] == 'Diamandemen Customer' ||
                                          item['status_text'] == 'Telah Diamandemen' ||
                                          item['status_text'] ==
                                            'Menunggu Persetujuan Amandemen' ? (
                                            <span className='badge badge-light-info'>
                                              {t('Amandemen')}
                                            </span>
                                          ) : item['status'] == '0' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '1' ? (
                                            <span className='badge badge-light-primary'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '2' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '3' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '4' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '5' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '6' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '7' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : (
                                            <span className='badge badge-light-danger'>
                                              {t(item['status_text'])}
                                            </span>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <ActionIcon
                                          className='me-1'
                                          title='Detail'
                                          iconPath='/media/icons/duotune/file-text-fill.svg'
                                          onClick={() => {
                                            setisAmandment('false')
                                            setTempDetail(item)
                                            handleShow()
                                          }}
                                        />

                                        <ActionIcon
                                          className='me-1'
                                          title={t('order-lampiran')}
                                          iconPath='/media/icons/duotune/archive-fill.svg'
                                          isLoading={isGetAttachmentLoading}
                                          onClick={() => {
                                            setisAmandment('false')
                                            setSubOrderID(item.id)
                                            setParam(item.is_new_item ? 'amandemen' : 'order-item')
                                            setFileBox(item)
                                            setTemporaryIndex(_index)
                                            // setDownloadOnly(
                                            //   item.status == 2 || item.is_new ? false : true
                                            // )
                                            setDownloadOnly(false)
                                            if (item.status == 2 || item.is_new)
                                              handleShowAttachmentRevisi(
                                                item.id,
                                                item.status,
                                                item.is_new,
                                                item.attachments
                                              )
                                            else
                                              handleShow1(
                                                item.is_new_item ? 'amandemen' : 'order-item',
                                                item.id
                                              )
                                          }}
                                        />

                                        <ActionIcon
                                          className='me-1'
                                          hidden={
                                            (item.status == 2 || item.is_new) &&
                                            item.is_new_item != true
                                              ? false
                                              : true
                                          }
                                          title={t('ubah')}
                                          iconPath='/media/icons/duotune/pencil-fill.svg'
                                          onClick={() => {
                                            setisAmandment('false')
                                            setTempData(item)
                                            setTempEdit(item)
                                            setStatusItem(item.is_new ? 2 : item.status)
                                            setTemporaryIndex(_index)
                                            setSubID(item.id)
                                            handleEdit(item)
                                            setSubSektorID(item.sector?.id)
                                            setState(item, 'edit')
                                          }}
                                        />

                                        <ActionIcon
                                          title={t('Comment')}
                                          iconPath='/media/icons/duotune/chat-left-text-fill.svg'
                                          isLoading={isGetCommentLoading}
                                          onClick={() => {
                                            handleGetComment(item.id, false)
                                          }}
                                        />

                                        <ActionIcon
                                          className='ms-1'
                                          title={t('Chat')}
                                          iconPath='/media/icons/duotune/chat-dots-fill.svg'
                                          hidden={item.is_new ? true : false}
                                          isLoading={isGetChatLoading}
                                          onClick={() => {
                                            setTempId(item.id)
                                            handleGetChat(item.id)
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <div>{item.produsen?.name}</div>
                                      </td>
                                      <td className='td-order-2 text-center column'>
                                        <div>{item.incoterm1?.code}</div>
                                      </td>
                                      {sektorID != 3 ? (
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                item['province']?.region_name +
                                                ', ' +
                                                item['city']?.city_name
                                              }
                                              index={_index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        ''
                                      )}
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={
                                              item?.end_user_multiple
                                                ? handleShowValue(
                                                    item?.end_user,
                                                    item?.end_user_multiple
                                                  )
                                                : item?.end_user
                                            }
                                            index={_index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>{t(item['product_type_desc'])}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {parseInt(item.material_number) == 0 ? (
                                            <label className=''>-</label>
                                          ) : (
                                            item['material_number']?.slice(-7)
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item['product_name']}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {i18next.language === 'en'
                                            ? item.request_quantum?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : item.request_quantum?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              })}{' '}
                                          {item.sector_id === 3 ? 'MT' : 'Ton'}
                                        </div>
                                      </td>
                                      <td>
                                        {item['fixed_quantum'] ? (
                                          <div>
                                            {(![0,1,2,5,13].includes(item.status)) ? (
                                              <>
                                                {i18next.language === 'en'
                                                  ? item['fixed_quantum']?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : item['fixed_quantum']?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })}{' '}
                                                {item.sector_id === 3 ? 'MT' : 'Ton'}
                                              </>
                                            ) : (
                                              <label className=''>-</label>
                                            )}
                                          </div>
                                        ) : (
                                          <label className=''>-</label>
                                        )}
                                      </td>
                                      <td>
                                        <div>
                                          {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? item.request_price?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : item.request_price?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                })) +
                                            (sektorID != 3 ? '/Ton' : '/MT')}
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {(![0,1,2,5,13].includes(item.status)) ? (
                                            <>
                                              {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                                (i18next.language === 'en'
                                                  ? item['fixed_price']?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : item['fixed_price']?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })) +
                                                (sektorID != 3 ? '/Ton' : '/MT')}
                                            </>
                                          ) : (
                                            <label className=''>-</label>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </TableUI.TBody>
                              </>
                            ) : (
                              <>
                                <TableUI.THead>
                                  <tr style={{backgroundColor: '#274070'}}>
                                    <th hidden={numberRevised > 0 ? false : true}>{t('pilih')}</th>
                                    <th>{t('sub-order-item')}</th>
                                    <th>Status</th>
                                    <th>{t('order-aksi')}</th>
                                    <th>Sales Org</th>
                                    <th>{t('sub-order-jenis')}</th>
                                    <th>{t('Product Code')}</th>
                                    <th>{t('sub-order-produk')}</th>
                                  </tr>
                                </TableUI.THead>
                                <TableUI.TBody>
                                  {detailOrder.map((item, _index) => (
                                    <tr
                                      key={item?.id ?? _index}
                                      className={
                                        !item.ischanged || (!item.is_new && numberRevised == 0)
                                          ? ''
                                          : 'bg-secondary'
                                      }
                                    >
                                      <td hidden={numberRevised > 0 ? false : true}>
                                        <div>
                                          <input
                                            className='form-check-input'
                                            type='checkbox'
                                            id={'checkbox' + _index}
                                            disabled={item.ischanged || item.is_new ? false : true}
                                            value={_index}
                                            onClick={() => onclickCheckBox2(_index)}
                                          />
                                          {/* <span>check 4</span> */}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{_index + 1}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {item['status_text'] == 'Pengajuan Amandemen' ||
                                          item['status_text'] == 'Amandemen' ||
                                          item['status_text'] == 'Diamandemen Customer' ||
                                          item['status_text'] == 'Telah Diamandemen' ||
                                          item['status_text'] ==
                                            'Menunggu Persetujuan Amandemen' ? (
                                            <span className='badge badge-light-info'>
                                              {t('Amandemen')}
                                            </span>
                                          ) : item['status'] == '0' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '1' ? (
                                            <span className='badge badge-light-primary'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '2' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '3' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '4' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '5' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '6' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '7' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : (
                                            <span className='badge badge-light-danger'>
                                              {t(item['status_text'])}
                                            </span>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <ActionIcon
                                          className='me-1'
                                          title='Detail'
                                          iconPath='/media/icons/duotune/file-text-fill.svg'
                                          onClick={() => {
                                            setisAmandment('false')
                                            setTempDetail(item)
                                            handleShow()
                                          }}
                                        />

                                        <ActionIcon
                                          className='me-1'
                                          title={t('order-lampiran')}
                                          iconPath='/media/icons/duotune/archive-fill.svg'
                                          isLoading={isGetAttachmentLoading}
                                          onClick={() => {
                                            setisAmandment('false')
                                            setSubOrderID(item.id)
                                            setParam(item.is_new_item ? 'amandemen' : 'order-item')
                                            setFileBox(item)
                                            setTemporaryIndex(_index)
                                            // setDownloadOnly(
                                            //   item.status == 2 || item.is_new ? false : true
                                            // )
                                            setDownloadOnly(false)
                                            if (item.status == 2 || item.is_new)
                                              handleShowAttachmentRevisi(
                                                item.id,
                                                item.status,
                                                item.is_new,
                                                item.attachments
                                              )
                                            else
                                              handleShow1(
                                                item.is_new_item ? 'amandemen' : 'order-item',
                                                item.id
                                              )
                                          }}
                                        />

                                        <ActionIcon
                                          className='me-1'
                                          hidden={
                                            (item.status == 2 || item.is_new) &&
                                            item.is_new_item != true
                                              ? false
                                              : true
                                          }
                                          title={t('ubah')}
                                          iconPath='/media/icons/duotune/pencil-fill.svg'
                                          onClick={() => {
                                            setisAmandment('false')
                                            setTempData(item)
                                            setTempEdit(item)
                                            setStatusItem(item.is_new ? 2 : item.status)
                                            setTemporaryIndex(_index)
                                            setSubID(item.id)
                                            handleEdit(item)
                                            setSubSektorID(item.sector?.id)
                                            setState(item, 'edit')
                                          }}
                                        />

                                        <ActionIcon
                                          title={t('Comment')}
                                          iconPath='/media/icons/duotune/chat-left-text-fill.svg'
                                          isLoading={isGetCommentLoading}
                                          onClick={() => {
                                            handleGetComment(item.id, false)
                                          }}
                                        />
                                        <ActionIcon
                                          className='ms-1'
                                          title={t('Chat')}
                                          iconPath='/media/icons/duotune/chat-dots-fill.svg'
                                          isLoading={isGetChatLoading}
                                          onClick={() => {
                                            setTempId(item.id)
                                            handleGetChat(item.id)
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <div>{item.produsen?.name}</div>
                                      </td>
                                      <td>
                                        <div>{t(item['product_type_desc'])}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {parseInt(item.material_number) == 0 ? (
                                            <label className=''>-</label>
                                          ) : (
                                            item['material_number']?.slice(-7)
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item['product_name']}</div>
                                      </td>
                                    </tr>
                                  ))}
                                </TableUI.TBody>
                              </>
                            )}
                          </>
                        )}
                      </TableUI.Table>
                    </TableUI.TableWrapper>
                  </TableUI.TableDetail>
                  {/* End Table Head */}
                </div>

                <div className='d-flex justify-content-end my-5'>
                  <Link to='/management/order/all' className='me-2'>
                    <Button className='btn btn-secondary'>
                      {btnCancel ? t('cancel') : t('order-kembali')}
                    </Button>
                  </Link>
                  <div className='me-2' hidden={indexItem.length == 0 ? true : false}>
                    <Button onClick={() => postEdit()} className='btn btn-primary'>
                      {btnLoading ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : isRetail(sektorID) ? (
                        t('Submit')
                      ) : (
                        t('Submit') + ' ' + t('Order')
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-body'>
                <Row>
                  <Col md={6}>
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4'>{t('order-perihal')}</p>
                      </Col>
                      <Col lg={7} key={nonSalesRegardingLabel}>
                        {regarding == 'PO002' ? (
                          <Form.Control
                            value={t('Non-penjualan') + ' - ' + t(nonSalesRegardingLabel)}
                            disabled
                            size='sm'
                          />
                        ) : (
                          <Form.Control value={t('penjualan')} disabled size='sm' />
                        )}
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control type='text' value={customerName} disabled size='sm' />
                      </Col>
                    </Row>

                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                      </Col>
                      <Col lg={7}>
                        <Form.Control type='text' value={customerCode} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4'>{t('order-lampiran')}</p>
                      </Col>
                      <Col lg={7}>
                        <Button
                          variant='primary'
                          onClick={() => {
                            setisAmandment('false')
                            handleShow1('header', params.id)
                            setParam('header')
                            roleUser == 'admin' ? setDownloadOnly(true) : setDownloadOnly(false)
                          }}
                        >
                          {t('order-lampiran')}
                        </Button>
                      </Col>
                    </Row>
                    {regarding == 'PO002' && roleUser == 'salesAdmin' ? (
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4'>{t('order-lampiran')} Order Items</p>
                        </Col>
                        <Col lg={7}>
                          <Button
                            variant='primary'
                            onClick={() => {
                              getAllFileOrder(ID)
                            }}
                          >
                            {t('order-lampiran')}
                          </Button>
                        </Col>
                      </Row>
                    ) : (
                      ''
                    )}
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4'>{t('Customer Support Data')}</p>
                      </Col>
                      <Col lg={7}>
                        <div className='d-flex align-items-center'>
                          <Button
                            className='btn btn-primary'
                            disabled={btnProfile}
                            onClick={() => handleProfileCustomer()}
                          >
                            {btnProfile ? (
                              <Spinner animation='border' variant='light' size='sm' />
                            ) : (
                              <>{t('order-lihat')}</>
                            )}
                          </Button>
                          {/* {customerName == 'AFIAH' && detailOrder[0].payment_type_1_desc == 'Credit Payment' ? (
                        <Button className='btn btn-warning' onClick={() => handleShow2()}>
                          {t('order-lihat')}
                        </Button>
                      ) : customerName == 'BINA SEJAHTERA' && detailOrder[0].payment_type_1_desc == 'Credit Payment' ? (
                        <Button className='btn btn-success' onClick={() => handleShow2()}>
                          {t('order-lihat')}
                        </Button>
                      ) : customerName == 'AGRO BOKASHINDO JAYA' && detailOrder[0].payment_type_1_desc == 'L/C at Sight' ? (
                        <Button className='btn btn-danger' onClick={() => handleShow2()}>
                          {t('order-lihat')}
                        </Button>
                      ) : customerName == 'ABK MITRA MANDIRI' && detailOrder[0].payment_type_1_desc == 'L/C at Sight' ? (
                        <Button className='btn btn-dark' onClick={() => handleShow2()}>
                          {t('order-lihat')}
                        </Button>
                      ) : (
                        <Button className='btn btn-primary' onClick={() => handleProfileCustomer()}>
                          {t('order-lihat')}
                        </Button>
                      )} */}
                        </div>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4'>{t('order-reqHarga')}</p>
                      </Col>
                      <Col lg={7}>
                        <Button className='btn btn-primary' disabled>
                          {t('order-lihat')}
                        </Button>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4'>{t('order-cekStock')}</p>
                      </Col>
                      <Col lg={7}>
                        <Button variant='primary' onClick={() => handleStock()}>
                          {btnStock ? (
                            <Spinner animation='border' variant='light' size='sm' />
                          ) : (
                            <>{t('order-lihat')}</>
                          )}
                        </Button>

                        <ShowStock show={showStock} setShow={setShowStock} loading={btnStock} reload={loadDetailStock} datas={allStock}/>
                        
                      </Col>
                    </Row>

                    { regarding == 'PO001' && showChatHistory && <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4'>{t('chat-history')}</p>
                      </Col>
                      <Col lg={7}>
                        <Button onClick={redirectToChatHistory} className='btn btn-primary'>
                          {t('order-lihat')}
                        </Button>
                      </Col>
                    </Row> }
                  </Col>
                  <Col md={6}>
                    <Row className='mb-3'>
                      <Col lg={4}>
                        <p className='fs-4 mt-2'>{t('Order Number')}</p>
                      </Col>
                      <Col lg={8}>
                        <Form.Control
                          type='text'
                          value={orderNumber == '' ? '' : '10' + orderNumber}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>

                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Address')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control as='textarea' value={customerAddress} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Phone Number')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control value={phoneNumber} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Email')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control value={emailCust} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('PIC Customer')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control value={PICCust} disabled size='sm' />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {regarding == 'PO001' && !isRetail(sektorID) && buttonAdd && hakAkses?.update && (
                  <>
                    <div className='my-5'>
                      <Button
                        className='btn btn-primary me-2'
                        disabled={disableAdd}
                        onClick={() => handleClickAddProduct(sektorID)}
                        style={{width: `${disableAdd ? '130px' : ''}`}}
                      >
                        {disableAdd ? (
                          <Spinner animation='border' variant='light' size='sm' />
                        ) : (
                          t('+tambah product')
                        )}
                      </Button>
                    </div>
                  </>
                )}

                <div className='table-responsive bdr'>
                  {/* Table Head */}
                  <TableUI.TableDetail colSpan={14}>
                    <TableUI.TableWrapper style={{marginBottom: 0}}>
                      <TableUI.Table>
                        {showPurchaseForm ? (
                          <>
                            <TableUI.THead>
                              <tr style={{backgroundColor: '#274070'}}>
                                {hakAkses?.approve ? <th>{t('pilih')}</th> : ''}
                                <th>{t('sub-order-item')}</th>
                                <th>Status</th>
                                <th>{t('order-aksi')}</th>
                                <th>Sales Org</th>
                                <th>{t('sub-order-incoterm')}</th>
                                <th>{t('sub-order-wilayah')}</th>
                                {sektorID == 1 ? <th>{t('segment')}</th> : ''}
                                <th>{t('End Customer')}</th>
                                <th>{t('sub-order-jenis')}</th>
                                <th>{t('Product Code')}</th>
                                <th>{t('sub-order-produk')}</th>
                                <th>{t('sub-order-spek')}</th>
                                <th>{t('Kuantum Pengajuan')}</th>
                                {!isRetail(sektorID) && <th>{t('Kuantum PengajuanD')}</th>}
                                <th>{t('Harga Pengajuan')}</th>
                                {!isRetail(sektorID) && <th>{t('sub-order-hargaD')}</th>}
                                {sektorID == 1 ? <th>Status {t('Price')}</th> : ''}
                                {isRetail(sektorID) ? <th>{t('sub-order-gudang')}</th> : ''}
                              </tr>
                            </TableUI.THead>
                            <TableUI.TBody>
                              {detailOrder.map((item, _index) => (
                                <>
                                  {isRetail(item.sector_id) ? (
                                    <>
                                      <tr key={item?.id ?? _index}>
                                        {hakAkses?.approve && (
                                          <td>
                                            <input
                                              className='form-check-input'
                                              type='checkbox'
                                              id={'checkbox' + _index}
                                              disabled={!item?.have_action || ![0,1].includes(item?.status)}
                                              value={item.id || `Uid${item.generatedId}` + '~#~' + _index}
                                              onClick={() => onclickCheckBox(_index)}
                                            />
                                          </td>
                                        )}

                                        <td>
                                          <div>{_index + 1}</div>
                                        </td>
                                        <td>
                                          <div>
                                            {item['status_text'] == 'Pengajuan Amandemen' ||
                                            item['status_text'] == 'Amandemen' ||
                                            item['status_text'] == 'Diamandemen Customer' ||
                                            item['status_text'] == 'Telah Diamandemen' ||
                                            item['status_text'] ==
                                              'Menunggu Persetujuan Amandemen' ? (
                                              <span className='badge badge-light-info'>
                                                {t('Amandemen')}
                                              </span>
                                            ) : item['status'] == '0' ? (
                                              <span className='badge badge-light-success'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '1' && item.is_new ? (
                                              <label className=''>-</label>
                                            ) : item['status'] == '1' ? (
                                              <span className='badge badge-light-primary'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '2' ? (
                                              <span className='badge badge-light-warning'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '3' ? (
                                              <span className='badge badge-light-warning'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '4' ? (
                                              <span className='badge badge-light-success'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '5' ? (
                                              <span className='badge badge-light-success'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '6' ? (
                                              <span className='badge badge-light-success'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '7' ? (
                                              <span className='badge badge-light-success'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : (
                                              <span className='badge badge-light-danger'>
                                                {t(item['status_text'])}
                                              </span>
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            <ActionIcon
                                              className='me-1'
                                              title='Detail'
                                              hasWarning={(!item.request_price) && [0,1].includes(item.status)}
                                              iconPath='/media/icons/duotune/file-text-fill.svg'
                                              onClick={() => {
                                                setisAmandment('false')
                                                setTempDetail(item)
                                                setIdxDetail(_index)
                                                setSubpriceApp(item.request_price)
                                                handleShow()
                                              }}
                                            />
                                            <ActionIcon
                                              className='me-1'
                                              title={t('order-lampiran')}
                                              iconPath='/media/icons/duotune/archive-fill.svg'
                                              isLoading={isGetAttachmentLoading}
                                              onClick={() => {
                                                setisAmandment('false')
                                                handleShow1(
                                                  item.is_new_item ? 'amandemen' : 'order-item',
                                                  item.id
                                                )
                                                setSubOrderID(item.id)
                                                setParam(
                                                  item.is_new_item ? 'amandemen' : 'order-item'
                                                )
                                                setFileBox(item)
                                                setStatusAmandemen(item.status_text)
                                                roleUser == 'admin'
                                                  ? setDownloadOnly(true)
                                                  : setDownloadOnly(false)
                                              }}
                                            />
                                            <ActionIcon
                                              className='me-1'
                                              title={t('Jadwal')}
                                              iconPath='/media/icons/duotune/calendar-check-fill.svg'
                                              onClick={() => {
                                                setSektorID(item.sector_id)
                                                item['status_text'] == 'Pengajuan Amandemen' ||
                                                item['status_text'] == 'Amandemen' ||
                                                item['status_text'] == 'Diamandemen Customer' ||
                                                item['status_text'] == 'Telah Diamandemen' ||
                                                item['status_text'] ==
                                                  'Menunggu Persetujuan Amandemen'
                                                  ? setIsDisable(true)
                                                  : setIsDisable(false)
                                                setProvinceDesc(item.province?.region_name)
                                                setCityDesc(item.city?.city_name)
                                                setPname(item.product_name)
                                                formattingTon(item.fixed_quantum)
                                                setisAmandment(item.is_new_item ? 'true' : 'false')
                                                setSubOrderID(item.id)
                                                if (item.is_new_item)
                                                  handleShowJadwalAmandemen(0, item.id)
                                                else handleShow3(item['id'])
                                                setTemporaryIndex(_index)
                                              }}
                                            />

                                            {item.status == 5 &&
                                            item.sales_id == localStorage.getItem('user-id') ? (
                                              <button
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                data-bs-toggle='tooltip'
                                                data-bs-placement='top'
                                                data-bs-trigger='hover'
                                                title={t('ke_nego')}
                                                onClick={() => {
                                                  toNego(item['id'], orderNumber)
                                                }}
                                              >
                                                <KTSVG
                                                  path='/media/icons/duotune/handshake.svg'
                                                  className='svg-icon-3'
                                                />
                                              </button>
                                            ) : (
                                              <></>
                                            )}
                                            <ActionIcon
                                              title={t('Comment')}
                                              iconPath='/media/icons/duotune/chat-left-text-fill.svg'
                                              isLoading={isGetCommentLoading}
                                              onClick={() => {
                                                handleGetComment(item.id, false)
                                              }}
                                            />
                                            {item.is_new ? (
                                              <></>
                                            ) : (
                                              <ActionIcon
                                                className='ms-1'
                                                disabled={
                                                  revisiIndex != 0
                                                    ? revisiIndex == _index + 1
                                                      ? false
                                                      : true
                                                    : false
                                                }
                                                title={t('Chat')}
                                                iconPath='/media/icons/duotune/chat-dots-fill.svg'
                                                isLoading={isGetChatLoading}
                                                onClick={() => {
                                                  setTempId(item.id)
                                                  handleGetChat(item.id)
                                                }}
                                              />
                                            )}

                                            {/* <button
                                hidden={
                                  indexItem.find((element) => element == _index) == _index
                                    ? false
                                    : true
                                }
                                onClick={() => {
                                  setShowReason(true)
                                  setReason(item.reason)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('notes')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/chat-left-text-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button> */}
                                            {/* {roleUser == 'salesAdmin' && item.status == 5 ? (
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              onClick={() => {
                                setID(item['id'])
                                setShowUpdate(true)
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/pencil-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            ) : (
                              <></>
                            )} */}
                                          </div>
                                        </td>
                                        <td>
                                          <div>{item.produsen?.name}</div>
                                        </td>
                                        {isRetail(item.sector?.id) ? (
                                          <>
                                            {item.incoterm2 == null ? (
                                              <td>
                                                <div>
                                                  {item.incoterm1?.code}-{item.incoterm2_id}
                                                </div>
                                              </td>
                                            ) : (
                                              <td>
                                                <div>
                                                  {item.incoterm1?.code}-{item.incoterm2?.code}
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {item.incoterm2 == null ? (
                                              <td>
                                                <div>
                                                  {item.incoterm2_id == null ||
                                                  item.incoterm2_id == '0' ||
                                                  item.incoterm2_id == ''
                                                    ? ''
                                                    : '-' + item.incoterm2_id}
                                                </div>
                                              </td>
                                            ) : (
                                              <td>
                                                <div>
                                                  {item.incoterm1?.code}-{item.incoterm2?.code}
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        )}
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                item['province']?.region_name +
                                                (item['city']?.city_name
                                                  ? ', ' + item['city']?.city_name
                                                  : '')
                                              }
                                              index={_index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                        {sektorID == 1 && (
                                          <td>
                                            <div>{t(item.segment_name)}</div>
                                          </td>
                                        )}
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                item?.end_user_multiple
                                                  ? handleShowValue(
                                                      item?.end_user,
                                                      item?.end_user_multiple
                                                    )
                                                  : item?.end_user
                                              }
                                              index={_index}
                                              className='desc-slicee'
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div>{item['product_type_desc']}</div>
                                        </td>
                                        <td>
                                          <div>
                                            {parseInt(item.material_number) == 0 ? (
                                              <label className=''>-</label>
                                            ) : (
                                              item['material_number']?.slice(-7)
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          <div>{item['product_name']}</div>
                                        </td>
                                        <td>
                                          {item['product_spec'] ? (
                                            <div>
                                              <PopoverText
                                                content={item['product_spec']}
                                                index={_index}
                                                className='spec-sliceee'
                                              />
                                            </div>
                                          ) : (
                                            <label className=''>-</label>
                                          )}
                                        </td>
                                        <td>
                                          <div>
                                            {i18next.language === 'en'
                                              ? item['request_quantum']?.toLocaleString('en', {
                                                  maximumFractionDigits: 4,
                                                })
                                              : item['request_quantum']?.toLocaleString('id', {
                                                  maximumFractionDigits: 4,
                                                })}{' '}
                                            {item.sector_id === 3 ? 'MT' : 'Ton'}
                                          </div>
                                        </td>
                                        {!isRetail(sektorID) && (
                                          <td>
                                            {item['fixed_quantum'] ? (
                                              <div>
                                                {(![0,1,2,5,13].includes(item.status)) &&
                                                item.sales_id != null ? (
                                                  <>
                                                    {i18next.language === 'en'
                                                      ? item['fixed_quantum']?.toLocaleString(
                                                          'en',
                                                          {
                                                            maximumFractionDigits: 4,
                                                          }
                                                        )
                                                      : item['fixed_quantum']?.toLocaleString(
                                                          'id',
                                                          {
                                                            maximumFractionDigits: 4,
                                                          }
                                                        )}{' '}
                                                    {item.sector_id === 3 ? 'MT' : 'Ton'}
                                                  </>
                                                ) : (
                                                  <label className=''>-</label>
                                                )}
                                              </div>
                                            ) : (
                                              <label className=''>-</label>
                                            )}
                                          </td>
                                        )}
                                        <td>
                                          <div>
                                            {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                              (i18next.language === 'en'
                                                ? item['request_price']?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                  })
                                                : item['request_price']?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                  })) +
                                              (sektorID != 3 ? '/Ton' : '/MT')}
                                          </div>
                                        </td>
                                        {!isRetail(sektorID) && (
                                          <td>
                                            <div>
                                              {(![0,1,2,5,13].includes(item.status)) &&
                                              item.sales_id != null ? (
                                                <>
                                                  {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                                    (i18next.language === 'en'
                                                      ? item['fixed_price']?.toLocaleString('en', {
                                                          maximumFractionDigits: 4,
                                                        })
                                                      : item['fixed_price']?.toLocaleString('id', {
                                                          maximumFractionDigits: 4,
                                                        })) +
                                                    (sektorID != 3 ? '/Ton' : '/MT')}
                                                </>
                                              ) : (
                                                <label className=''>-</label>
                                              )}
                                            </div>
                                          </td>
                                        )}
                                        {isRetail(item.sector_id) ? (
                                          <td>
                                            <div>{item['plant'] + ' - ' + item['plant_desc']}</div>
                                          </td>
                                        ) : (
                                          ''
                                        )}
                                      </tr>
                                    </>
                                  ) : (
                                    <>
                                      <tr key={item?.id ?? _index}>
                                        {hakAkses?.approve && (
                                          <td>
                                            <input
                                              className='form-check-input'
                                              type='checkbox'
                                              id={'checkbox' + _index}
                                              value={item.id || `Uid${item.generatedId}` + '~#~' + _index}
                                              disabled={(!item?.have_action && item.id) || !UserSegment(item?.segment_code) || ![0,1].includes(item?.status)}
                                              onClick={() => onclickCheckBox(_index)}
                                            />
                                          </td>
                                        )}

                                        <td>
                                          <div>{_index + 1}</div>
                                        </td>
                                        <td>
                                          <div>
                                            {item['status_text'] == 'Pengajuan Amandemen' ||
                                            item['status_text'] == 'Amandemen' ||
                                            item['status_text'] == 'Telah Diamandemen' ||
                                            item['status_text'] ==
                                              'Menunggu Persetujuan Amandemen' ? (
                                              <span className='badge badge-light-info'>
                                                {t('Amandemen')}
                                              </span>
                                            ) : item['status'] == '0' ? (
                                              <span className='badge badge-light-success'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '1' && item.is_new ? (
                                              <label className=''>-</label>
                                            ) : item['status'] == '1' ? (
                                              <span className='badge badge-light-primary'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '2' ? (
                                              <span className='badge badge-light-warning'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '3' ? (
                                              <span className='badge badge-light-warning'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '4' ? (
                                              <span className='badge badge-light-success'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '5' ? (
                                              <span className='badge badge-light-success'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '6' ? (
                                              <span className='badge badge-light-success'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : item['status'] == '7' ? (
                                              <span className='badge badge-light-success'>
                                                {t(item['status_text'])}
                                              </span>
                                            ) : (
                                              <span className='badge badge-light-danger'>
                                                {t(item['status_text'])}
                                              </span>
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            <ActionIcon
                                              className='me-1'
                                              title='Detail'
                                              iconPath='/media/icons/duotune/file-text-fill.svg'
                                              disabled={loadDetail}
                                              onClick={() => {
                                                setisAmandment('false')
                                                setTempDetail(item)
                                                if (roleUser == 'salesAdmin') {
                                                  setState(item, 'app')
                                                }
                                                setIdxDetail(_index)
                                                productTypeDetail = item.product_type
                                                produsenDetail = item.produsen?.code
                                                regionDetail = item.province?.id
                                                handleDetailClick(item.sector_id)
                                              }}
                                            />
                                            {!item.is_new && (
                                              <ActionIcon
                                                className='me-1'
                                                title={t('order-lampiran')}
                                                iconPath='/media/icons/duotune/archive-fill.svg'
                                                isLoading={isGetAttachmentLoading}
                                                onClick={() => {
                                                  setisAmandment(item.is_amendment ? 'true' : 'false')
                                                  handleShow1(
                                                    item.is_amendment ? 'amandemen' : 'order-item',
                                                    item.id
                                                  )
                                                  setSubOrderID(item.id)
                                                  setParam(
                                                    item.is_amendment ? 'amandemen' : 'order-item'
                                                  )
                                                  setFileBox(item)
                                                  setStatusAmandemen(item.status_text)
                                                  roleUser == 'admin'
                                                    ? setDownloadOnly(true)
                                                    : setDownloadOnly(false)
                                                  ambilAttachment(item.is_amendment ? 'amandemen' : 'order-item', item.id)
                                                }}
                                              />
                                            )}
                                            {item.is_new && (
                                              <ActionIcon
                                                className='me-1'
                                                title={t('order-lampiran')}
                                                iconPath='/media/icons/duotune/archive-fill.svg'
                                                isLoading={isGetAttachmentLoading}
                                                onClick={() => {
                                                  removeFileState()
                                                  setTempData(item)
                                                  setIndexAttac(_index)
                                                  setShowAttac(true)
                                                  setFileBox(item)
                                                }}
                                              />
                                            )}

                                            {item.is_new ? (
                                              <ActionIcon
                                                className='me-1'
                                                title={t('tambah_jadwal')}
                                                iconPath='/media/icons/duotune/calendar-check-fill.svg'
                                                onClick={() => {
                                                  formattingTon(item.request_quantum)
                                                  setSektorID(item.sector_id)
                                                  setProvinceDesc(item.province_desc)
                                                  setCityDesc(item.city_desc)
                                                  setPname(item.product_name)
                                                  setIndex2(_index)
                                                  handleJadwal(item)
                                                  setTemporaryIndex(_index)
                                                }}
                                              />
                                            ) : (
                                              <ActionIcon
                                                className='me-1'
                                                title={t('Jadwal')}
                                                iconPath='/media/icons/duotune/calendar-check-fill.svg'
                                                onClick={() => {
                                                  setSektorID(item.sector_id)
                                                  item['status_text'] == 'Pengajuan Amandemen' ||
                                                  item['status_text'] == 'Amandemen' ||
                                                  item['status_text'] == 'Diamandemen Customer' ||
                                                  item['status_text'] == 'Telah Diamandemen' ||
                                                  item['status_text'] ==
                                                    'Menunggu Persetujuan Amandemen'
                                                    ? setIsDisable(true)
                                                    : setIsDisable(false)
                                                  setProvinceDesc(item.province?.region_name)
                                                  setTemporaryIndex(_index)
                                                  setCityDesc(item.city?.city_name)
                                                  setPname(item.product_name)
                                                  formattingTon(item.fixed_quantum)
                                                  setisAmandment(
                                                    item.is_new_item ? 'true' : 'false'
                                                  )
                                                  setSubOrderID(item.id)
                                                  if (item.is_new_item)
                                                    handleShowJadwalAmandemen(0, item.id)
                                                  else handleShow3(item['id'])
                                                }}
                                              />
                                            )}
                                            {item.is_new && (
                                              <ActionIcon
                                                title={t('Hapus')}
                                                iconPath='/media/icons/duotune/trash-fill.svg'
                                                onClick={() =>
                                                  handleDeleteItems(_index, item.generatedId)
                                                }
                                              />
                                            )}

                                            {item.status == 5 &&
                                            item.sales_id == localStorage.getItem('user-id') ? (
                                              <button
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                data-bs-toggle='tooltip'
                                                data-bs-placement='top'
                                                data-bs-trigger='hover'
                                                title={t('ke_nego')}
                                                onClick={() => {
                                                  toNego(item['id'], orderNumber)
                                                }}
                                              >
                                                <KTSVG
                                                  path='/media/icons/duotune/handshake.svg'
                                                  className='svg-icon-3'
                                                />
                                              </button>
                                            ) : (
                                              <></>
                                            )}
                                            {item.is_new ? (
                                              <></>
                                            ) : (
                                              <ActionIcon
                                                title={t('Comment')}
                                                iconPath='/media/icons/duotune/chat-left-text-fill.svg'
                                                isLoading={isGetCommentLoading}
                                                onClick={() => {
                                                  handleGetComment(item.id, false)
                                                }}
                                              />
                                            )}
                                            {(
                                              (item.status == 3 || item.status == 5 || item.status == 6)) && hakAkses?.approve ? (
                                              <button
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1'
                                                data-bs-toggle='tooltip'
                                                data-bs-placement='top'
                                                data-bs-trigger='hover'
                                                title={t('Rollback Ke') + ' ' + t('Order')}
                                                onClick={() => {
                                                  rollback(item['id'])
                                                }}
                                              >
                                                <KTSVG
                                                  path='/media/icons/duotune/arrow-clockwise.svg'
                                                  className='svg-icon-3'
                                                />
                                              </button>
                                            ) : (
                                              <></>
                                            )}

                                            {item.is_new ? (
                                              <></>
                                            ) : (
                                              <ActionIcon
                                                className='ms-1'
                                                title={t('Chat')}
                                                iconPath='/media/icons/duotune/chat-dots-fill.svg'
                                                isLoading={isGetChatLoading}
                                                onClick={() => {
                                                  setTempId(item.id)
                                                  handleGetChat(item.id)
                                                }}
                                              />
                                            )}

                                            {/* <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Hapus')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/trash-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button> */}

                                            {/* <button
                                hidden={
                                  indexItem.find((element) => element == _index) == _index
                                    ? false
                                    : true
                                }
                                onClick={() => {
                                  setShowReason(true)
                                  setReason(item.reason)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('notes')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/chat-left-text-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button> */}
                                            {/* {roleUser == 'salesAdmin' && item.status == 5 ? (
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              onClick={() => {
                                setID(item['id'])
                                setShowUpdate(true)
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/pencil-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          ) : (
                            <></>
                          )} */}
                                          </div>
                                        </td>
                                        <td>
                                          <div>{item.produsen?.name}</div>
                                        </td>
                                        {isRetail(item.sector?.id) ? (
                                          <>
                                            {item.incoterm2 == null ? (
                                              <td>
                                                <div>
                                                  {item.incoterm1?.code}-{item.incoterm2_id}
                                                </div>
                                              </td>
                                            ) : (
                                              <td>
                                                <div>
                                                  {item.incoterm1?.code}-{item.incoterm2?.code}
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {item.incoterm2 == null ? (
                                              <td>
                                                <div>
                                                  {item.incoterm1?.code}
                                                  {item.incoterm2_id == null ||
                                                  item.incoterm2_id == '0' ||
                                                  item.incoterm2_id == ''
                                                    ? ''
                                                    : '-' + item.incoterm2_id}
                                                </div>
                                              </td>
                                            ) : (
                                              <td>
                                                <div>
                                                  {item.incoterm1?.code}
                                                  {item.incoterm2?.code
                                                    ? '-' + item.incoterm2?.code
                                                    : ''}
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        )}
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                item['province']?.region_name +
                                                (item['city']?.city_name
                                                  ? ', ' + item['city']?.city_name
                                                  : '')
                                              }
                                              index={_index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                        {sektorID == 1 && (
                                          <td>
                                            <div>{t(item.segment_name)}</div>
                                          </td>
                                        )}
                                        <td>
                                          <PopoverText
                                            content={
                                              item?.end_user_multiple
                                                ? handleShowValue(
                                                    item?.end_user,
                                                    item?.end_user_multiple
                                                  )
                                                : item?.end_user
                                            }
                                            index={_index}
                                            className='desc-slicee'
                                          />
                                        </td>
                                        <td>
                                          <div>{t(item['product_type_desc'])}</div>
                                        </td>
                                        <td>
                                          <div>
                                            {parseInt(item.material_number) == 0 ? (
                                              <label className=''>-</label>
                                            ) : (
                                              item['material_number']?.slice(-7)
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          <div>{item['product_name']}</div>
                                        </td>
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                item['product_spec'] ? item['product_spec'] : '-'
                                              }
                                              index={_index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            {i18next.language === 'en'
                                              ? parseFloat(item['request_quantum'])?.toLocaleString(
                                                  'en',
                                                  {
                                                    maximumFractionDigits: 4,
                                                  }
                                                )
                                              : parseFloat(item['request_quantum'])?.toLocaleString(
                                                  'id',
                                                  {
                                                    maximumFractionDigits: 4,
                                                  }
                                                )}{' '}
                                            {item.sector_id === 3 ? 'MT' : 'Ton'}
                                          </div>
                                        </td>
                                        {!isRetail(sektorID) && (
                                          <td>
                                            {item['fixed_quantum'] ? (
                                              <div>
                                                {(![0,1,2,5,13].includes(item.status)) ? (
                                                  <>
                                                    {i18next.language === 'en'
                                                      ? item['fixed_quantum']?.toLocaleString(
                                                          'en',
                                                          {
                                                            maximumFractionDigits: 4,
                                                          }
                                                        )
                                                      : item['fixed_quantum']?.toLocaleString(
                                                          'id',
                                                          {
                                                            maximumFractionDigits: 4,
                                                          }
                                                        )}{' '}
                                                    {item.sector_id === 3 ? 'MT' : 'Ton'}
                                                  </>
                                                ) : (
                                                  <>
                                                    <label className=''>-</label>
                                                  </>
                                                )}
                                              </div>
                                            ) : (
                                              <>
                                                <label className=''>-</label>
                                              </>
                                            )}
                                          </td>
                                        )}
                                        {item.is_formulated_price ? (
                                          <>
                                            <td>
                                              <div>{t('Formulated Price')}</div>
                                            </td>
                                          </>
                                        ) : (
                                          <>
                                            <td>
                                              <div>
                                                {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                                  (i18next.language === 'en'
                                                    ? parseFloat(
                                                        item['request_price']
                                                      )?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : parseFloat(
                                                        item['request_price']
                                                      )?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })) +
                                                  (sektorID != 3 ? '/Ton' : '/MT')}
                                              </div>
                                            </td>
                                          </>
                                        )}

                                        {!isRetail(sektorID) && (
                                          <td>
                                            <div>
                                              {(
                                                ![0,1,2,5,13].includes(item.status)
                                              ) ? (
                                                <>
                                                  {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                                    (i18next.language === 'en'
                                                      ? item['fixed_price']?.toLocaleString('en', {
                                                          maximumFractionDigits: 4,
                                                        })
                                                      : item['fixed_price']?.toLocaleString('id', {
                                                          maximumFractionDigits: 4,
                                                        })) +
                                                    (sektorID != 3 ? '/Ton' : '/MT')}
                                                </>
                                              ) : (
                                                <label className=''>-</label>
                                              )}
                                            </div>
                                          </td>
                                        )}
                                        {item.sector_id == 1 ? (
                                          <>
                                            <td>
                                              <div>
                                                {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                                              </div>
                                            </td>
                                          </>
                                        ) : (
                                          <></>
                                        )}
                                        {isRetail(item.sector_id) ? (
                                          <td>
                                            <div>
                                              <PopoverText
                                                content={item['plant'] + ' - ' + item['plant_desc']}
                                                index={_index}
                                                className='spec-sliceee'
                                              />
                                            </div>
                                          </td>
                                        ) : (
                                          ''
                                        )}
                                      </tr>
                                    </>
                                  )}
                                </>
                              ))}
                            </TableUI.TBody>
                          </>
                        ) : (
                          <>
                            {nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202' ? (
                              <>
                                <TableUI.THead>
                                  <tr style={{backgroundColor: '#274070'}}>
                                    {hakAkses?.approve ? <th>{t('pilih')}</th> : ''}
                                    <th>{t('sub-order-item')}</th>
                                    <th>Status</th>
                                    <th>{t('order-aksi')}</th>
                                    <th>Sales Org</th>
                                    <th>{t('sub-order-incoterm')}</th>
                                    {sektorID != 3 ? <th>{t('sub-order-wilayah')}</th> : ''}
                                    <th>{t('End Customer')}</th>
                                    <th>{t('sub-order-jenis')}</th>
                                    <th>{t('Product Code')}</th>
                                    <th>{t('sub-order-produk')}</th>
                                    <th>{t('Kuantum Pengajuan')}</th>
                                    <th>{t('Kuantum PengajuanD')}</th>
                                    <th>{t('Harga Pengajuan')}</th>
                                    <th>{t('sub-order-hargaD')}</th>
                                    <th>Status {t('Price')}</th>
                                  </tr>
                                </TableUI.THead>
                                <TableUI.TBody>
                                  {detailOrder.map((item, _index) => (
                                    <tr key={item?.id ?? _index}>
                                      {hakAkses?.approve ? (
                                        <>
                                          {item.status == 1 || item.status == 0 ? (
                                            <td>
                                              {
                                                  UserSegment(item?.segment_code) ? <>
                                                  <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id={'checkbox' + _index}
                                                value={
                                                  item.id || `Uid${item.generatedId}` + '~#~' + _index
                                                }
                                                onClick={() => onclickCheckBox(_index)}
                                              />
                                                </> : <>
                                                <span data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title={t('not-match-segment')}>
                                                  <input
                                                    className='form-check-input'
                                                    type='checkbox'
                                                    disabled
                                                  />
                                                </span>
                                                </>
                                              }
                                              {/* <span>check 9</span> */}
                                            </td>
                                          ) : (
                                            <td>
                                              <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id={'checkbox' + _index}
                                                disabled
                                              />
                                              {/* <span>check 10</span> */}
                                            </td>
                                          )}
                                        </>
                                      ) : (
                                        ''
                                      )}

                                      <td>
                                        <div>{_index + 1}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {item['status_text'] == 'Pengajuan Amandemen' ||
                                          item['status_text'] == 'Amandemen' ||
                                          item['status_text'] == 'Diamandemen Customer' ||
                                          item['status_text'] == 'Telah Diamandemen' ||
                                          item['status_text'] ==
                                            'Menunggu Persetujuan Amandemen' ? (
                                            <span className='badge badge-light-info'>
                                              {t('Amandemen')}
                                            </span>
                                          ) : item['status'] == '0' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '1' && item.is_new ? (
                                            <label className=''>-</label>
                                          ) : item['status'] == '1' ? (
                                            <span className='badge badge-light-primary'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '2' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '3' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '4' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '5' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '6' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '7' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item.status == 'new' ? (
                                            <label className=''>-</label>
                                          ) : (
                                            <span className='badge badge-light-danger'>
                                              {t(item['status_text'])}
                                            </span>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <ActionIcon
                                            className='me-1'
                                            title='Detail'
                                            iconPath='/media/icons/duotune/file-text-fill.svg'
                                            disabled={loadDetail}
                                            onClick={() => {
                                              setSubprice(item.fixed_price2)
                                              setQuantum(item.fixed_quantum2)
                                              setTemporaryIndex(_index)
                                              setIdxDetail(_index)
                                              setisAmandment('false')
                                              setTempDetail(item)
                                              handleDetailClick(item.sector_id)
                                              productTypeDetail = item.product_type
                                              produsenDetail = item.produsen?.code
                                              regionDetail = item.province?.id
                                              if (roleUser == 'salesAdmin') {
                                                setState(item, 'app')
                                              }
                                            }}
                                          />
                                          <ActionIcon
                                            className='me-1'
                                            title={t('order-lampiran')}
                                            iconPath='/media/icons/duotune/archive-fill.svg'
                                            isLoading={isGetAttachmentLoading}
                                            hidden={roleUser == 'salesAdmin' ? true : false}
                                            onClick={() => {
                                              setisAmandment('false')
                                              handleShow1(
                                                item.is_new_item ? 'amandemen' : 'order-item',
                                                item.id
                                              )
                                              setSubOrderID(item.id)
                                              setParam(
                                                item.is_new_item ? 'amandemen' : 'order-item'
                                              )
                                              setFileBox(item)
                                              roleUser == 'salesAdmin' || roleUser == 'admin'
                                                ? setDownloadOnly(true)
                                                : setDownloadOnly(false)
                                            }}
                                          />
                                          {item.status == 5 &&
                                          item.sales_id == localStorage.getItem('user-id') ? (
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('ke_nego')}
                                              onClick={() => {
                                                toNego(item['id'], orderNumber)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/handshake.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                          ) : (
                                            <></>
                                          )}
                                          <ActionIcon
                                            title={t('Comment')}
                                            iconPath='/media/icons/duotune/chat-left-text-fill.svg'
                                            isLoading={isGetCommentLoading}
                                            onClick={() => {
                                              handleGetComment(item.id, false)
                                            }}
                                          />
                                          {item.is_new ? (
                                            <></>
                                          ) : (
                                            <ActionIcon
                                              className='ms-1'
                                              iconPath='/media/icons/duotune/chat-dots-fill.svg'
                                              disabled={
                                                revisiIndex != 0
                                                  ? revisiIndex == _index + 1
                                                    ? false
                                                    : true
                                                  : false
                                              }
                                              title={t('Chat')}
                                              isLoading={isGetChatLoading}
                                              onClick={() => {
                                                setTempId(item.id)
                                                handleGetChat(item.id)
                                              }}
                                            />
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item.produsen?.name}</div>
                                      </td>
                                      <td>
                                        <div>{item.incoterm1?.code}</div>
                                      </td>
                                      {sektorID != 3 ? (
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                item['province']?.region_name +
                                                ', ' +
                                                item['city']?.city_name
                                              }
                                              index={_index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        ''
                                      )}
                                      <td>
                                        <div>
                                          <PopoverText
                                            content={
                                              item?.end_user_multiple
                                                ? handleShowValue(
                                                    item?.end_user,
                                                    item?.end_user_multiple
                                                  )
                                                : item?.end_user
                                            }
                                            index={_index}
                                            className='desc-slicee'
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>{t(item['product_type_desc'])}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {parseInt(item.material_number) == 0 ? (
                                            <label className=''>-</label>
                                          ) : (
                                            item['material_number']?.slice(-7)
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item['product_name']}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {i18next.language === 'en'
                                            ? item['request_quantum']?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              })
                                            : item['request_quantum']?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              })}{' '}
                                          {item.sector_id === 3 ? 'MT' : 'Ton'}
                                        </div>
                                      </td>

                                      <td>
                                        {item['fixed_quantum'] ? (
                                          <div>
                                            {(![0,1,2,5,13].includes(item.status)) ? (
                                              <>
                                                {i18next.language === 'en'
                                                  ? item['fixed_quantum']?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : item['fixed_quantum']?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })}{' '}
                                                {item.sector_id === 3 ? 'MT' : 'Ton'}
                                              </>
                                            ) : (
                                              <label className=''>-</label>
                                            )}
                                          </div>
                                        ) : (
                                          <label className=''>-</label>
                                        )}
                                      </td>
                                      <td>
                                        <div>
                                          {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                            (i18next.language === 'en'
                                              ? parseFloat(item['request_price'])?.toLocaleString(
                                                  'en',
                                                  {
                                                    maximumFractionDigits: 4,
                                                  }
                                                )
                                              : parseFloat(item['request_price'])?.toLocaleString(
                                                  'id',
                                                  {
                                                    maximumFractionDigits: 4,
                                                  }
                                                )) +
                                            (sektorID != 3 ? '/Ton' : '/MT')}
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {(![0,1,2,5,13].includes(item.status)) ? (
                                            <>
                                              {(sektorID != 3 ? 'Rp ' : 'USD ') +
                                                (i18next.language === 'en'
                                                  ? parseFloat(item['fixed_price'])?.toLocaleString(
                                                      'en',
                                                      {
                                                        maximumFractionDigits: 4,
                                                      }
                                                    )
                                                  : parseFloat(item['fixed_price'])?.toLocaleString(
                                                      'id',
                                                      {
                                                        maximumFractionDigits: 4,
                                                      }
                                                    )) +
                                                (sektorID != 3 ? '/Ton' : '/MT')}
                                            </>
                                          ) : (
                                            <label className=''>-</label>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </TableUI.TBody>
                              </>
                            ) : (
                              <>
                                <TableUI.THead>
                                  <tr style={{backgroundColor: '#274070'}}>
                                    {hakAkses?.approve ? <th>{t('pilih')}</th> : ''}
                                    <th>{t('sub-order-item')}</th>
                                    <th>Status</th>
                                    <th>{t('order-aksi')}</th>
                                    <th>Sales Org</th>
                                    <th>{t('sub-order-jenis')}</th>
                                    <th>{t('Product Code')}</th>
                                    <th>{t('sub-order-produk')}</th>
                                  </tr>
                                </TableUI.THead>
                                <TableUI.TBody>
                                  {detailOrder.map((item, _index) => (
                                    <tr key={item?.id ?? _index}>
                                      {hakAkses?.approve ? (
                                        <>
                                          {item.status == 1 || item.status == 0 ? (
                                            <td>
                                              <div>
                                                {
                                                  UserSegment(item?.segment_code) ? <>
                                                  <input
                                                  className='form-check-input'
                                                  type='checkbox'
                                                  id={'checkbox' + _index}
                                                  value={
                                                    item.id ||
                                                    `Uid${item.generatedId}` + '~#~' + _index
                                                  }
                                                  onClick={() => onclickCheckBox(_index)}
                                                />
                                                </> : <>
                                                <span data-bs-toggle='tooltip'
                                                  data-bs-placement='top'
                                                  data-bs-trigger='hover'
                                                  title={t('not-match-segment')}>
                                                  <input
                                                    className='form-check-input'
                                                    type='checkbox'
                                                    disabled
                                                  />
                                                </span>
                                                </>
                                                }
                                                {/* <span>check 11</span> */}
                                              </div>
                                            </td>
                                          ) : (
                                            <td>
                                              <div>
                                                <input
                                                  className='form-check-input'
                                                  type='checkbox'
                                                  id={'checkbox' + _index}
                                                  disabled
                                                />
                                                {/* <span>check 12</span> */}
                                              </div>
                                            </td>
                                          )}
                                        </>
                                      ) : (
                                        <></>
                                      )}

                                      <td>
                                        <div>{_index + 1}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {item['status_text'] == 'Pengajuan Amandemen' ||
                                          item['status_text'] == 'Amandemen' ||
                                          item['status_text'] == 'Diamandemen Customer' ||
                                          item['status_text'] == 'Telah Diamandemen' ||
                                          item['status_text'] ==
                                            'Menunggu Persetujuan Amandemen' ? (
                                            <span className='badge badge-light-info'>
                                              {t('Amandemen')}
                                            </span>
                                          ) : item['status'] == '0' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '1' ? (
                                            <span className='badge badge-light-primary'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '2' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '3' ? (
                                            <span className='badge badge-light-warning'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '4' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '5' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '6' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : item['status'] == '7' ? (
                                            <span className='badge badge-light-success'>
                                              {t(item['status_text'])}
                                            </span>
                                          ) : (
                                            <span className='badge badge-light-danger'>
                                              {t(item['status_text'])}
                                            </span>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <ActionIcon
                                            className='me-1'
                                            title='Detail'
                                            iconPath='/media/icons/duotune/file-text-fill.svg'
                                            disabled={loadDetail}
                                            onClick={() => {
                                              setisAmandment('false')
                                              setIdxDetail(_index)
                                              setTempDetail(item)
                                              handleDetailClick(item.sector_id)
                                              productTypeDetail = item.product_type
                                              produsenDetail = item.produsen?.code
                                              regionDetail = item.province?.id
                                              if (roleUser == 'salesAdmin') {
                                                setState(item, 'app')
                                              }
                                            }}
                                          />
                                          <ActionIcon
                                            className='me-1'
                                            title={t('order-lampiran')}
                                            iconPath='/media/icons/duotune/archive-fill.svg'
                                            isLoading={isGetAttachmentLoading}
                                            hidden={roleUser == 'salesAdmin' ? true : false}
                                            onClick={() => {
                                              setisAmandment('false')
                                              handleShow1(
                                                item.is_new_item ? 'amandemen' : 'order-item',
                                                item.id
                                              )
                                              setSubOrderID(item.id)
                                              setParam(
                                                item.is_new_item ? 'amandemen' : 'order-item'
                                              )
                                              setFileBox(item)
                                              roleUser == 'salesAdmin' || roleUser == 'admin'
                                                ? setDownloadOnly(true)
                                                : setDownloadOnly(false)
                                            }}
                                          />

                                          {item.status == 5 &&
                                          item.sales_id == localStorage.getItem('user-id') ? (
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('ke_nego')}
                                              onClick={() => {
                                                toNego(item['id'], orderNumber)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/handshake.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                          ) : (
                                            <></>
                                          )}
                                          <ActionIcon
                                            title={t('Comment')}
                                            iconPath='/media/icons/duotune/chat-left-text-fill.svg'
                                            isLoading={isGetCommentLoading}
                                            onClick={() => {
                                              handleGetComment(item.id, false)
                                            }}
                                          />
                                          {item.is_new ? (
                                            <></>
                                          ) : (
                                            <ActionIcon
                                              className='ms-1'
                                              disabled={
                                                revisiIndex != 0
                                                  ? revisiIndex == _index + 1
                                                    ? false
                                                    : true
                                                  : false
                                              }
                                              title={t('Chat')}
                                              iconPath='/media/icons/duotune/chat-dots-fill.svg'
                                              isLoading={isGetChatLoading}
                                              onClick={() => {
                                                setTempId(item.id)
                                                handleGetChat(item.id)
                                              }}
                                            />
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item.produsen?.name}</div>
                                      </td>
                                      <td>
                                        <div>{t(item['product_type_desc'])}</div>
                                      </td>
                                      <td>
                                        <div>
                                          {parseInt(item.material_number) == 0 ? (
                                            <label className=''>-</label>
                                          ) : (
                                            item['material_number']?.slice(-7)
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        <div>{item['product_name']}</div>
                                      </td>
                                    </tr>
                                  ))}
                                </TableUI.TBody>
                              </>
                            )}
                          </>
                        )}
                      </TableUI.Table>
                    </TableUI.TableWrapper>
                  </TableUI.TableDetail>
                  {/* End Table Head */}
                </div>
                {roleUser == 'Anper' || roleUser == 'anper' ? (
                  <></>
                ) : (
                  <div style={{marginTop: '2rem'}}>
                    {hakAkses?.approve ? (
                      <>
                        <div className='d-flex justify-content-end mt-5 mb-3'>
                          <Link to='/management/order/all' className='me-2'>
                            <Button variant='secondary'>
                              {buttonFlag ? t('Cancel') : t('order-kembali')}
                            </Button>
                          </Link>

                          {buttonFlag ? (
                            <>
                              <button
                                className='btn btn-danger me-2'
                                id='btn-reject'
                                onClick={handleShow4}
                              >
                                {t('order-tolak2')}
                              </button>
                              <Modal show={show4} onHide={handleClose4} centered backdrop='static'>
                                <Modal.Header closeButton>
                                  <Modal.Title>{t('alasan-tolak-order')}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <FloatingLabel
                                    controlId='floatingTextarea2'
                                    label={t('order-alasan')}
                                  >
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('Tinggal-pesan')}
                                      style={{height: '100px'}}
                                      onChange={(e: any) => setRejectNote(e.target.value)}
                                    />
                                  </FloatingLabel>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant='secondary' onClick={handleClose4}>
                                    {t('cancel')}
                                  </Button>
                                  <Button
                                    variant='danger'
                                    onClick={() => Reject()}
                                    disabled={btnLoading}
                                  >
                                    {btnLoading ? (
                                      <Spinner animation='border' variant='light' size='sm' />
                                    ) : (
                                      t('order-tolak2')
                                    )}
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                              {amandemenPresent ? (
                                <button
                                  className='btn btn-warning me-2'
                                  id='btn-revision'
                                  onClick={handleShow62}
                                >
                                  {t('order-revisi2')}
                                </button>
                              ) : (
                                ''
                              )}

                              <Modal show={show6} onHide={handleClose6} centered backdrop='static'>
                                <Modal.Header closeButton>
                                  <Modal.Title>{t('Revision Reason')}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <FloatingLabel
                                    controlId='floatingTextarea2'
                                    label={t('order-alasan')}
                                  >
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('Tinggal-pesan')}
                                      style={{height: '100px'}}
                                      onChange={(e: any) => setRevisionNote(e.target.value)}
                                    />
                                  </FloatingLabel>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant='secondary' onClick={handleClose6}>
                                    {t('cancel')}
                                  </Button>
                                  <Button
                                    variant='warning'
                                    onClick={() => Revision()}
                                    disabled={btnLoading}
                                  >
                                    {btnLoading ? (
                                      <Spinner animation='border' variant='light' size='sm' />
                                    ) : (
                                      t('order-revisi2')
                                    )}
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                              <button
                                className='btn btn-success me-2'
                                id='btn-approve'
                                onClick={handleShow5}
                              >
                                {isRetail(sektorID)
                                  ? t('Approve')
                                  : regarding == 'PO002'
                                  ? t('setujui')
                                  : t('Submit') + ' ' + t('aside-negosiasi')}
                              </button>
                              <Modal show={show5} onHide={handleClose5} centered backdrop='static'>
                                <Modal.Header closeButton></Modal.Header>
                                <Modal.Body>
                                  <h3 className='text-center mb-5'>{t('apakahAndaYakin')}</h3>
                                  <div className='d-flex justify-content-center'>
                                    <Button
                                      variant='secondary me-2'
                                      onClick={() => setShow5(false)}
                                    >
                                      {t('Tidak')}
                                    </Button>
                                    <Button onClick={handleShow6} disabled={btnLoading}>
                                      {btnLoading ? (
                                        <Spinner animation='border' variant='light' size='sm' />
                                      ) : (
                                        t('Ya')
                                      )}
                                    </Button>
                                  </div>
                                </Modal.Body>
                              </Modal>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </>
                    ) : (
                      <div className='d-flex justify-content-end'>
                        <Link to='/management/order/all' className='me-2'>
                          <Button variant='secondary'>{t('order-kembali')}</Button>
                        </Link>
                      </div>
                    )}
                  </div>
                )}
                <Modal
                  show={showUpdate}
                  onHide={() => setShowUpdate(false)}
                  centered
                  backdrop='static'
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <Row className='mb-5'>
                      <Col sm={4}>
                        <h6 className='mt-4'>{t('Update Price')}</h6>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          type='number'
                          placeholder={t('Update Price')}
                          onChange={(e: any) => setUpdatePrice(parseInt(e.target.value))}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-5'>
                      <Col sm={4}>
                        <h6 className='mt-4'>{t('Update Quantum')}</h6>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          type='number'
                          placeholder={t('Update Quantum')}
                          onChange={(e: any) => setUpdateQuantum(parseInt(e.target.value))}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant='secondary' onClick={() => setShowUpdate(false)}>
                      {t('cancel')}
                    </Button>
                    <Button variant='success' onClick={() => handleUpdate()} disabled={btnLoading}>
                      {btnLoading ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : (
                        t('submit')
                      )}
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            )}
          </>
        )}

        {/* modal custoemr profile */}
        <Modal
          size='xl'
          show={showCustomerProfile}
          onHide={() => {
            setShowCustomerProfile(false)
            setTotalInvoices([0, 0, 0, 0])
            setInvoices([
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
            ])
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Customer Support Data')}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{backgroundColor: '#e9e9f4'}}>
            <Row className='mb-5'>
              <Col sm={6}>
                <div className='card pe-1'>
                  <div className='card-body'>
                    <div className='d-flex align-items-center'>
                      <img src={toAbsoluteUrl(`/media/money 1.png`)} />
                      <h6 className='ms-3' style={{color: '#274070'}}>
                        Outstanding Invoice
                      </h6>
                    </div>
                    <hr />
                    <div className='d-flex justify-content-between'>
                      <p>{'<'}31 Days</p>
                      <p>{totalInvoices[0]}</p>
                    </div>
                    <div className='d-flex justify-content-between bg-secondary'>
                      <p>31-90 Days</p>
                      <p>{totalInvoices[1]}</p>
                    </div>
                    <div className='d-flex justify-content-between'>
                      <p>91-365 Days</p>
                      <p>{totalInvoices[2]}</p>
                    </div>
                    <div className='d-flex justify-content-between bg-secondary'>
                      <p>{'>'}365 Days</p>
                      <p>{totalInvoices[3]}</p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={6}>
                <div className='card ps-1 '>
                  <div className='card-body'>
                    <div className='d-flex align-items-center'>
                      <img src={toAbsoluteUrl(`/media/search 1.png`)} />
                      <h6 className='ms-3' style={{color: '#274070'}}>
                        Status
                      </h6>
                    </div>
                    <hr />
                    <div className='d-flex justify-content-center align-items-center'>
                      <div
                        className='rounded-circle'
                        style={{
                          width: '80px',
                          height: '80px',
                          backgroundColor: colorList[custStatus.status],
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className='card'>
              <div className='card-body'>
                <Row>
                  <Col sm={6}>
                    <div className='d-flex align-items-center mb-3'>
                      <img src={toAbsoluteUrl(`/media/search 1.png`)} />
                      <h6 className='ms-3' style={{color: '#274070'}}>
                        Data Detail
                      </h6>
                    </div>
                    <div className='card' style={{backgroundColor: '#F4FAFA'}}>
                      <div className='card-body'>
                        {/* <h6 style={{color: '#274070'}}>
                          Customer Title:{' '}
                          <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>
                            {custStatus['CompanyTitle'] ? custStatus['CompanyTitle'] : '-'}
                          </span>
                        </h6> */}
                        <h6 className='mb-4' style={{color: '#274070'}}>
                          Customer Name:{' '}
                          <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>
                            {custStatus.customer_name}
                          </span>
                        </h6>
                        <h6 style={{color: '#274070'}}>
                          Alamat:{' '}
                          <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>
                            {custStatus.customer_address}
                          </span>
                        </h6>
                        <h6 style={{color: '#274070'}}>
                          Provinsi: <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>-</span>
                        </h6>
                        <h6 className='mb-10' style={{color: '#274070'}}>
                          Kota/Kab: <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>-</span>
                        </h6>
                        <h6 style={{color: '#274070'}}>Customer Number</h6>
                        <div className='w-50' style={{backgroundColor: 'white'}}>
                          <div className='d-flex justify-content-between align-items-center px-2 border-top border-bottom'>
                            <p>{customerCode}</p>
                            <div
                              className='rounded-circle'
                              style={{
                                width: '12px',
                                height: '12px',
                                backgroundColor:
                                  colorList[custStatus.status ? custStatus.status : 'Yellow'],
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <Row className='mb-5'>
                      <Col sm={6} className='pe-2'>
                        <h4 className='mb-2'>Invoices {'>'} 365 Days</h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[3].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[3].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[3].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[3].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[3].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                      <Col sm={6} className='ps-2'>
                        <h4 className='mb-2' style={{color: '#F0C94A'}}>
                          Invoices 31-90 Days
                        </h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[1].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[1].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[1].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[1].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[1].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6} className='pe-2'>
                        <h4 className='mb-2 text-danger'>Invoices 91-365 Days</h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[2].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[2].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[2].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[2].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[2].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                      <Col sm={6} className='ps-2'>
                        <h4 className='mb-2' style={{color: '#48CE86'}}>
                          Invoices {'<'}30 Days
                        </h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[0].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[0].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[0].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[0].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[0].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
            {/* {customerName == 'AFIAH' ? (
              <img src={toAbsoluteUrl('/media/Kuning.png')} className='w-100' />
            ) : customerName == 'BINA SEJAHTERA' ? (
              <img src={toAbsoluteUrl('/media/Hijau.png')} className='w-100' />
            ) : customerName == 'AGRO BOKASHINDO JAYA' ? (
              <img src={toAbsoluteUrl('/media/Merah.png')} className='w-100' />
            ) : customerName == 'ABK MITRA MANDIRI' ? (
              <img src={toAbsoluteUrl('/media/Hitam.png')} className='w-100' />
            ) : (
              <></>
            )} */}
          </Modal.Body>
        </Modal>

        {/* modal attachment */}
        <Modal
          size='lg'
          show={showUpload}
          onHide={() => {
            setShowUpload(false)
            setIsPrivate(false)
            setTempRole([])
            setFileBox({})
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {param !== 'header'
                ? fileBox?.product_name
                  ? (fileBox.province?.region_name != undefined
                      ? fileBox.province?.region_name
                      : '') +
                    (fileBox.city?.city_name != undefined ? ', ' + fileBox.city?.city_name : '') +
                    (fileBox.province ? ' | ' : '') +
                    fileBox.product_name +
                    (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                  : t('File Box')
                : t('File Box')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            
            <div hidden={revisiIndex != 0 && param != 'header' ? false : true}>
              {!downloadOnly && (
                <Row>
                  <Col sm={6}>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-fileUnggah')}</h6>
                        </td>
                        <td className='w-75'>
                          {statusItem == 2 ? (
                            <InputFile
                              setFileName={setNamaFile}
                              setFiles={setFiles2}
                            />
                          ) : (
                            <InputFile
                                setFileName={(_: string) => {}}
                                setFiles={setFiles}
                                isBase64={false}
                            />
                          )}
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-keterangan')}</h6>
                        </td>
                        <td className='w-75'>
                          <Form.Control
                            type='text'
                            placeholder={t('order-keterangan')}
                            id='uploadketerangan'
                            onChange={(e: any) => setDescription(e.target.value)}
                          />
                        </td>
                      </tr>
                    </table>
                    <table
                      className='mb-3'
                      hidden={roleUser == 'null' || roleUser == null ? true : false}
                    >
                      <tr>
                        <td>
                          <h6 className='me-11'>{t('Private')}</h6>
                        </td>
                        <td className='w-75 d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            name='isPrivate'
                            type='checkbox'
                            className='mt-5 mb-2'
                            onClick={() => {
                              setIsPrivate(!isPrivate)
                              setTempRole([])
                            }}
                            id='isPrivate2'
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3' hidden={isPrivate ? false : true}>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('Akses Role')}</h6>
                        </td>
                        <td className='w-75' style={{maxWidth: '274px'}}>
                          <MultiSelect
                            key={isPrivate.toString()}
                            options={fullRole?.map((item: any) => {
                              return {label: item.label, value: item.value}
                            })}
                            value={tempRole}
                            onChange={(e: any) => setTempRole(e)}
                            labelledBy='Select'
                          />
                        </td>
                      </tr>
                    </table>
                    <div className='d-flex justify-content-end'>
                      {statusItem == 2 ? (
                        <Button
                          variant='primary'
                          className='w-100'
                          disabled={btnLoading}
                          onClick={() => handleUpload2()}
                        >
                          {btnLoading ? <Spinner animation='border' size='sm' /> : t('order-kirim')}
                        </Button>
                      ) : (
                        <Button
                          variant='primary'
                          className='w-100'
                          disabled={btnLoading}
                          onClick={() => handleUpload()}
                        >
                          {btnLoading ? <Spinner animation='border' size='sm' /> : t('order-kirim')}
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
              )}

              {statusItem == 2 ? (
                <>
                  {detailOrder[temporaryIndex].attachments.length < 1 ||
                  detailOrder[temporaryIndex].attachments.length == undefined ? (
                    <div className='text-center p-4'>No File</div>
                  ) : (
                    <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        <thead className='fw-bold border-bottom'>
                          <tr className=''>
                            <th className='text-center'>{t('order-noo')}</th>
                            <th className='text-center'>{t('order-keterangan')}</th>
                            <th className='text-center'>{t('order-tglUpload')}</th>
                            {/* <th className='text-center'>{t('User Code')}</th> */}
                            <th className='text-center'>{t('order-user')}</th>
                            <th className='text-center'>{t('Akses Role')}</th>
                            <th className='text-center'>{t('order-aksi')}</th>
                          </tr>
                        </thead>
                        {detailOrder[temporaryIndex].attachments
                          .slice(0)
                          .reverse()
                          .map((data: any, _index: any) => (
                            <tbody key={data?.id ?? _index}>
                              <tr className=''>
                                <td className='text-center'>
                                  <label>{_index + 1}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{data.description}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{dateformat(getCurrentFormattedDate())}</label>
                                </td>
                                {/* <td className='text-center'>
                                  <label>
                                    {localStorage.getItem('cust-code') !== 'null'
                                      ? localStorage.getItem('cust-code')
                                      : localStorage.getItem('user_code')}
                                  </label>
                                </td> */}
                                <td className='text-center'>
                                  <label>{localStorage.getItem('username')}</label>
                                </td>
                                <td className='text-center'>
                                  {data.private ? (
                                    data.roles.length > 0 ? (
                                      <PopoverText
                                        content={handleShowRoleNameFromState(data.roles)}
                                        index={_index}
                                        className='desc-slice'
                                      />
                                    ) : (
                                      'Private'
                                    )
                                  ) : (
                                    'Public'
                                  )}
                                </td>
                                <td className='text-center'>
                                  <ActionIcon
                                    className='me-1'
                                    title={t('unduh')}
                                    iconPath='/media/icons/duotune/arrow-down-square-fill.svg'
                                    onClick={() => download_file(data.file_r, data.name)}
                                  />
                                  {accsessDelete && (
                                    <ActionIcon
                                      title={t('Hapus')}
                                      iconPath='/media/icons/duotune/trash-fill.svg'
                                      onClick={() =>
                                        handleDeleteUploadHeader(
                                          detailOrder[temporaryIndex].attachments.length -
                                            1 -
                                            _index,
                                          detailOrder,
                                          setOrderItemsFiles,
                                          'order-item'
                                        )
                                      }
                                    />
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          ))}
                      </table>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {allFile.length < 1 || allFile.length == undefined ? (
                    <>
                      <div className='text-center p-4'>No File</div>
                    </>
                  ) : (
                    <div className='table-responsive mt-4 bdr'>
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        <thead className='fw-bold border-bottom'>
                          <tr className=''>
                            <th className='text-center'>{t('order-noo')}</th>
                            <th className='text-center'>{t('order-keterangan')}</th>
                            <th className='text-center'>{t('order-tglUpload')}</th>
                            {/* <th className='text-center'>{t('User Code')}</th> */}
                            <th className='text-center'>{t('order-user')}</th>
                            <th className='text-center'>{t('Akses Role')}</th>
                            <th className='text-center'>{t('order-aksi')}</th>
                          </tr>
                        </thead>
                        {allFile.map((data: any, _index: any) => (
                          <tbody key={data?.id ?? _index}>
                            <tr className=''>
                              <td className='text-center'>
                                <label>{_index + 1}</label>
                              </td>
                              <td className='text-center'>
                                <label>{data.description}</label>
                              </td>
                              <td className='text-center'>
                                <label>{dateformat(data.updated_at)}</label>
                              </td>
                              {/* <td className='text-center'>
                                <label>
                                  {localStorage.getItem('cust-code') !== 'null'
                                    ? localStorage.getItem('cust-code')
                                    : localStorage.getItem('user_code')}
                                </label>
                              </td> */}
                              <td className='text-center'>
                                {data.user?.customer_code == null ? (
                                  <label>{data.user?.name}</label>
                                ) : (
                                  <label>{data.user?.customer?.name}</label>
                                )}
                              </td>
                              <td className='text-center'>
                                {data.private ? (
                                  data.roles.length > 0 ? (
                                    <PopoverText
                                      content={handleShowRoleName(data.roles)}
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  ) : (
                                    'Private'
                                  )
                                ) : (
                                  'Public'
                                )}
                              </td>
                              <td className='text-center'>
                                <ActionIcon
                                  className='me-1'
                                  title={t('unduh')}
                                  iconPath='/media/icons/duotune/arrow-down-square-fill.svg'
                                  onClick={() =>
                                    handleDownloadAttachment(data.file_path)
                                  }
                                />
                                {param == 'header' ? (
                                  <>
                                    {roleUser != 'salesAdmin' ? (
                                      ''
                                    ) : (
                                      <>
                                        {(accsessDelete ||
                                          CheckSameIDAttachment(data.user_role_flag)) && (
                                          <ActionIcon
                                            title={t('Hapus')}
                                            iconPath='/media/icons/duotune/trash-fill.svg'
                                            onClick={() => deleteAttachment(data.id)}
                                          />
                                        )}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {roleUser != 'salesAnper' ? (
                                      ''
                                    ) : (
                                      <>
                                        {(accsessDelete ||
                                          CheckSameIDAttachment(data.user_role_flag)) && (
                                          <ActionIcon
                                            title={t('Hapus')}
                                            iconPath='/media/icons/duotune/trash-fill.svg'
                                            onClick={() => deleteAttachment(data.id)}
                                          />
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      </table>
                    </div>
                  )}
                </>
              )}
            </div>

            <div hidden={revisiIndex == 0 || param == 'header' ? false : true}>
              {!downloadOnly ? (
                <Row hidden={statusAmandemen == 'Telah Diamandemen' ? true : false}>
                  <Col sm={6}>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-fileUnggah')}</h6>
                        </td>
                        <td className='w-75'>
                          <InputFile
                              setFileName={(_: string) => {}}
                              setFiles={setFiles}
                              isBase64={false}
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-keterangan')}</h6>
                        </td>
                        <td className='w-75'>
                          <Form.Control
                            type='text'
                            placeholder={t('order-keterangan')}
                            id='uploadketerangan2'
                            onChange={(e: any) => setDescription(e.target.value)}
                          />
                        </td>
                      </tr>
                    </table>
                    <table
                      className='mb-3'
                      hidden={roleUser == 'null' || roleUser == null ? true : false}
                    >
                      <tr>
                        <td>
                          <h6 className='me-11'>{t('Private')}</h6>
                        </td>
                        <td className='w-75 d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            type='checkbox'
                            className='mt-5 mb-2'
                            onClick={() => {
                              setIsPrivate(!isPrivate)
                              setTempRole([])
                            }}
                            id='isPrivate1'
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3' hidden={isPrivate ? false : true}>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('Akses Role')}</h6>
                        </td>
                        <td className='w-75' style={{maxWidth: '274px'}}>
                          <MultiSelect
                            key={isPrivate.toString()}
                            options={fullRole?.map((item: any) => {
                              return {label: item.label, value: item.value}
                            })}
                            value={tempRole}
                            onChange={(e: any) => setTempRole(e)}
                            labelledBy='Select'
                          />
                        </td>
                      </tr>
                    </table>
                    <div className='d-flex justify-content-end'>
                      <Button
                        variant='primary'
                        className='w-100'
                        disabled={btnLoading}
                        onClick={() => handleUpload()}
                      >
                        {btnLoading ? <Spinner animation='border' size='sm' /> : t('order-kirim')}
                      </Button>
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}

              {allFile.length < 1 || allFile.length == undefined ? (
                <div className='text-center p-4'>No File</div>
              ) : (
                <div className='table-responsive mt-4 bdr'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='fw-bold border-bottom'>
                      <tr className=''>
                        <th className='text-center'>{t('order-noo')}</th>
                        <th className='text-center'>{t('order-keterangan')}</th>
                        <th className='text-center'>{t('order-tglUpload')}</th>
                        {/* <th className='text-center'>{t('User Code')}</th> */}
                        <th className='text-center'>{t('order-user')}</th>
                        <th className='text-center'>{t('Akses Role')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    <tbody>
                    {allFile.map((data: any, _index: number) => (
                        <tr className='' key={data?.id ?? _index}>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(data.updated_at)}</label>
                          </td>
                          {/* <td className='text-center'>
                            <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                          </td> */}
                          <td className='text-center'>
                            {data.user?.customer_code == null ? (
                              <label>{data.user?.name}</label>
                            ) : (
                              <label>{data.user?.customer?.name}</label>
                            )}
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleName(data.roles)}
                                  index={_index}
                                  className='desc-slice'
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <ActionIcon
                              className='me-1'
                              title={t('unduh')}
                              iconPath='/media/icons/duotune/arrow-down-square-fill.svg'
                              onClick={() =>
                                handleDownloadAttachment(data.file_path)
                              }
                            />
                            {param == 'header' ? (
                              <>
                                {roleUser != 'salesAdmin' ? (
                                  <>
                                    {roleUser == 'null' && statusOrder == 2 ? (
                                      <ActionIcon
                                        title={t('Hapus')}
                                        iconPath='/media/icons/duotune/trash-fill.svg'
                                        onClick={() => deleteAttachment(data.id)}
                                      />
                                    ) : (
                                      ''
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {(accsessDelete ||
                                      CheckSameIDAttachment(data.user_role_flag)) && (
                                      <ActionIcon
                                        title={t('Hapus')}
                                        iconPath='/media/icons/duotune/trash-fill.svg'
                                        onClick={() => deleteAttachment(data.id)}
                                      />
                                    )}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {(accsessDelete || CheckSameIDAttachment(data.user_role_flag)) && (
                                  <ActionIcon
                                    title={t('Hapus')}
                                    iconPath='/media/icons/duotune/trash-fill.svg'
                                    onClick={() => deleteAttachment(data.id)}
                                  />
                                )}
                              </>
                            )}
                          </td>
                        </tr>
                    ))}
                  </tbody>
                  </table>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>

        {/* modal attachment db */}
        <Modal
          size='lg'
          show={showUpload2}
          onHide={() => {
            setShowUpload2(false)
            setFileBox({})
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {fileBox?.product_name
                ? (fileBox.province ? fileBox.province?.region_name : '') +
                  (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                  (fileBox.province ? ' | ' : '') +
                  fileBox.product_name +
                  (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                : t('File Box')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
          {!downloadOnly && (
                <Row>
                  <Col sm={6}>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-fileUnggah')}</h6>
                        </td>
                        <td className='w-75'>
                          {statusItem == 2 ? (
                            <InputFile
                                setFileName={setNamaFile}
                                setFiles={setFiles2}
                            />
                          ) : (
                            <InputFile
                                setFileName={(_: string) => {}}
                                setFiles={setFiles}
                                isBase64={false}
                            />
                          )}
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('order-keterangan')}</h6>
                        </td>
                        <td className='w-75'>
                          <Form.Control
                            type='text'
                            placeholder={t('order-keterangan')}
                            id='uploadketerangan'
                            onChange={(e: any) => setDescription(e.target.value)}
                          />
                        </td>
                      </tr>
                    </table>
                    <table
                      className='mb-3'
                      hidden={roleUser == 'null' || roleUser == null ? true : false}
                    >
                      <tr>
                        <td>
                          <h6 className='me-11'>{t('Private')}</h6>
                        </td>
                        <td className='w-75 d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            name='isPrivate'
                            type='checkbox'
                            className='mt-5 mb-2'
                            onClick={() => {
                              setIsPrivate(!isPrivate)
                              setTempRole([])
                            }}
                            id='isPrivate2'
                          />
                        </td>
                      </tr>
                    </table>
                    <table className='mb-3' hidden={isPrivate ? false : true}>
                      <tr>
                        <td style={{width: '120px'}}>
                          <h6>{t('Akses Role')}</h6>
                        </td>
                        <td className='w-75' style={{maxWidth: '274px'}}>
                          <MultiSelect
                            key={isPrivate.toString()}
                            options={fullRole?.map((item: any) => {
                              return {label: item.label, value: item.value}
                            })}
                            value={tempRole}
                            onChange={(e: any) => setTempRole(e)}
                            labelledBy='Select'
                          />
                        </td>
                      </tr>
                    </table>
                    <div className='d-flex justify-content-end'>
                      {statusItem == 2 ? (
                        <Button
                          variant='primary'
                          className='w-100'
                          disabled={btnLoading}
                          onClick={() => handleUpload2()}
                        >
                          {btnLoading ? <Spinner animation='border' size='sm' /> : t('order-kirim')}
                        </Button>
                      ) : (
                        <Button
                          variant='primary'
                          className='w-100'
                          disabled={btnLoading}
                          onClick={() => handleUpload()}
                        >
                          {btnLoading ? <Spinner animation='border' size='sm' /> : t('order-kirim')}
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
              )}
            {allFile.length < 1 || allFile.length == undefined ? (
              <div className='text-center p-2'>No Attachment</div>
            ) : (
              <div className='table-responsive mt-4 bdr'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='fw-bold border-bottom'>
                    <tr className=''>
                      <th className='text-center'>{t('order-noo')}</th>
                      <th className='text-center'>{t('order-keterangan')}</th>
                      <th className='text-center'>{t('order-tglUpload')}</th>
                      {/* <th className='text-center'>{t('User Code')}</th> */}
                      <th className='text-center'>{t('order-user')}</th>
                      <th className='text-center'>{t('Akses Role')}</th>
                      <th className='text-center'>{t('order-aksi')}</th>
                    </tr>
                  </thead>
                  {allFile.map((data: any, _index: number) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.description}</label>
                        </td>
                        <td className='text-center'>
                          <label>{dateformat(data.updated_at)}</label>
                        </td>
                        {/* <td className='text-center'>
                          <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                        </td> */}
                        <td className='text-center'>
                          {data.user?.customer_code == null ? (
                            <label>{data.user?.name}</label>
                          ) : (
                            <label>{data.user?.customer?.name}</label>
                          )}
                        </td>
                        <td className='text-center'>
                          {data.private ? (
                            data.roles.length > 0 ? (
                              <PopoverText
                                content={handleShowRoleName(data.roles)}
                                index={_index}
                                className='desc-slice'
                              />
                            ) : (
                              'Private'
                            )
                          ) : (
                            'Public'
                          )}
                        </td>
                        <td className='text-center'>
                          <ActionIcon
                            className='me-1'
                            title={t('unduh')}
                            iconPath='/media/icons/duotune/arrow-down-square-fill.svg'
                            onClick={() =>
                              handleDownloadAttachment(data.file_path)
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* modal attachment db */}
        <Modal
          size='lg'
          show={showUpload3}
          onHide={() => {
            setShowUpload3(false)
            setFileBox({})
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {fileBox?.product_name
                ? (fileBox.province ? fileBox.province?.region_name : '') +
                  (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                  (fileBox.province ? ' | ' : '') +
                  fileBox.product_name +
                  (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                : t('File Box')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Accordion>
              {allFilesByOrder.map((data: any, _index: number) => (
                <Accordion.Item eventKey={data?.id} key={data?.id ?? _index}>
                  <Accordion.Header>{data?.id}</Accordion.Header>
                  <Accordion.Body style={{backgroundColor: 'white'}}>
                    {data.attachments.length < 1 || data.attachments.length == undefined ? (
                      <></>
                    ) : (
                      <div className='table-responsive mt-4 bdr'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                          <thead className='fw-bold border-bottom'>
                            <tr className=''>
                              <th className='text-center px-2'>{t('order-noo')}</th>
                              <th className='text-center'>{t('order-keterangan')}</th>
                              <th className='text-center'>{t('order-tglUpload')}</th>
                              {/* <th className='text-center'>{t('User Code')}</th> */}
                              <th className='text-center'>{t('order-user')}</th>
                              <th className='text-center'>{t('order-aksi')}</th>
                            </tr>
                          </thead>
                          {data.attachments.map((data2: any, _index: number) => (
                            <tbody key={data2?.id ?? _index}>
                              <tr className=''>
                                <td className='text-center'>
                                  <label>{_index + 1}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{data2.description}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{data2.updated_at}</label>
                                </td>
                                {/* <td className='text-center'>
                                  <label>
                                    {data2.user?.customer_code || data2.user?.nama_pengguna}
                                  </label>
                                </td> */}
                                <td className='text-center'>
                                  {data2.user?.customer_code == null ? (
                                    <label>{data2.user?.name}</label>
                                  ) : (
                                    <label>{data2.user?.customer?.name}</label>
                                  )}
                                </td>
                                <td className='text-center'>
                                  <ActionIcon
                                    className='e-1'
                                    title={t('unduh')}
                                    iconPath='/media/icons/duotune/arrow-down-square-fill.svg'
                                    onClick={() =>
                                      handleDownloadAttachment(data2.file_path)
                                    }
                                  />
                                </td>
                              </tr>
                            </tbody>
                          ))}
                        </table>
                      </div>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Modal.Body>
        </Modal>

        {/* modal attachmment local*/}
        <Modal
          show={showAttac}
          size='lg'
          onHide={() => {
            setShowAttac(false)
            setIsPrivate(false)
            setTempRole([])
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {fileBox?.product_name
                ? (fileBox.province ? fileBox.province?.region_name : '') +
                  (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                  (fileBox.province ? ' | ' : '') +
                  fileBox.product_name +
                  (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                : t('File Box')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-fileUnggah')}</h6>
                    </td>
                    <td className='w-75'>
                      <InputFile
                          setFileName={setNamaFile}
                          setFiles={setFiles3}
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-keterangan')}</h6>
                    </td>
                    <td className='w-75'>
                      <Form.Control
                        type='text'
                        id='uploadketerangan'
                        placeholder={t('order-keterangan')}
                        onChange={(e: any) => setDescription(e.target.value)}
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3'>
                  <tr>
                    <td>
                      <h6 className='me-11'>{t('Private')}</h6>
                    </td>
                    <td className='w-75 d-flex justify-content-start'>
                      <Form.Check
                        reverse
                        type='checkbox'
                        className='mt-5 mb-2'
                        onClick={() => {
                          setIsPrivate(!isPrivate)
                          setTempRole([])
                        }}
                        id='isPrivate3'
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3' hidden={isPrivate ? false : true}>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('Akses Role')}</h6>
                    </td>
                    <td className='w-75' style={{maxWidth: '274px'}}>
                      <MultiSelect
                        key={isPrivate.toString()}
                        options={fullRole?.map((item: any) => {
                          return {label: item.label, value: item.value}
                        })}
                        value={tempRole}
                        onChange={(e: any) => setTempRole(e)}
                        labelledBy='Select'
                      />
                    </td>
                  </tr>
                </table>
                <div className='d-flex justify-content-end'>
                  <Button variant='primary' className='w-100' onClick={() => handleUpload3()}>
                    {t('order-kirim')}
                  </Button>
                </div>
              </Col>
              <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='fw-bold border-bottom'>
                    <tr className=''>
                      <th className='text-center px-2'>{t('order-noo')}</th>
                      <th className='text-center'>{t('order-keterangan')}</th>
                      <th className='text-center'>{t('order-tglUpload')}</th>
                      {/* <th className='text-center'>{t('User Code')}</th> */}
                      <th className='text-center'>{t('order-user')}</th>
                      <th className='text-center'>{t('Akses Role')}</th>
                      <th className='text-center'>{t('order-aksi')}</th>
                    </tr>
                  </thead>
                  {detailOrder[indexAttac]?.attachments
                    ?.reverse()
                    .map((data: any, _index: number) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(getCurrentFormattedDate())}</label>
                          </td>
                          {/* <td className='text-center'>
                            <label>
                              {localStorage.getItem('cust-code') !== 'null'
                                ? localStorage.getItem('cust-code')
                                : localStorage.getItem('user_code')}
                            </label>
                          </td> */}
                          <td className='text-center'>
                            <label>{localStorage.getItem('username')}</label>
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleNameFromState(data.roles)}
                                  index={_index}
                                  className='desc-slice'
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <ActionIcon
                              className='me-1'
                              title={t('unduh')}
                              iconPath='/media/icons/duotune/arrow-down-square-fill.svg'
                              onClick={() => download_file(data.file_r, data.name)}
                            />
                            <ActionIcon
                              title={t('Hapus')}
                              iconPath='/media/icons/duotune/trash-fill.svg'
                              onClick={() =>
                                handleDeleteUploadAttac(
                                  detailOrder[indexAttac]?.attachments?.length - 1 - _index,
                                  detailOrder[indexAttac]?.attachments
                                )
                              }
                            />
                          </td>
                        </tr>
                      </tbody>
                    ))}
                </table>
              </div>
            </Row>
          </Modal.Body>
        </Modal>

        {/* modal edit revisi */}
        <Modal
          show={showEdit}
          onHide={() => setShowEdit(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t('Edit')} {t('Order')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadingEdit ? (
              <div className='d-flex justify-content-center'>
                <Spinner animation='border' variant='primary' />
              </div>
            ) : (
              <>
                {showPurchaseForm ? (
                  <>
                    {idSektor == 3 && (
                      <>
                        <Row>
                          <Col md={6}>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('kontrak-produsen')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='produsen'
                                  placeholder={t('pilih')}
                                  defaultValue={
                                    salesArea[
                                      salesArea.findIndex(
                                        (item: any) => item.label === tempData?.produsen?.name
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue3(
                                      setProdusen,
                                      e?.value,
                                      setDistribution,
                                      setProdusenDesc
                                    )
                                    fieldClearer(8)
                                  }}
                                  options={salesArea}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-incoterm1')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='incoterm1'
                                  placeholder={t('pilih')}
                                  key={idSektor + fullIncoterm}
                                  defaultValue={
                                    fullIncoterm[
                                      fullIncoterm.findIndex(
                                        (item: any) => item.label === tempData?.incoterm1?.code
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                                  }}
                                  options={fullIncoterm}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-provinsi')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='provinsi'
                                  placeholder={t('pilih')}
                                  key={idSektor + produsen + fullProvince}
                                  defaultValue={
                                    fullProvince[
                                      fullProvince.findIndex(
                                        (item: any) => item.label === provinceDesc
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    setFullCity([])
                                    cityData(e?.value)
                                  }}
                                  options={fullProvince}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-jenis')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='jenis'
                                  onChange={(e: any) => productTypeChange(e.target.value)}
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-productType')}
                                  </option>
                                  {fullProductType.map((item: any) => {
                                    return (
                                      <>
                                        {item.id != 12 && (
                                          <>
                                            {item.material_group == tempData?.product_type ? (
                                              <option
                                                selected
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            ) : (
                                              <option
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('Kuantum Pengajuan')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <InputGroup size='sm'>
                                  <CurrencyInput
                                    className='form-control form-control-sm'
                                    id='kuantum'
                                    key={produsen}
                                    placeholder={t('Kuantum Pengajuan')}
                                    defaultValue={quantum}
                                    decimalSeparator={language === 'en' ? '.' : ','}
                                    groupSeparator={language === 'en' ? ',' : '.'}
                                    onValueChange={(value: any) => {
                                      setQuantum(value?.replace(/,/g, '.'))
                                    }}
                                    decimalsLimit={3}
                                  />
                                  <InputGroup.Text id='basic-addon2'>MT</InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('Shipping Tolerance')} </p>
                              </Col>
                              <Col sm={8}>
                                <InputGroup className='mb-3' size='sm'>
                                  <Form.Control
                                    placeholder={t('Shipping Tolerance')}
                                    type='number'
                                    id='shipping'
                                    defaultValue={shipping}
                                    onChange={(e: any) => setShipping(parseInt(e.target.value))}
                                  />
                                  <InputGroup.Text id='basic-addon2'>
                                    <span className='px-1'>%</span>
                                  </InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('sub-order-payment1')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='payment1'
                                  onChange={(e: any) =>
                                    separateValue(setPay1, e.target.value, setPay1Desc)
                                  }
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-payment')}
                                  </option>
                                  {fullPayment.map((item: any) => {
                                    return (
                                      <>
                                        {item.payment_desc == tempData?.payment_type_1_desc ? (
                                          <option
                                            selected
                                            value={item.code + '~#~' + item.payment_desc}
                                          >
                                            {item.payment_desc}
                                          </option>
                                        ) : (
                                          <option value={item.code + '~#~' + item.payment_desc}>
                                            {item.payment_desc}
                                          </option>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  as='textarea'
                                  defaultValue={tempData?.payment_note}
                                  placeholder={t('keterangan')}
                                  id='keterangan'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setketerangan(e.target.value)}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('End Customer')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  size='sm'
                                  as='textarea'
                                  id='enduser'
                                  placeholder={t('End Customer')}
                                  defaultValue={tempData.end_user}
                                  onChange={(e: any) => {
                                    setEnduser(e.target.value)
                                    setEnduserDesc(e.target.value)
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col md={6}>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-sektor')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                {localStorage.getItem('cust-group') != 'AR06' ? (
                                  <Form.Control
                                    type='text'
                                    size='sm'
                                    disabled
                                    value={t(tempData?.sector?.name)}
                                  />
                                ) : (
                                  <Form.Control type='text' size='sm' disabled value='Export' />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='incoterm2'
                                  placeholder={t('pilih')}
                                  key={idSektor + fullIncoterm2}
                                  defaultValue={
                                    fullIncoterm2[
                                      fullIncoterm2.findIndex(
                                        (item: any) => item.label === incoterm2Desc
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                                  }}
                                  options={fullIncoterm2}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-kota')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='kota'
                                  placeholder={t('pilih')}
                                  key={province + fullCity}
                                  isDisabled
                                  defaultValue={
                                    fullCity[
                                      fullCity.findIndex((item: any) => item.label === cityDesc)
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue2(setCity, e?.value, setCityDesc)
                                    // fieldClearer(4)
                                  }}
                                  options={fullCity}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('sub-order-produk')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='produk'
                                  placeholder={t('pilih')}
                                  key={ptype + fullProductName}
                                  defaultValue={
                                    fullProductName[
                                      fullProductName.findIndex(
                                        (item: any) =>
                                          item.truevalue == parseInt(tempData?.material_number)
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => productNameChange(e?.value)}
                                  options={fullProductName}
                                />
                              </Col>
                            </Row>
                            {pnumber == '0' && (
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('sub-order-catatan')}
                                    defaultValue={tempData?.notes}
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setNote(e.target.value)}
                                  />
                                </Col>
                              </Row>
                            )}
                            <Row className='mb-2'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>
                                  {t('Harga Pengajuan')}/MT<span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <InputGroup className='mb-3'>
                                  <InputGroup.Text>
                                    <span className='px-2'>USD</span>
                                  </InputGroup.Text>
                                  <CurrencyInput
                                    className='form-control form-control-sm'
                                    id='hargap'
                                    key={formulaPrice.toString() + produsen}
                                    defaultValue={subprice}
                                    disabled={formulaPrice}
                                    decimalSeparator={language === 'en' ? '.' : ','}
                                    groupSeparator={language === 'en' ? ',' : '.'}
                                    onValueChange={(value: any) => {
                                      setSubprice(value?.replace(/,/g, '.'))
                                    }}
                                    decimalsLimit={2}
                                    placeholder={t('Harga Pengajuan')}
                                  />
                                </InputGroup>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='mt-4 fs-6'>{t('termasuk-ppn')}</p>
                              </Col>
                              <Col sm={8} className='d-flex justify-content-start'>
                                <Form.Check
                                  reverse
                                  name='formula_Price'
                                  type='checkbox'
                                  onClick={() => {
                                    setFormulaPrice(!formulaPrice)
                                  }}
                                  defaultChecked={tempData.is_formulated_price}
                                  id='formula_Price'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  placeholder={t('sub-order-spek')}
                                  as='textarea'
                                  defaultValue={tempData?.product_spec}
                                  id='spek'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setPspec(e.target.value)}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='payment2'
                                  onChange={(e: any) =>
                                    separateValue(setPay2, e.target.value, setPay2Desc)
                                  }
                                >
                                  {/* <option selected hidden disabled>{t(tempData?.payment_type_2)}</option> */}
                                  <option value='~#~'>{t('Pilih-payment')}</option>
                                  {fullPayment.map((item: any) => {
                                    return (
                                      <>
                                        {item.payment_desc == tempData?.payment_type_2_desc ? (
                                          <option
                                            selected
                                            value={item.code + '~#~' + item.payment_desc}
                                          >
                                            {item.payment_desc}
                                          </option>
                                        ) : (
                                          <option value={item.code + '~#~' + item.payment_desc}>
                                            {item.payment_desc}
                                          </option>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                            {parseInt(pnumber) != 0 && (
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('sub-order-catatan')}
                                    defaultValue={tempData?.notes}
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setNote(e.target.value)}
                                  />
                                </Col>
                              </Row>
                            )}
                          </Col>
                        </Row>
                      </>
                    )}

                    {idSektor == 1 && (
                      <>
                        <Row>
                          <Col md={6}>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('kontrak-produsen')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='produsen'
                                  placeholder={t('pilih')}
                                  defaultValue={
                                    salesArea[
                                      salesArea.findIndex(
                                        (item: any) => item.label === tempData?.produsen?.name
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue3(
                                      setProdusen,
                                      e?.value,
                                      setDistribution,
                                      setProdusenDesc
                                    )
                                    fieldClearer(8)
                                  }}
                                  options={salesArea}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-incoterm1')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='incoterm1'
                                  placeholder={t('pilih')}
                                  key={idSektor + produsen + fullIncoterm}
                                  defaultValue={
                                    fullIncoterm[
                                      fullIncoterm.findIndex(
                                        (item: any) => item.label === incoterm1Desc
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                                  }}
                                  options={fullIncoterm}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-provinsi')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='provinsi'
                                  placeholder={t('pilih')}
                                  key={idSektor + produsen + fullProvince}
                                  defaultValue={
                                    fullProvince[
                                      fullProvince.findIndex(
                                        (item: any) => item.label === provinceDesc
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    setFullCity([])
                                    cityData(e?.value)
                                  }}
                                  options={fullProvince}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-jenis')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='jenis'
                                  onChange={(e: any) => productTypeChange(e.target.value)}
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-productType')}
                                  </option>
                                  {fullProductType.map((item: any) => {
                                    return (
                                      <>
                                        {item.id != 12 && (
                                          <>
                                            {item.material_group_desc ==
                                            tempData?.product_type_desc ? (
                                              <option
                                                selected
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            ) : (
                                              <option
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                            {parseInt(pnumber) == 0 && (
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6'>
                                    Custom Product Name<span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    placeholder=' Custom Product Name'
                                    size='sm'
                                    defaultValue={pname}
                                    aria-label='Default select example'
                                    type='text'
                                    id='custom'
                                    onChange={(e: any) => setPname(e.target.value)}
                                  />
                                </Col>
                              </Row>
                            )}
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('Kuantum Pengajuan')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <InputGroup size='sm'>
                                  <CurrencyInput
                                    className='form-control form-control-sm'
                                    id='kuantum'
                                    key={produsen}
                                    placeholder={t('Kuantum Pengajuan')}
                                    defaultValue={quantum}
                                    decimalSeparator={language === 'en' ? '.' : ','}
                                    groupSeparator={language === 'en' ? ',' : '.'}
                                    onValueChange={(value: any) => {
                                      setQuantum(value?.replace(/,/g, '.'))
                                    }}
                                    decimalsLimit={3}
                                  />
                                  <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Row>
                            <Row className='mb-2'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('Shipping Tolerance')}</p>
                              </Col>
                              <Col sm={8}>
                                <InputGroup size='sm'>
                                  <Form.Control
                                    placeholder={t('Shipping Tolerance')}
                                    type='number'
                                    id='shipping'
                                    defaultValue={shipping}
                                    onChange={(e: any) => setShipping(parseInt(e.target.value))}
                                  />
                                  <InputGroup.Text id='basic-addon2'>
                                    <span className='px-2'>%</span>
                                  </InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('sub-order-payment1')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='payment1'
                                  onChange={(e: any) =>
                                    separateValue(setPay1, e.target.value, setPay1Desc)
                                  }
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-payment')}
                                  </option>
                                  {fullPayment.map((item: any) => {
                                    return (
                                      <>
                                        {item.code == tempData?.payment_type_1 ? (
                                          <option
                                            selected
                                            value={item.code + '~#~' + item.payment_desc_id}
                                          >
                                            {item.payment_desc_id}
                                          </option>
                                        ) : (
                                          <option value={item.code + '~#~' + item.payment_desc_id}>
                                            {item.payment_desc_id}
                                          </option>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  as='textarea'
                                  defaultValue={tempData?.payment_note}
                                  placeholder={t('keterangan')}
                                  id='keterangan'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setketerangan(e.target.value)}
                                />
                              </Col>
                            </Row>
                            {parseInt(pnumber) != 0 && (
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('segment')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col md={8}>
                                  <Form.Select
                                    size='sm'
                                    id='segment'
                                    onChange={(e: any) =>
                                      separateValue(setSegment, e.target.value, setSegmentDesc)
                                    }
                                    aria-label='Default select example'
                                  >
                                    {fullSegment.map((item: any) => {
                                      if (item.code == 'Z2' || item.code == 'Z3') {
                                        if (item.code == segment) {
                                          return (
                                            <option selected value={item.code + '~#~' + item.name}>
                                              {item.name}
                                            </option>
                                          )
                                        } else {
                                          return (
                                            <option value={item.code + '~#~' + item.name}>
                                              {item.name}
                                            </option>
                                          )
                                        }
                                      } else {
                                        return null
                                      }
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                            )}
                            <Row className='mb-1'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('End Customer')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                {isNoEnduser ? (
                                  <Form.Control
                                    size='sm'
                                    as='textarea'
                                    id='enduser'
                                    placeholder={t('End Customer')}
                                    defaultValue={tempData.end_user}
                                    onChange={(e: any) => {
                                      setEnduser(e.target.value)
                                      setEnduserDesc(e.target.value)
                                    }}
                                  />
                                ) : (
                                  <MultiSelect
                                    options={fullEndUser?.map((item: any) => {
                                      return {label: t(item.name), value: item.name}
                                    })}
                                    value={arrayEnduser}
                                    onChange={(e: any) => setEnduserArray(e)}
                                    labelledBy='Select'
                                  />
                                  // <Form.Select
                                  //   size='sm'
                                  //   aria-label='Default select example'
                                  //   id='enduser2'
                                  //   onChange={(e: any) =>
                                  //     separateValue4(e.target.value, setEnduser, setEnduserDesc)
                                  //   }
                                  // >
                                  //   <option selected value={0 + '~#~'}>
                                  //     {t('pilih')} {t('End Customer')}
                                  //   </option>
                                  //   {fullEndUser.map((item: any) => {
                                  //     return (
                                  //       <>
                                  //         {item.name == enduserDesc ? (
                                  //           <option
                                  //             selected
                                  //             value={item.end_user_code + '~#~' + item.name}
                                  //           >
                                  //             {t(item.name)}
                                  //           </option>
                                  //         ) : (
                                  //           <option value={item.end_user_code + '~#~' + item.name}>
                                  //             {t(item.name)}
                                  //           </option>
                                  //         )}
                                  //       </>
                                  //     )
                                  //   })}
                                  // </Form.Select>
                                )}
                              </Col>
                            </Row>
                            {!isRetail(idSektor) && (
                              <Row className='mb-4'>
                                <Col sm={4}></Col>
                                <Col sm={8} className='d-flex'>
                                  <Form.Check
                                    onClick={() => setIsNoEnduser(!isNoEnduser)}
                                    defaultChecked={isNoEnduser}
                                    // disabled={ptype == 'P13'}
                                    name='ppn'
                                    id='noenduser'
                                    className='mt-4 mb-2'
                                    type='checkbox'
                                  />
                                  {i18next.language == 'en' ? (
                                    <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                  ) : (
                                    <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                  )}
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <Col md={6}>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-sektor')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  size='sm'
                                  aria-label='Default select example'
                                  id='sektor'
                                  disabled
                                  value={tempData?.sector?.name}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='incoterm2'
                                  placeholder={t('pilih')}
                                  key={idSektor + produsen + fullIncoterm2}
                                  defaultValue={
                                    fullIncoterm2[
                                      fullIncoterm2.findIndex(
                                        (item: any) => item.label === incoterm2Desc
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                                  }}
                                  options={fullIncoterm2}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-kota')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='kota'
                                  placeholder={t('pilih')}
                                  key={province + fullCity}
                                  defaultValue={
                                    fullCity[
                                      fullCity.findIndex((item: any) => item.label === cityDesc)
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue2(setCity, e?.value, setCityDesc)
                                  }}
                                  options={fullCity}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('sub-order-produk')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='produk'
                                  placeholder={t('pilih')}
                                  key={ptype + fullProductName}
                                  defaultValue={
                                    fullProductName[
                                      fullProductName.findIndex(
                                        (item: any) => item.truevalue == parseInt(pnumber)
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    // setQuantum(0)
                                    // setSubprice(0)
                                    productNameChange(e?.value)
                                  }}
                                  options={fullProductName}
                                />
                              </Col>
                            </Row>
                            {pnumber == '0' && (
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('sub-order-catatan')}
                                    defaultValue={tempData?.notes}
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setNote(e.target.value)}
                                  />
                                </Col>
                              </Row>
                            )}
                            <Row className='mb-2'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>
                                  {t('Harga Pengajuan')}/Ton<span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <InputGroup size='sm'>
                                  <InputGroup.Text>
                                    <span className='px-1'>Rp</span>
                                  </InputGroup.Text>
                                  <CurrencyInput
                                    className='form-control form-control-sm'
                                    id='hargap'
                                    key={formulaPrice.toString() + produsen}
                                    defaultValue={subprice}
                                    disabled={formulaPrice}
                                    decimalSeparator={language === 'en' ? '.' : ','}
                                    groupSeparator={language === 'en' ? ',' : '.'}
                                    onValueChange={(value: any) => {
                                      setSubprice(value?.replace(/,/g, '.'))
                                    }}
                                    decimalsLimit={-1}
                                    placeholder={t('Harga Pengajuan')}
                                  />
                                </InputGroup>
                              </Col>
                            </Row>

                            <Row className='my-7'>
                              <Col sm={6} className='d-flex '>
                                <Row sm={8} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('termasuk-ppn')}</p>
                                </Row>
                                <Row
                                  sm={4}
                                  className='d-flex justify-content-start align-items-center ms-4'
                                >
                                  <Form.Check
                                    reverse
                                    name='ppn'
                                    type='checkbox'
                                    id='ckbox-ppn'
                                    defaultChecked={tempData?.include_ppn}
                                  />
                                </Row>
                              </Col>
                              <Col sm={6} className='d-flex'>
                                <Row sm={8} className='d-flex align-items-center'>
                                  <p className=' fs-6'>{t('Formulated Price')}</p>
                                </Row>
                                <Row
                                  sm={4}
                                  className='d-flex justify-content-start align-items-center ms-4'
                                >
                                  <Form.Check
                                    reverse
                                    name='formula_Price'
                                    type='checkbox'
                                    onClick={() => {
                                      setFormulaPrice(!formulaPrice)
                                    }}
                                    defaultChecked={tempData.is_formulated_price}
                                    id='formula_Price'
                                  />
                                </Row>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='payment2'
                                  onChange={(e: any) =>
                                    separateValue(setPay2, e.target.value, setPay2Desc)
                                  }
                                >
                                  <option value='~#~'>{t('Pilih-payment')}</option>
                                  {fullPayment.map((item: any) => {
                                    return (
                                      <>
                                        {item.code == tempData?.payment_type_2 ? (
                                          <option
                                            selected
                                            value={item.code + '~#~' + item.payment_desc_id}
                                          >
                                            {item.payment_desc_id}
                                          </option>
                                        ) : (
                                          <option value={item.code + '~#~' + item.payment_desc_id}>
                                            {item.payment_desc_id}
                                          </option>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  placeholder={t('sub-order-spek')}
                                  as='textarea'
                                  defaultValue={tempData?.product_spec}
                                  id='spek'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setPspec(e.target.value)}
                                />
                              </Col>
                            </Row>
                            {parseInt(pnumber) != 0 && (
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('sub-order-catatan')}
                                    defaultValue={tempData?.notes}
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setNote(e.target.value)}
                                  />
                                </Col>
                              </Row>
                            )}
                            {parseInt(pnumber) == 0 && (
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>
                                    {t('segment')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col md={8}>
                                  <Form.Select
                                    size='sm'
                                    id='segment'
                                    onChange={(e: any) =>
                                      separateValue(setSegment, e.target.value, setSegmentDesc)
                                    }
                                    aria-label='Default select example'
                                  >
                                    {fullSegment.map((item: any) => {
                                      if (item.code == 'Z2' || item.code == 'Z3') {
                                        if (item.code == segment) {
                                          return (
                                            <option selected value={item.code + '~#~' + item.name}>
                                              {item.name}
                                            </option>
                                          )
                                        } else {
                                          return (
                                            <option value={item.code + '~#~' + item.name}>
                                              {item.name}
                                            </option>
                                          )
                                        }
                                      } else {
                                        return null
                                      }
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                            )}
                          </Col>
                        </Row>
                      </>
                    )}

                    {isRetail(idSektor) && (
                      <>
                        <Row>
                          <Col md={6}>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('kontrak-produsen')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='produsen'
                                  placeholder={t('pilih')}
                                  defaultValue={
                                    salesArea[
                                      salesArea.findIndex(
                                        (item: any) => item.label === tempData?.produsen?.name
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue3(
                                      setProdusen,
                                      e?.value,
                                      setDistribution,
                                      setProdusenDesc
                                    )
                                    fieldClearer(8)
                                  }}
                                  options={salesArea}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-incoterm1')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='incoterm1'
                                  placeholder={t('pilih')}
                                  key={idSektor + fullIncoterm}
                                  defaultValue={
                                    fullIncoterm[
                                      fullIncoterm.findIndex(
                                        (item: any) => item.label === tempData?.incoterm1?.code
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                                  }}
                                  options={fullIncoterm}
                                />
                              </Col>
                            </Row>

                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('destination-city')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='kota'
                                  placeholder={t('pilih')}
                                  key={provinceDesc + fullCity}
                                  defaultValue={
                                    fullCity[
                                      fullCity.findIndex((item: any) => item.label === cityDesc)
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue2(setCity, e?.value, setCityDesc)
                                    // fieldClearer(4)
                                  }}
                                  options={fullCity}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-jenis')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='jenis'
                                  onChange={(e: any) => productTypeChange(e.target.value)}
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-productType')}
                                  </option>
                                  {fullProductType.map((item: any) => {
                                    return (
                                      <>
                                        {item.id != 12 && (
                                          <>
                                            {item.material_group == tempData?.product_type ? (
                                              <option
                                                selected
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            ) : (
                                              <option
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                            
                            {/* <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('destination-province')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='destinationProvince'
                                  placeholder={t('pilih')}
                                  key={idSektor + fullIncoterm}
                                  defaultValue={fullProvinceDest.filter(
                                    (item: any) => parseInt(item.value.split('~#~')[0]) === tempData?.province_dest_id
                                  )}
                                  onChange={(e: any) => {
                                    changeDestinationProvince(e?.value)
                                  }}
                                  options={fullProvinceDest}
                                />
                              </Col>
                            </Row> */}

                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('Kuantum Pengajuan')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <InputGroup size='sm'>
                                  <CurrencyInput
                                    className='form-control form-control-sm'
                                    id='kuantum'
                                    key={produsen}
                                    placeholder={t('Kuantum Pengajuan')}
                                    defaultValue={quantum}
                                    decimalSeparator={language === 'en' ? '.' : ','}
                                    groupSeparator={language === 'en' ? ',' : '.'}
                                    onValueChange={(value: any) => {
                                      setQuantum(value?.replace(/,/g, '.'))
                                    }}
                                    decimalsLimit={3}
                                  />
                                  <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-payment1')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='payment1'
                                  onChange={(e: any) =>
                                    separateValue(setPay1, e.target.value, setPay1Desc)
                                  }
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-payment')}
                                  </option>
                                  {fullPayment.map((item: any) => {
                                    return (
                                      <>
                                        {item.payment_desc_id == tempData?.payment_type_1_desc ? (
                                          <option
                                            selected
                                            value={item.code + '~#~' + item.payment_desc_id}
                                          >
                                            {item.payment_desc_id}
                                          </option>
                                        ) : (
                                          <option value={item.code + '~#~' + item.payment_desc_id}>
                                            {item.payment_desc_id}
                                          </option>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('keterangan')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  as='textarea'
                                  defaultValue={tempData?.payment_note}
                                  placeholder={t('keterangan')}
                                  id='keterangan'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setketerangan(e.target.value)}
                                />
                              </Col>
                            </Row>
                            {idSektor == 4 && (
                              <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('commodity')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Select
                                      key={idSektor + produsen}
                                      placeholder={t('pilih')}
                                      id='commodities'
                                      onChange={(e: any) => setCommodity(e.value)}
                                      defaultValue={commodities.find((item: any) => item?.value == tempData?.commodity)}
                                      options={commodities}
                                      menuPlacement='top'
                                    />
                                  </Col>
                              </Row>
                            )}
                          </Col>
                          <Col md={6}>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('sub-order-sektor')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                {localStorage.getItem('cust-group') != 'AR06' ? (
                                  <Form.Control
                                    type='text'
                                    size='sm'
                                    disabled
                                    value={t(tempData?.sector?.name)}
                                  />
                                ) : (
                                  <Form.Control type='text' size='sm' disabled value='Export' />
                                )}
                              </Col>
                            </Row>
                            <Row className='mb-4' hidden={isRetail(tempData?.sector_id) ? true : false}>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>{t('sub-order-incoterm2')}</p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='incoterm2'
                                  placeholder={t('pilih')}
                                  key={idSektor + fullIncoterm2}
                                  defaultValue={
                                    fullIncoterm2[
                                      fullIncoterm2.findIndex(
                                        (item: any) => item.label === incoterm2Desc
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                                  }}
                                  options={fullIncoterm2}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('destination-province')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='provinsi'
                                  placeholder={t('pilih')}
                                  key={idSektor + fullProvince}
                                  defaultValue={
                                    fullProvince[
                                      fullProvince.findIndex(
                                        (item: any) =>
                                          item.label === tempData?.province?.region_name
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    setFullCity([])
                                    cityData(e?.value)
                                    separateValue2(setProvince, e.value, setProvinceDesc)
                                  }}
                                  options={fullProvince}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('pickup-plant')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='gudang'
                                  placeholder={t('pilih')}
                                  key={province + city + fullPlant}
                                  defaultValue={
                                    fullPlant[
                                      fullPlant.findIndex(
                                        (item: any) =>
                                          item.label === warehouse + '-' + warehouseDesc
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => plantChange(e?.value)}
                                  options={fullPlant}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='mt-3'>
                                  {t('sub-order-produk')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='produk'
                                  placeholder={t('pilih')}
                                  key={ptype + fullProductName}
                                  defaultValue={
                                    fullProductName[
                                      fullProductName.findIndex(
                                        (item: any) => item.truevalue == parseInt(pnumber)
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    // setQuantum(0)
                                    // setSubprice(0)
                                    productNameChange(e?.value)
                                  }}
                                  options={fullProductName}
                                />
                              </Col>
                            </Row>

                             {/* <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>
                                  {t('destination-city')}
                                  <span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='destination-city'
                                  placeholder={t('pilih')}
                                  key={destinationProvince + fullDestinationCity}
                                  defaultValue={
                                    fullDestinationCity[
                                      fullDestinationCity.findIndex(
                                        (item: any) => item.value.split('~#~')[0] == tempData?.city_dest_id
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    separateValue2(setDestinationCity, e?.value, setDestinationCityDesc)
                                    // fieldClearer(4)
                                  }}
                                  options={fullDestinationCity}
                                />
                              </Col>
                            </Row> */}
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-spek')}
                                {/* <span className='text-danger'>*</span> */}
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  placeholder={t('sub-order-spek')}
                                  as='textarea'
                                  defaultValue={tempData?.product_spec}
                                  id='spek'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setPspec(e.target.value)}
                                />
                              </Col>
                            </Row>
                           
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('Price')}/Ton<span className='text-danger'>*</span>
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  placeholder={t('Price')}
                                  size='sm'
                                  key={pnumber}
                                  type='text'
                                  value={
                                    'Rp ' + (i18next.language === 'en'
                                      ? parseInt(subprice).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseInt(subprice).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }))
                                  }
                                  id='hargap'
                                  disabled
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4' hidden={isRetail(tempData?.sector_id) ? true : false}>
                              <Col sm={4}>
                                <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='payment2'
                                  onChange={(e: any) =>
                                    separateValue(setPay2, e.target.value, setPay2Desc)
                                  }
                                >
                                  {/* <option selected hidden disabled>{t(tempData?.payment_type_2)}</option> */}
                                  <option value='~#~'>{t('Pilih-payment')}</option>
                                  {fullPayment.map((item: any) => {
                                    return (
                                      <>
                                        {item.payment_desc_id == tempData?.payment_type_2_desc ? (
                                          <option
                                            selected
                                            value={item.code + '~#~' + item.payment_desc_id}
                                          >
                                            {item.payment_desc_id}
                                          </option>
                                        ) : (
                                          <option value={item.code + '~#~' + item.payment_desc_id}>
                                            {item.payment_desc_id}
                                          </option>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('sub-order-catatan')}
                                  defaultValue={tempData?.notes}
                                  id='note'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setNote(e.target.value)}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202' ? (
                      <>
                        <Row>
                          <Col md={6}>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  aria-label='Default select example'
                                  size='sm'
                                  id='produsen'
                                  onChange={(e: any) => {
                                    const code = e.target.value.split('~#~')
                                    setTempEdit((state: any) => ({
                                      ...state,
                                      produsen: {...state.code, code: code[0], name: code[1]},
                                      request_price: 0,
                                      request_quantum: 0,
                                      product_name: '0',
                                      material_number: null,
                                      include_ppn: false,
                                    }))
                                    setPname('')
                                    setProdusenCode(code[0])
                                    setPnumber('')
                                    setProdusen(code[0])
                                    setIsProdusen(!isProdusen)
                                    fieldClearer(1)
                                  }}
                                >
                                  {fullProdusen.map((items: any) => (
                                    <>
                                      {tempEdit.produsen?.name == items.label ? (
                                        <option value={items.value} selected>
                                          {items.label}
                                        </option>
                                      ) : (
                                        <option value={items.value}>{items.label}</option>
                                      )}
                                    </>
                                  ))}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>Incoterm</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  aria-label='Default select example'
                                  size='sm'
                                  id='incoterm1'
                                  key={idSektor + produsen + fullIncoterm}
                                  onChange={(e: any) => {
                                    const code = e.target.value.split('~#~')
                                    setTempEdit((state: any) => ({
                                      ...state,
                                      incoterm1: {...state.incoterm1, code: code[1], id: code[0]},
                                    }))
                                    separateValue2(setIncoterm1, e.target.value, setIncoterm1Desc)
                                  }}
                                >
                                  <option value='0'>
                                    {t('pilih')} {t('sub-order-incoterm1')}
                                  </option>
                                  {fullIncoterm.map((items: any) => (
                                    <>
                                      {tempEdit.incoterm1?.code == items.label ? (
                                        <option value={items.value} selected>
                                          {items.label}
                                        </option>
                                      ) : (
                                        <option value={items.value}>{items.label}</option>
                                      )}
                                    </>
                                  ))}
                                </Form.Select>
                              </Col>
                            </Row>

                            <Row className='mb-4' hidden={sektorID == 3 ? true : false}>
                              <Col sm={4}>
                                <p className='mt-3 fs-6'>
                                  {t('sub-order-provinsi')}
                                  <span className='text-danger'>*</span>{' '}
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='provinsi'
                                  key={idSektor + produsen}
                                  placeholder={t('pilih')}
                                  defaultValue={
                                    fullProvince[
                                      fullProvince.findIndex(
                                        (item: any) => item.label === provinceDesc
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    setFullCity([])
                                    cityData(e?.value)
                                  }}
                                  options={fullProvince}
                                />
                              </Col>
                            </Row>

                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='jenis'
                                  onChange={(e: any) => {
                                    const tmp = e.target.value.split('~#~')
                                    setTempEdit((state: any) => ({
                                      ...state,
                                      product_name: '',
                                      product_type_desc: tmp[0],
                                      product_type: tmp[1],
                                    }))
                                    productTypeChange(e.target.value)
                                  }}
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-productType')}
                                  </option>
                                  {fullProductType.map((item: any) => {
                                    return (
                                      <>
                                        {item.id != 12 && (
                                          <>
                                            {item.material_group_desc ==
                                            tempEdit?.product_type_desc ? (
                                              <option
                                                selected
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            ) : (
                                              <option
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>

                            {parseInt(pnumber) == 0 && (
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('sub-order-catatan')}
                                    defaultValue={tempEdit?.notes}
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => {
                                      setTempEdit((state: any) => ({
                                        ...state,
                                        notes: e.target.value,
                                      }))
                                      setNote(e.target.value)
                                    }}
                                  />
                                </Col>
                              </Row>
                            )}

                            <Row className='mb-4'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col sm={8}>
                                <InputGroup size='sm'>
                                  <CurrencyInput
                                    className='form-control form-control-sm'
                                    id='kuantum'
                                    key={change.toString() + produsen}
                                    defaultValue={tempEdit?.request_quantum}
                                    decimalSeparator={language === 'en' ? '.' : ','}
                                    groupSeparator={language === 'en' ? ',' : '.'}
                                    onValueChange={(value: any) => {
                                      setTempEdit((state: any) => ({
                                        ...state,
                                        request_quantum: value?.replace(/,/g, '.'),
                                      }))
                                      setQuantum(value?.replace(/,/g, '.'))
                                    }}
                                    decimalsLimit={3}
                                  />
                                  <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Row>

                            <Row>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-endUser')}</p>
                              </Col>
                              <Col sm={8}>
                                {isNoEnduser || idSektor == 3 ? (
                                  <Form.Control
                                    size='sm'
                                    as='textarea'
                                    id='enduser'
                                    style={{height: '40px'}}
                                    placeholder={t('End Customer')}
                                    defaultValue={
                                      tempEdit?.end_user_multiple ? '' : tempEdit?.end_user
                                    }
                                    onChange={(e: any) => {
                                      setTempEdit((state: any) => ({
                                        ...state,
                                        end_user: e.target.value,
                                        end_user_multiple: false,
                                      }))
                                      setEnduser(e.target.value)
                                      setEnduserDesc(e.target.value)
                                    }}
                                  />
                                ) : (
                                  <MultiSelect
                                    options={fullEndUser?.map((item: any) => {
                                      return {label: t(item.name), value: item.name}
                                    })}
                                    value={arrayEnduser}
                                    onChange={(e: any) => {
                                      let user = handleUser(e)
                                      setEnduserArray(e)
                                      setTempEdit((state: any) => ({
                                        ...state,
                                        end_user: user.toString(),
                                        end_user_multiple: true,
                                      }))
                                    }}
                                    labelledBy='Select'
                                  />
                                )}
                              </Col>
                            </Row>

                            {idSektor == 1 && (
                              <Row className='mb-4'>
                                <Col sm={4}></Col>
                                <Col sm={8} className='d-flex'>
                                  <Form.Check
                                    onClick={() => setIsNoEnduser(!isNoEnduser)}
                                    defaultChecked={isNoEnduser}
                                    disabled={disableCKBOX}
                                    name='ppn'
                                    id='noenduser'
                                    className='mt-4 mb-2'
                                    type='checkbox'
                                  />
                                  {i18next.language == 'en' ? (
                                    <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                  ) : (
                                    <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                  )}
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <Col md={6}>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  value={t(tempEdit.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('sub-order-catatan')}
                                  defaultValue={tempEdit?.notes}
                                  id='note'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => {
                                    setTempEdit((state: any) => ({...state, notes: e.target.value}))
                                    setNote(e.target.value)
                                  }}
                                />
                              </Col>
                            </Row>

                            {tempEdit?.sector_id != 3 ? (
                              <>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Select
                                      id='kota'
                                      placeholder={t('pilih')}
                                      key={province}
                                      defaultValue={
                                        fullCity[
                                          fullCity.findIndex(
                                            (item: any) => item.label === tempEdit.city?.city_name
                                          )
                                        ]
                                      }
                                      onChange={(e: any) => {
                                        const tmp = e.value.split('~#~')
                                        setTempEdit((state: any) => ({
                                          ...state,
                                          city_id: tmp[0],
                                          city: {...state.city, id: tmp[0], city_name: tmp[1]},
                                        }))
                                        setCity(tmp[0])
                                        setCityDesc(tmp[1])
                                        // fieldClearer(4)
                                      }}
                                      options={fullCity}
                                    />
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              ''
                            )}
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='nama'
                                  placeholder={t('pilih')}
                                  key={ptype + tempEdit.material_number + fullProductName}
                                  defaultValue={
                                    fullProductName[
                                      fullProductName.findIndex(
                                        (item: any) =>
                                          item.truevalue == parseInt(tempEdit?.material_number)
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    // productNameChange(e.target.value)
                                    const tmp = e.value.split('~#~')
                                    const productName = tmp[1]
                                    setTempEdit((state: any) => ({
                                      ...state,
                                      material_number: tmp[0],
                                      unit: tmp[2],
                                      product_name: productName,
                                    }))
                                    setPnumber(tmp[0])
                                    setPunit(tmp[2])
                                    setPname(productName)
                                    // fieldClearer(1)
                                  }}
                                  options={fullProductName}
                                />
                              </Col>
                            </Row>

                            {parseInt(pnumber) == 0 && (
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6'>Custom Product Name</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    placeholder=' Custom Product Name'
                                    size='sm'
                                    defaultValue={pname}
                                    aria-label='Default select example'
                                    type='text'
                                    id='custom'
                                    onChange={(e: any) => setPname(e.target.value)}
                                  />
                                </Col>
                              </Row>
                            )}

                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('Harga Pengajuan')}/{tempEdit.sector_id === 3 ? 'MT' : 'Ton'}
                                </p>
                              </Col>
                              <Col sm={8}>
                                {tempEdit.sector_id != 3 ? (
                                  <InputGroup size='sm'>
                                    <InputGroup.Text>
                                      <span className='px-1'>Rp</span>
                                    </InputGroup.Text>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='hargap'
                                      key={change.toString() + produsen}
                                      defaultValue={tempEdit?.request_price}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value: any) => {
                                        setTempEdit((state: any) => ({
                                          ...state,
                                          request_price: value?.replace(/,/g, '.'),
                                        }))
                                        setSubprice(value?.replace(/,/g, '.'))
                                      }}
                                      decimalsLimit={-1}
                                      placeholder={t('Harga Pengajuan')}
                                    />
                                  </InputGroup>
                                ) : (
                                  <InputGroup size='sm'>
                                    <InputGroup.Text>
                                      <span className='px-1'>MT</span>
                                    </InputGroup.Text>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='hargap'
                                      key={change.toString() + produsen}
                                      defaultValue={tempEdit?.request_price}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value: any) => {
                                        setTempEdit((state: any) => ({
                                          ...state,
                                          request_price: value?.replace(/,/g, '.'),
                                        }))
                                        setSubprice(value?.replace(/,/g, '.'))
                                      }}
                                      decimalsLimit={2}
                                      placeholder={t('Harga Pengajuan')}
                                    />
                                  </InputGroup>
                                )}
                              </Col>
                            </Row>

                            {tempEdit?.sector_id != 3 ? (
                              <>
                                <Row className='my-7'>
                                  <Col sm={4} className='d-flex align-items-center'>
                                    <p className='fs-6'>{t('termasuk-ppn')}</p>
                                  </Col>
                                  <Col
                                    sm={8}
                                    className='d-flex justify-content-start align-items-center'
                                  >
                                    <Form.Check
                                      reverse
                                      name='ppn'
                                      type='checkbox'
                                      id='ckbox-ppn'
                                      defaultChecked={tempEdit?.include_ppn}
                                      onClick={() => {
                                        setTempEdit((state: any) => ({
                                          ...state,
                                          include_ppn: !state.include_ppn,
                                        }))
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row className='mb-3'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              aria-label='Default select example'
                              size='sm'
                              id='produsen'
                              onChange={(e: any) => {
                                const code = e.target.value.split('~#~')
                                setTempEdit((state: any) => ({
                                  ...state,
                                  produsen: {...state.code, code: code[0], name: code[1]},
                                }))
                                fieldClearer(1)
                                setProdusenCode(code[0])
                                setIsProdusen(!isProdusen)
                              }}
                            >
                              {fullProdusen.map((items: any) => (
                                <>
                                  {tempEdit.produsen?.name == items.label ? (
                                    <option value={items.value} selected>
                                      {items.label}
                                    </option>
                                  ) : (
                                    <option value={items.value}>{items.label}</option>
                                  )}
                                </>
                              ))}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col sm={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              value={t(tempEdit.sector?.name)}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='jenis'
                              onChange={(e: any) => {
                                const tmp = e.target.value.split('~#~')
                                setTempEdit((state: any) => ({
                                  ...state,
                                  product_name: '',
                                  product_type_desc: tmp[0],
                                  product_type: tmp[1],
                                }))
                                productTypeChange(e.target.value)
                              }}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-productType')}
                              </option>
                              {fullProductType.map((item: any) => {
                                return (
                                  <>
                                    {item.id != 12 && (
                                      <>
                                        {item.material_group_desc == tempEdit?.product_type_desc ? (
                                          <option
                                            selected
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        ) : (
                                          <option
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        )}
                                      </>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-4 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='nama'
                              placeholder={t('pilih')}
                              key={ptype + fullProductName}
                              defaultValue={
                                fullProductName[
                                  fullProductName.findIndex(
                                    (item: any) =>
                                      item.truevalue == parseInt(tempEdit?.material_number)
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                // productNameChange(e.target.value)
                                const tmp = e.value.split('~#~')
                                const productName = tmp[1]
                                setTempEdit((state: any) => ({
                                  ...state,
                                  material_number: tmp[0],
                                  unit: tmp[2],
                                  product_name: productName,
                                }))
                                setPnumber(tmp[0])
                                setPunit(tmp[2])
                                setPname(productName)
                                // fieldClearer(1)
                              }}
                              options={fullProductName}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              as='textarea'
                              placeholder={t('sub-order-catatan')}
                              defaultValue={tempEdit?.notes}
                              id='note'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => {
                                setTempEdit((state: any) => ({...state, notes: e.target.value}))
                                setNote(e.target.value)
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-endUser')}</p>
                          </Col>
                          <Col sm={8}>
                            {isNoEnduser || idSektor == 3 ? (
                              <Form.Control
                                size='sm'
                                as='textarea'
                                id='enduser'
                                style={{height: '40px'}}
                                placeholder={t('End Customer')}
                                defaultValue={tempEdit?.end_user_multiple ? '' : tempEdit?.end_user}
                                onChange={(e: any) => {
                                  setTempEdit((state: any) => ({
                                    ...state,
                                    end_user: e.target.value,
                                    end_user_multiple: false,
                                  }))
                                  setEnduser(e.target.value)
                                  setEnduserDesc(e.target.value)
                                }}
                              />
                            ) : (
                              <MultiSelect
                                options={fullEndUser?.map((item: any) => {
                                  return {label: t(item.name), value: item.name}
                                })}
                                value={arrayEnduser}
                                onChange={(e: any) => {
                                  let user = handleUser(e)
                                  setEnduserArray(e)
                                  setTempEdit((state: any) => ({
                                    ...state,
                                    end_user: user.toString(),
                                    end_user_multiple: true,
                                  }))
                                }}
                                labelledBy='Select'
                              />
                            )}
                          </Col>
                        </Row>

                        {idSektor == 1 && (
                          <Row className='mb-4'>
                            <Col sm={4}></Col>
                            <Col sm={8} className='d-flex'>
                              <Form.Check
                                onClick={() => setIsNoEnduser(!isNoEnduser)}
                                defaultChecked={isNoEnduser}
                                disabled={disableCKBOX}
                                name='ppn'
                                className='mt-4 mb-2'
                                id='noenduser'
                                type='checkbox'
                              />
                              {i18next.language == 'en' ? (
                                <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                              ) : (
                                <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                              )}
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </>
                )}

                <div className='d-flex justify-content-end mt-5'>
                  <Button variant='primary' onClick={() => editOrderRevisi()} disabled={btnLoading}>
                    {btnLoading ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      <>
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr075.svg'
                          className='svg-icon-3'
                        />
                        {t('order-kirim')}
                      </>
                    )}
                  </Button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        {/* modal detail */}
        <Modal
          show={show}
          onHide={() => {
            handleClose()
            clearState()
          }}
          centered
          backdrop='static'
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadDetail ? (
              <>
                <SkeletonModal />
              </>
            ) : (
              <>
                {showPurchaseForm ? (
                  <>
                    {is_amendment == 'true' ? (
                      <>
                        {tempDetail.sector_id == 1 && (
                          <Row>
                            <Col md='6'>
                              <h5 className='mb-3 text-danger'>{t('Before')}</h5>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>Sales Org</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2?.produsen?.name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(tempData2?.sector?.name)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2?.incoterm1?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col md={8}>
                                  {tempData2?.incoterm2 == null ? (
                                    <Form.Control
                                      value={
                                        tempData2?.incoterm2_id == null ||
                                        tempData2?.incoterm2_id == '0'
                                          ? ''
                                          : tempData2?.incoterm2_id
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  ) : (
                                    <Form.Control
                                      value={tempData2?.incoterm2?.code}
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={tempData2.province?.region_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={tempData2.city?.city_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('segment')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={t(tempData2?.segment_name)}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2.product_type_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2.product_name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                                </Col>
                                <Col md={8}>
                                  {tempData2.so_qty_realized == undefined ? (
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? parseFloat(tempData2?.fixed_quantum).toLocaleString(
                                              'en',
                                              {
                                                maximumFractionDigits: 4,
                                              }
                                            ) + ' Ton'
                                          : parseFloat(tempData2?.fixed_quantum).toLocaleString(
                                              'id',
                                              {
                                                maximumFractionDigits: 4,
                                              }
                                            ) + ' Ton'
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  ) : (
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? (
                                              parseFloat(tempData2.fixed_quantum) -
                                              parseFloat(tempData2.so_qty_realized)
                                            ).toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                          : (
                                              parseFloat(tempData2.fixed_quantum) -
                                              parseFloat(tempData2.so_qty_realized)
                                            ).toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' Ton'
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-2'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/Ton</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      'Rp ' + (i18next.language === 'en'
                                        ? parseInt(tempData2?.fixed_price).toLocaleString('en') +
                                          '/Ton'
                                        : parseInt(tempData2?.fixed_price).toLocaleString('id') +
                                          '/Ton')
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-4 fs-6'>{t('termasuk-ppn')}</p>
                                </Col>
                                <Col sm={8} className='d-flex justify-content-start'>
                                  <Form.Check
                                    reverse
                                    name='ppn'
                                    className='mt-5 mb-2'
                                    type='checkbox'
                                    id='ckbox-ppn'
                                    checked={tempData2?.include_ppn}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                </Col>
                                <Col sm={8} className='d-flex justify-content-start'>
                                  <Form.Control
                                    disabled
                                    type='text'
                                    size='sm'
                                    value={
                                      tempData2?.shipping_tolerance == 0
                                        ? ''
                                        : tempData2?.shipping_tolerance + '%'
                                    }
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2?.payment_type_1_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2?.payment_type_2_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  {i18next.language === 'en' ? (
                                    <p className='mt-3 fs-6'>{t('keterangan')}</p>
                                  ) : (
                                    <p className='fs-6'>{t('keterangan')}</p>
                                  )}
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2?.payment_note}
                                    type='text'
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2.product_spec}
                                    type='text'
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      tempData2?.end_user_multiple
                                        ? handleShowValue(
                                            tempData2?.end_user,
                                            tempData2?.end_user_multiple
                                          )
                                        : tempData2?.end_user
                                    }
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2?.notes}
                                    as='textarea'
                                    style={{height: '40px'}}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              { !isRetail(tempData?.sector_id) && <>
                                <Row
                                  className='mb-4'
                                  hidden={tempData?.amandement_notes == null ? true : false}
                                >
                                  <Col md={4}>
                                    <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('alasan perpanjangan')}
                                      defaultValue={tempData?.amandement_notes}
                                      disabled
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  className='mb-4'
                                  hidden={tempData?.extension_date == null ? true : false}
                                >
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('tanggal perpanjangan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      defaultValue={tempData?.extension_date}
                                      style={{height: '40px'}}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </> }
                            </Col>
                            <Col md='6'>
                              <h5 className='mb-3' style={{color: '#2664b5'}}>
                                {t('After')}
                              </h5>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>Sales Org</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData.produsen?.name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(tempData.sector?.name)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData.incoterm1?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col md={8}>
                                  {tempData?.incoterm2 == null ? (
                                    <Form.Control
                                      value={
                                        tempData?.incoterm2_id == null ||
                                        tempData?.incoterm2_id == '0'
                                          ? ''
                                          : tempData?.incoterm2_id
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  ) : (
                                    <Form.Control
                                      value={tempData?.incoterm2?.code}
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={tempData.province?.region_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={tempData.city?.city_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('segment')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={t(tempData?.segment_name)}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              {/* <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control type='text' value={tempData.plant_desc} disabled size='sm' />
                    </Col>
                  </Row> */}
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData.product_type_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData.product_name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      i18next.language === 'en'
                                        ? (
                                            parseFloat(tempData.fixed_quantum) -
                                            parseFloat(tempData.so_qty_realized)
                                          )?.toLocaleString('en', {maximumFractionDigits: 4}) +
                                          ' Ton'
                                        : (
                                            parseFloat(tempData.fixed_quantum) -
                                            parseFloat(tempData.so_qty_realized)
                                          )?.toLocaleString('id', {maximumFractionDigits: 4}) +
                                          ' Ton'
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-2'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/Ton</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      'Rp ' + (i18next.language === 'en'
                                        ? parseInt(tempData?.fixed_price).toLocaleString('en') +
                                          '/Ton'
                                        : parseInt(tempData?.fixed_price).toLocaleString('id') +
                                          '/Ton')
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-4 fs-6'>{t('termasuk-ppn')}</p>
                                </Col>
                                <Col sm={8} className='d-flex justify-content-start'>
                                  <Form.Check
                                    reverse
                                    name='ppn'
                                    className='mt-5 mb-2'
                                    type='checkbox'
                                    id='ckbox-ppn'
                                    checked={tempData?.include_ppn}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                </Col>
                                <Col sm={8} className='d-flex justify-content-start'>
                                  <Form.Control
                                    disabled
                                    type='text'
                                    size='sm'
                                    value={
                                      tempData?.shipping_tolerance == 0
                                        ? ''
                                        : tempData?.shipping_tolerance + '%'
                                    }
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData?.payment_type_1_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData?.payment_type_2_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  {i18next.language === 'en' ? (
                                    <p className='mt-3 fs-6'>{t('keterangan')}</p>
                                  ) : (
                                    <p className='fs-6'>{t('keterangan')}</p>
                                  )}
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData?.payment_note}
                                    type='text'
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData.product_spec}
                                    as='textarea'
                                    style={{height: '40px'}}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      tempData?.end_user_multiple
                                        ? handleShowValue(
                                            tempData?.end_user,
                                            tempData?.end_user_multiple
                                          )
                                        : tempData?.end_user
                                    }
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData?.notes}
                                    as='textarea'
                                    style={{height: '40px'}}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              { !isRetail(tempData?.sector_id) && <>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('alasan perpanjangan')}
                                      defaultValue={tempData?.amandement_notes}
                                      disabled
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  className='mb-4'
                                  hidden={tempData?.extension_date == null ? true : false}
                                >
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('tanggal perpanjangan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      defaultValue={tempData?.extension_date}
                                      style={{height: '40px'}}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </> }
                            </Col>
                          </Row>
                        )}

                        {tempDetail.sector_id == 3 && (
                          <Row>
                            <Col md='6'>
                              <h5 className='mb-3 text-danger'>{t('Before')}</h5>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>Sales Org</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2.produsen?.name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(tempData2.sector?.name)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2.incoterm1?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col md={8}>
                                  {tempData2?.incoterm2 == null ? (
                                    <Form.Control
                                      value={
                                        tempData2?.incoterm2_id == null ||
                                        tempData2?.incoterm2_id == '0'
                                          ? ''
                                          : tempData2?.incoterm2_id
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  ) : (
                                    <Form.Control
                                      value={tempData2?.incoterm2?.code}
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={tempData2.province?.region_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={tempData2.city?.city_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2.product_type_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2.product_name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                                </Col>
                                <Col md={8}>
                                  {tempData2.so_qty_realized == undefined ? (
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? parseFloat(tempData2?.fixed_quantum).toLocaleString(
                                              'en',
                                              {
                                                maximumFractionDigits: 4,
                                              }
                                            ) + ' MT'
                                          : parseFloat(tempData2?.fixed_quantum).toLocaleString(
                                              'id',
                                              {
                                                maximumFractionDigits: 4,
                                              }
                                            ) + ' MT'
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  ) : (
                                    <Form.Control
                                      value={
                                        i18next.language === 'en'
                                          ? (
                                              parseFloat(tempData2.fixed_quantum) -
                                              parseFloat(tempData2.so_qty_realized)
                                            ).toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) + ' MT'
                                          : (
                                              parseFloat(tempData2.fixed_quantum) -
                                              parseFloat(tempData2.so_qty_realized)
                                            ).toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) + ' MT'
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/MT</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      'USD ' + i18next.language === 'en'
                                        ? parseFloat(tempData2?.fixed_price).toLocaleString('en') +
                                          '/MT'
                                        : parseFloat(tempData2?.fixed_price).toLocaleString('id') +
                                          '/MT'
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              {/* <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-4'>{t('termasuk-ppn')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Check
                                reverse
                                disabled
                                name='ppn'
                                className='mt-5 mb-2'
                                type='checkbox'
                                id='ckbox-ppn'
                                checked={tempData2?.include_ppn}
                              />
                            </Col>
                          </Row> */}
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                </Col>
                                <Col sm={8} className='d-flex justify-content-start'>
                                  <Form.Control
                                    disabled
                                    type='text'
                                    size='sm'
                                    value={
                                      tempData2?.shipping_tolerance == 0
                                        ? ''
                                        : tempData2?.shipping_tolerance + '%'
                                    }
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2?.payment_type_1_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2?.payment_type_2_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='mt-3 fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2?.payment_note}
                                    type='text'
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2.product_spec}
                                    type='text'
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      tempData2?.end_user_multiple
                                        ? handleShowValue(
                                            tempData2?.end_user,
                                            tempData2?.end_user_multiple
                                          )
                                        : tempData2?.end_user
                                    }
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData2?.notes}
                                    as='textarea'
                                    style={{height: '40px'}}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              { !isRetail(tempData?.sector_id) && <>
                                <Row
                                  className='mb-4'
                                  hidden={tempData?.amandement_notes == null ? true : false}
                                >
                                  <Col md={4}>
                                    <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('alasan perpanjangan')}
                                      defaultValue={tempData?.amandement_notes}
                                      disabled
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  className='mb-4'
                                  hidden={tempData?.extension_date == null ? true : false}
                                >
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('tanggal perpanjangan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      defaultValue={tempData?.extension_date}
                                      style={{height: '40px'}}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </> }
                            </Col>
                            <Col md='6'>
                              <h5 className='mb-3' style={{color: '#2664b5'}}>
                                {t('After')}
                              </h5>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>Sales Org</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData.produsen?.name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(tempData.sector?.name)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData.incoterm1?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col md={8}>
                                  {tempData?.incoterm2 == null ? (
                                    <Form.Control
                                      value={
                                        tempData?.incoterm2_id == null ||
                                        tempData?.incoterm2_id == '0'
                                          ? ''
                                          : tempData?.incoterm2_id
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  ) : (
                                    <Form.Control
                                      value={tempData?.incoterm2?.code}
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={tempData.province?.region_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={tempData.city?.city_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData.product_type_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData.product_name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      i18next.language === 'en'
                                        ? (
                                            parseFloat(tempData.fixed_quantum) -
                                            parseFloat(tempData.so_qty_realized)
                                          )?.toLocaleString('en', {maximumFractionDigits: 4}) +
                                          ' MT'
                                        : (
                                            parseFloat(tempData.fixed_quantum) -
                                            parseFloat(tempData.so_qty_realized)
                                          )?.toLocaleString('id', {maximumFractionDigits: 4}) +
                                          ' MT'
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/MT</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      'USD ' + i18next.language === 'en'
                                        ? parseFloat(tempData?.fixed_price).toLocaleString('en') +
                                          '/MT'
                                        : parseFloat(tempData?.fixed_price).toLocaleString('id') +
                                          '/MT'
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              {/* <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-4'>{t('termasuk-ppn')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Check
                                reverse
                                name='ppn'
                                disabled
                                className='mt-5 mb-2'
                                type='checkbox'
                                id='ckbox-ppn'
                                checked={tempData?.include_ppn}
                              />
                            </Col>
                          </Row> */}
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                </Col>
                                <Col sm={8} className='d-flex justify-content-start'>
                                  <Form.Control
                                    disabled
                                    type='text'
                                    size='sm'
                                    value={
                                      tempData?.shipping_tolerance == 0
                                        ? ''
                                        : tempData?.shipping_tolerance + '%'
                                    }
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData?.payment_type_1_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData?.payment_type_2_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='mt-3 fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData?.payment_note}
                                    type='text'
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData.product_spec}
                                    type='text'
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      tempData?.end_user_multiple
                                        ? handleShowValue(
                                            tempData?.end_user,
                                            tempData?.end_user_multiple
                                          )
                                        : tempData?.end_user
                                    }
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempData?.notes}
                                    as='textarea'
                                    style={{height: '40px'}}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              { !isRetail(tempData?.sector_id) && <>
                                <Row className='mb-4'>
                                  <Col md={4}>
                                    <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                  </Col>
                                  <Col md={8}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('alasan perpanjangan')}
                                      defaultValue={tempData?.amandement_notes}
                                      disabled
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  className='mb-4'
                                  hidden={tempData?.extension_date == null ? true : false}
                                >
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('tanggal perpanjangan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      defaultValue={tempData?.extension_date}
                                      style={{height: '40px'}}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </> }
                            </Col>
                          </Row>
                        )}
                      </>
                    ) : (
                      <>
                      {/* <span>{JSON.stringify(tempDetail)} {roleUser}</span> */}
                        {tempDetail.status === 1 && roleUser == 'salesAdmin' ? (
                          <>
                            {tempDetail?.sector_id == 1 && (
                              <Row>
                                <Col md={6}>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('kontrak-produsen')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Select
                                        aria-label='Default select example'
                                        size='sm'
                                        id='produsen'
                                        onChange={(e: any) => {
                                          const code = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            request_price: '0',
                                            request_quantum: '0',
                                            product_name: 0,
                                            material_number: null,
                                            shipping_tolerance: '0',
                                            product_type_desc: '',
                                            province: {...state.province, id: null},
                                            city: {...state.city, city_name: null, id: ''},
                                            produsen: {...state.code, code: code[0], name: code[1]},
                                          }))
                                          setProdusen(code[0])
                                          setProdusenCode(code[0])
                                          setPname('')
                                          setPnumber('')
                                          setPtype('')
                                          setChange(!change)
                                        }}
                                      >
                                        {fullProdusen.map((items: any) => (
                                          <>
                                            {tempDetail.produsen?.name == items.label ? (
                                              <option value={items.value} selected>
                                                {items.label}
                                              </option>
                                            ) : (
                                              <option value={items.value}>{items.label}</option>
                                            )}
                                          </>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-4'>
                                        {t('sub-order-incoterm1')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Select
                                        aria-label='Default select example'
                                        size='sm'
                                        id='incoterm1'
                                        key={idSektor + produsen + fullIncoterm}
                                        onChange={(e: any) => {
                                          const code = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            incoterm1: {
                                              ...state.incoterm1,
                                              code: code[1],
                                              id: code[0],
                                            },
                                          }))
                                          separateValue2(
                                            setIncoterm1,
                                            e.target.value,
                                            setIncoterm1Desc
                                          )
                                        }}
                                      >
                                        <option value='0'>
                                          {t('pilih')} {t('sub-order-incoterm1')}{' '}
                                          <span className='text-danger'>*</span>
                                        </option>
                                        {fullIncoterm.map((items: any) => (
                                          <>
                                            {tempDetail.incoterm1?.code == items.label ? (
                                              <option value={items.value} selected>
                                                {items.label}
                                              </option>
                                            ) : (
                                              <option value={items.value}>{items.label}</option>
                                            )}
                                          </>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-4'>
                                        {t('sub-order-provinsi')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='provinsi'
                                        placeholder={t('pilih')}
                                        key={tempDetail.produsen.code}
                                        value={
                                          fullProvince[
                                            fullProvince.findIndex((item: any) =>
                                              item.number.match(tempDetail?.province?.id)
                                            )
                                          ]
                                        }
                                        onChange={(e: any) => {
                                          const tmp = e.value.split('~#~')
                                          // setTempDetail((state: any) => ({ ...state, city: { ...state.city, city_name: '' }, province: { ...state.province, id: tmp[0], region_name: tmp[1] }, request_quantum: 0, request_price: 0, include_ppn: false, shipping_tolerance: 0 }))
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            city: {...state.city, city_name: null},
                                            province: {
                                              ...state.province,
                                              id: tmp[0],
                                              region_name: tmp[1],
                                            },
                                          }))
                                          setProvince(tmp[0])
                                          setChange(!change)
                                          // fieldClearer(5)
                                        }}
                                        options={fullProvince}
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-4'>
                                        {t('sub-order-jenis')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Select
                                        size='sm'
                                        aria-label='Default select example'
                                        id='jenis'
                                        onChange={(e: any) => {
                                          const tmp = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            product_name: '',
                                            product_type_desc: tmp[0],
                                            product_type: tmp[1],
                                            material_number: null,
                                          }))
                                          productTypeChange(e.target.value)
                                          setProdusen(tempDetail.produsen.code)
                                        }}
                                      >
                                        <option hidden value='~#~'>
                                          {t('Pilih-productType')}
                                        </option>
                                        {fullProductType.map((item: any) => {
                                          return (
                                            <>
                                              {item.id != 12 && (
                                                <>
                                                  {item.material_group_desc ==
                                                  tempDetail?.product_type_desc ? (
                                                    <option
                                                      selected
                                                      value={
                                                        item.material_group_desc +
                                                        '~#~' +
                                                        item.material_group
                                                      }
                                                    >
                                                      {t(item.material_group_desc)}
                                                    </option>
                                                  ) : (
                                                    <option
                                                      value={
                                                        item.material_group_desc +
                                                        '~#~' +
                                                        item.material_group
                                                      }
                                                    >
                                                      {t(item.material_group_desc)}
                                                    </option>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )
                                        })}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  {parseInt(pnumber) == 0 && (
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='fs-6'>Custom Product Name</p>
                                      </Col>
                                      <Col sm={8}>
                                        <Form.Control
                                          placeholder=' Custom Product Name'
                                          size='sm'
                                          defaultValue={pname}
                                          aria-label='Default select example'
                                          type='text'
                                          id='custom'
                                          onChange={(e: any) => setPname(e.target.value)}
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('Kuantum Pengajuan')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <InputGroup size='sm'>
                                        <CurrencyInput
                                          className='form-control form-control-sm'
                                          id='kuantum'
                                          key={change.toString()}
                                          defaultValue={tempDetail.request_quantum}
                                          disabled={nonPurchaseButPurchase}
                                          decimalSeparator={language === 'en' ? '.' : ','}
                                          groupSeparator={language === 'en' ? ',' : '.'}
                                          onValueChange={(value: any) => {
                                            let dtl: any = {
                                              request_quantum: value?.replace(/,/g, '.')
                                            }
                                            if(!nonPurchaseButPurchase){
                                              dtl.fixed_quantum = value?.replace(/,/g, '.')
                                            }
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              ...dtl
                                            }))
                                            setQuantum(value?.replace(/,/g, '.'))
                                          }}
                                          decimalsLimit={3}
                                        />
                                        <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                      </InputGroup>
                                    </Col>
                                  </Row>
                                  {
                                    nonPurchaseButPurchase && (
                                      <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('quantumapproved')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <InputGroup size='sm'>
                                        <CurrencyInput
                                          className='form-control form-control-sm'
                                          id='kuantum'
                                          key={change.toString()}
                                          defaultValue={tempDetail.fixed_quantum || tempDetail.request_quantum}
                                          decimalSeparator={language === 'en' ? '.' : ','}
                                          groupSeparator={language === 'en' ? ',' : '.'}
                                          onValueChange={(value: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              fixed_quantum: value?.replace(/,/g, '.'),
                                            }))
                                          }}
                                          decimalsLimit={3}
                                        />
                                        <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                      </InputGroup>
                                    </Col>
                                  </Row>
                                    )
                                  }
                                  <Row className='mb-2'>
                                    <Col sm={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <InputGroup className='mb-3' size='sm'>
                                        <Form.Control
                                          placeholder={t('Shipping Tolerance')}
                                          type='number'
                                          id='shipping'
                                          value={tempDetail.shipping_tolerance}
                                          onChange={(e: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              shipping_tolerance: parseInt(e.target.value),
                                            }))
                                            setShipping(parseInt(e.target.value))
                                          }}
                                        />
                                        <InputGroup.Text id='basic-addon2'>
                                          <span className='px-2'>%</span>
                                        </InputGroup.Text>
                                      </InputGroup>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('sub-order-payment1')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Select
                                        size='sm'
                                        aria-label='Default select example'
                                        id='payment1'
                                        onChange={(e: any) => {
                                          const tmp = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            payment_type_1: tmp[0],
                                            payment_type_1_desc: tmp[1],
                                          }))
                                          separateValue(setPay1, e.target.value, setPay1Desc)
                                        }}
                                      >
                                        <option hidden value='~#~'>
                                          {t('Pilih-payment')}
                                        </option>
                                        {fullPayment.map((item: any) => {
                                          return (
                                            <>
                                              {item.code == tempDetail?.payment_type_1 ? (
                                                <option
                                                  selected
                                                  value={item.code + '~#~' + item.payment_desc_id}
                                                >
                                                  {item.payment_desc_id}
                                                </option>
                                              ) : (
                                                <option
                                                  value={item.code + '~#~' + item.payment_desc_id}
                                                >
                                                  {item.payment_desc_id}
                                                </option>
                                              )}
                                            </>
                                          )
                                        })}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('keterangan')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        as='textarea'
                                        defaultValue={tempDetail?.payment_note}
                                        placeholder={t('keterangan')}
                                        id='keterangan'
                                        size='sm'
                                        style={{height: '40px'}}
                                        onChange={(e: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            payment_note: e.target.value,
                                          }))
                                          setketerangan(e.target.value)
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                  {parseInt(pnumber) != 0 && (
                                    <Row className='mb-4'>
                                      <Col md={4}>
                                        <p className='mt-3 fs-6'>
                                          {t('segment')}
                                          <span className='text-danger'>*</span>
                                        </p>
                                      </Col>
                                      <Col md={8}>
                                        <Form.Select
                                          size='sm'
                                          id='segment'
                                          onChange={(e: any) => {
                                            const tmp = e.target.value.split('~#~')
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              segment_code: tmp[0],
                                              segment_name: tmp[1],
                                            }))
                                            separateValue(
                                              setSegment,
                                              e.target.value,
                                              setSegmentDesc
                                            )
                                          }}
                                          aria-label='Default select example'
                                        >
                                          {fullSegment.map((item: any) => {
                                            if (item.code == 'Z2' || item.code == 'Z3') {
                                              if (item.code == tempDetail.segment_code) {
                                                return (
                                                  <option
                                                    selected
                                                    value={item.code + '~#~' + item.name}
                                                  >
                                                    {item.name}
                                                  </option>
                                                )
                                              } else {
                                                return (
                                                  <option value={item.code + '~#~' + item.name}>
                                                    {item.name}
                                                  </option>
                                                )
                                              }
                                            } else {
                                              return null
                                            }
                                          })}
                                        </Form.Select>
                                      </Col>
                                    </Row>
                                  )}
                                  <Row className='mb-1'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('End Customer')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      {!isNoEnduser ? (
                                        <MultiSelect
                                          options={fullEndUser?.map((item: any) => {
                                            return {label: t(item.name), value: item.name}
                                          })}
                                          value={arrayEnduser}
                                          onChange={(e: any) => {
                                            let user = handleUser(e)
                                            setEnduserArray(e)
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              end_user: user.toString(),
                                              end_user_multiple: true,
                                            }))
                                          }}
                                          labelledBy='Select'
                                        />
                                      ) : (
                                        <Form.Control
                                          size='sm'
                                          as='textarea'
                                          id='enduser'
                                          placeholder={t('End Customer')}
                                          defaultValue={
                                            tempDetail?.end_user_multiple
                                              ? ''
                                              : tempDetail?.end_user
                                          }
                                          onChange={(e: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              end_user: e.target.value,
                                              end_user_multiple: false,
                                            }))
                                            setEnduser(e.target.value)
                                            setEnduserDesc(e.target.value)
                                          }}
                                        />
                                      )}
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col sm={4}></Col>
                                    <Col sm={8} className='d-flex'>
                                      <Form.Check
                                        onClick={() => setIsNoEnduser(!isNoEnduser)}
                                        defaultChecked={isNoEnduser}
                                        name='ppn'
                                        // disabled={ptype == 'P13' ? true : false}
                                        className='mt-4 mb-2'
                                        type='checkbox'
                                        id='noenduser'
                                      />
                                      {i18next.language == 'en' ? (
                                        <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                      ) : (
                                        <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                      )}
                                    </Col>
                                  </Row>

                                  { !isRetail(tempDetail?.sector_id) && <>
                                    <Row className='mb-4'>
                                      <Col md={4}>
                                        <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                      </Col>
                                      <Col md={8}>
                                        <Form.Control
                                          value={tempDetail?.amandement_notes}
                                          type='text'
                                          disabled
                                          size='sm'
                                        />
                                      </Col>
                                    </Row>
                                  </> }
                                </Col>

                                <Col md={6}>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-4'>{t('sub-order-sektor')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        size='sm'
                                        aria-label='Default select example'
                                        id='sektor'
                                        disabled
                                        value={t(tempDetail?.sector?.name)}
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Select
                                        aria-label='Default select example'
                                        size='sm'
                                        id='incoterm2'
                                        key={idSektor + produsen + fullIncoterm}
                                        onChange={(e: any) => {
                                          const code = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            incoterm2_id: code[0],
                                            incoterm2: {
                                              ...state.incoterm2,
                                              code: code[1],
                                              id: code[0],
                                            },
                                          }))
                                          separateValue2(
                                            setIncoterm2,
                                            e.target.value,
                                            setIncoterm2Desc
                                          )
                                        }}
                                      >
                                        <option value='0'>
                                          {t('pilih')} {t('sub-order-incoterm2')}
                                        </option>
                                        {fullIncoterm.map((items: any) => (
                                          <>
                                            {tempDetail.incoterm2?.code == items.label ? (
                                              <option value={items.value} selected>
                                                {items.label}
                                              </option>
                                            ) : (
                                              <option value={items.value}>{items.label}</option>
                                            )}
                                          </>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-4'>
                                        {t('sub-order-kota')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='kota'
                                        placeholder={t('pilih')}
                                        key={province + tempDetail.province.id}
                                        value={
                                          fullCity[
                                            fullCity.findIndex((item: any) =>
                                              item.label.match(tempDetail.city?.city_name)
                                            )
                                          ]
                                        }
                                        onChange={(e: any) => {
                                          const tmp = e.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            city_id: tmp[0],
                                            city: {...state.city, id: tmp[0], city_name: tmp[1]},
                                          }))
                                          setCity(tmp[0])
                                          // fieldClearer(4)
                                        }}
                                        options={fullCity}
                                      />
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>
                                        {t('sub-order-produk')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='nama'
                                        placeholder={t('pilih')}
                                        key={ptype + tempDetail.material_number + fullProductName}
                                        defaultValue={
                                          fullProductName[
                                            fullProductName.findIndex(
                                              (item: any) =>
                                                item.truevalue ==
                                                parseInt(tempDetail?.material_number)
                                            )
                                          ]
                                        }
                                        onChange={(e: any) => {
                                          // productNameChange(e.target.value)
                                          const tmp = e.value.split('~#~')
                                          const productName = tmp[1]
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            material_number: tmp[0],
                                            unit: tmp[2],
                                            product_name: productName,
                                          }))
                                          setPnumber(tmp[0])
                                          setPunit(tmp[2])
                                          setPname(productName)
                                          // fieldClearer(1)
                                        }}
                                        options={fullProductName}
                                      />
                                    </Col>
                                  </Row>
                                  {pnumber == '0' && (
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                      </Col>
                                      <Col sm={8}>
                                        <Form.Control
                                          as='textarea'
                                          placeholder={t('sub-order-catatan')}
                                          defaultValue={tempDetail?.notes}
                                          id='note'
                                          size='sm'
                                          style={{height: '40px'}}
                                          onChange={(e: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              notes: e.target.value,
                                            }))
                                            setNote(e.target.value)
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  )}

                                  <Row className='mb-4'>
                                    <Col sm={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>
                                        {t('Harga Pengajuan')}/Ton
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <InputGroup size='sm'>
                                        <InputGroup.Text>
                                          <span className='px-1'>Rp</span>
                                        </InputGroup.Text>
                                        <CurrencyInput
                                          className='form-control form-control-sm'
                                          id='hargap'
                                          key={change.toString()}
                                          defaultValue={
                                            tempDetail?.is_formulated_price
                                              ? '0'
                                              : tempDetail.request_price
                                          }
                                          disabled={tempDetail?.is_formulated_price || nonPurchaseButPurchase}
                                          decimalSeparator={language === 'en' ? '.' : ','}
                                          groupSeparator={language === 'en' ? ',' : '.'}
                                          onValueChange={(value: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              request_price: value?.replace(/,/g, '.'),
                                            }))
                                            setSubprice(value?.replace(/,/g, '.'))
                                          }}
                                          decimalsLimit={-1}
                                          placeholder={t('Harga Pengajuan')}
                                        />
                                      </InputGroup>
                                    </Col>
                                  </Row>

                                  {
                                    nonPurchaseButPurchase && (
                                      <Row className='mb-4'>
                                        <Col sm={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>
                                            {t('Harga Disetujui')}/Ton
                                            <span className='text-danger'>*</span>
                                          </p>
                                        </Col>
                                        <Col sm={8}>
                                          <InputGroup size='sm'>
                                            <InputGroup.Text>
                                              <span className='px-1'>Rp</span>
                                            </InputGroup.Text>
                                            <CurrencyInput
                                              className='form-control form-control-sm'
                                              id='hargap'
                                              key={change.toString()}
                                              defaultValue={
                                                tempDetail?.is_formulated_price
                                                  ? '0'
                                                  : (tempDetail.fixed_price || tempDetail.request_price)
                                              }
                                              disabled={tempDetail?.is_formulated_price}
                                              decimalSeparator={language === 'en' ? '.' : ','}
                                              groupSeparator={language === 'en' ? ',' : '.'}
                                              onValueChange={(value: any) => {
                                                setTempDetail((state: any) => ({
                                                  ...state,
                                                  fixed_price: value?.replace(/,/g, '.'),
                                                }))
                                              }}
                                              decimalsLimit={-1}
                                              placeholder={t('Harga Disetujui')}
                                            />
                                          </InputGroup>
                                        </Col>
                                      </Row>
                                    )
                                  }

                                  <Row className='my-7'>
                                    <Col sm={6} className='d-flex'>
                                      <Row sm={8} className='d-flex align-items-center'>
                                        <p className='fs-6'>{t('termasuk-ppn')}</p>
                                      </Row>
                                      <Row
                                        sm={4}
                                        className='d-flex justify-content-start align-items-center ms-4'
                                      >
                                        <Form.Check
                                          reverse
                                          name='ppn'
                                          type='checkbox'
                                          id='ckbox-ppn'
                                          defaultChecked={tempDetail?.include_ppn}
                                          onClick={() => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              include_ppn: !state.include_ppn,
                                            }))
                                          }}
                                        />
                                      </Row>
                                    </Col>

                                    <Col sm={6} className='d-flex'>
                                      <Row sm={8} className='d-flex align-items-center'>
                                        <p className='fs-6'>{t('Formulated Price')}</p>
                                      </Row>
                                      <Row
                                        sm={4}
                                        className='d-flex justify-content-start align-items-center ms-4'
                                      >
                                        <Form.Check
                                          reverse
                                          name='formula_Price'
                                          type='checkbox'
                                          id='formula_Price'
                                          defaultChecked={tempDetail?.is_formulated_price}
                                          onClick={() => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              is_formulated_price: !state.is_formulated_price,
                                            }))
                                          }}
                                        />
                                      </Row>
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Select
                                        size='sm'
                                        aria-label='Default select example'
                                        id='payment2'
                                        onChange={(e: any) => {
                                          const tmp = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            payment_type_2: tmp[0],
                                            payment_type_2_desc: tmp[1],
                                          }))
                                          separateValue(setPay2, e.target.value, setPay2Desc)
                                        }}
                                      >
                                        <option value='~#~'>{t('Pilih-payment')}</option>
                                        {fullPayment.map((item: any) => {
                                          return (
                                            <>
                                              {item.code == tempDetail?.payment_type_2 ? (
                                                <option
                                                  selected
                                                  value={item.code + '~#~' + item.payment_desc_id}
                                                >
                                                  {item.payment_desc_id}
                                                </option>
                                              ) : (
                                                <option
                                                  value={item.code + '~#~' + item.payment_desc_id}
                                                >
                                                  {item.payment_desc_id}
                                                </option>
                                              )}
                                            </>
                                          )
                                        })}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        placeholder={t('sub-order-spek')}
                                        as='textarea'
                                        defaultValue={tempDetail?.product_spec}
                                        id='spek'
                                        size='sm'
                                        style={{height: '40px'}}
                                        onChange={(e: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            product_spec: e.target.value,
                                          }))
                                          setPspec(e.target.value)
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                  {parseInt(pnumber) != 0 && (
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                      </Col>
                                      <Col sm={8}>
                                        <Form.Control
                                          as='textarea'
                                          placeholder={t('sub-order-catatan')}
                                          defaultValue={tempDetail?.notes}
                                          id='note'
                                          size='sm'
                                          style={{height: '40px'}}
                                          onChange={(e: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              notes: e.target.value,
                                            }))
                                            setNote(e.target.value)
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                  {parseInt(pnumber) == 0 && (
                                    <Row className='mb-4'>
                                      <Col md={4}>
                                        <p className='mt-3 fs-6'>
                                          {t('segment')}
                                          <span className='text-danger'>*</span>
                                        </p>
                                      </Col>
                                      <Col md={8}>
                                        <Form.Select
                                          size='sm'
                                          id='segment'
                                          onChange={(e: any) => {
                                            const tmp = e.target.value.split('~#~')
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              segment_code: tmp[0],
                                              segment_name: tmp[1],
                                            }))
                                            separateValue(
                                              setSegment,
                                              e.target.value,
                                              setSegmentDesc
                                            )
                                          }}
                                          aria-label='Default select example'
                                        >
                                          {fullSegment.map((item: any) => {
                                            if (item.code == 'Z2' || item.code == 'Z3') {
                                              if (item.code == tempDetail.segment_code) {
                                                return (
                                                  <option
                                                    selected
                                                    value={item.code + '~#~' + item.name}
                                                  >
                                                    {item.name}
                                                  </option>
                                                )
                                              } else {
                                                return (
                                                  <option value={item.code + '~#~' + item.name}>
                                                    {item.name}
                                                  </option>
                                                )
                                              }
                                            } else {
                                              return null
                                            }
                                          })}
                                        </Form.Select>
                                      </Col>
                                    </Row>
                                  )}

                                  { !isRetail(tempDetail?.sector_id) && <>
                                    <Row className='mb-4'>
                                      <Col md={4}>
                                        <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                                      </Col>
                                      <Col md={8}>
                                        <Form.Control
                                          value={tempDetail?.extension_date}
                                          type={tempDetail?.extension_date ? 'date' : 'text'}
                                          disabled
                                          size='sm'
                                        />
                                      </Col>
                                    </Row>
                                  </> }
                                
                                </Col>
                                <div className='d-flex justify-content-end '>
                                  <Button
                                    className='btn btn-primary'
                                    onClick={() => handleSaveDetail(tempDetail)}
                                  >
                                    {t('save')}
                                  </Button>
                                </div>
                              </Row>
                            )}

                            {tempDetail?.sector_id == 3 && (
                              <Row>
                                <Col md='6'>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>
                                        Sales Org
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Select
                                        aria-label='Default select example'
                                        size='sm'
                                        id='produsen'
                                        onChange={(e: any) => {
                                          const code = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            request_price: '0',
                                            request_quantum: '0',
                                            product_name: 0,
                                            material_number: null,
                                            shipping_tolerance: '0',
                                            product_type_desc: '',
                                            province: {...state.province, id: null},
                                            city: {...state.city, city_name: null, id: ''},
                                            produsen: {...state.code, code: code[0], name: code[1]},
                                          }))
                                          setProdusenCode(code[0])
                                          setPname('')
                                          setPnumber('')
                                          setChange(!change)
                                        }}
                                      >
                                        {fullProdusen.map((items: any) => (
                                          <>
                                            {tempDetail.produsen?.name == items.label ? (
                                              <option value={items.value} selected>
                                                {items.label}
                                              </option>
                                            ) : (
                                              <option value={items.value}>{items.label}</option>
                                            )}
                                          </>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('sub-order-incoterm1')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Select
                                        aria-label='Default select example'
                                        size='sm'
                                        id='incoterm1'
                                        key={idSektor + produsen + fullIncoterm}
                                        onChange={(e: any) => {
                                          const code = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            incoterm1: {
                                              ...state.incoterm1,
                                              code: code[1],
                                              id: code[0],
                                            },
                                          }))
                                          separateValue2(
                                            setIncoterm1,
                                            e.target.value,
                                            setIncoterm1Desc
                                          )
                                        }}
                                      >
                                        <option value='0'>
                                          {t('pilih')} {t('sub-order-incoterm1')}
                                        </option>
                                        {fullIncoterm.map((items: any) => (
                                          <>
                                            {tempDetail.incoterm1?.code == items.label ? (
                                              <option value={items.value} selected>
                                                {items.label}
                                              </option>
                                            ) : (
                                              <option value={items.value}>{items.label}</option>
                                            )}
                                          </>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-4'>
                                        {t('sub-order-provinsi')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='provinsi'
                                        placeholder={t('pilih')}
                                        key={tempDetail.produsen.code}
                                        value={
                                          fullProvince[
                                            fullProvince.findIndex((item: any) =>
                                              item.number.match(tempDetail?.province?.id)
                                            )
                                          ]
                                        }
                                        onChange={(e: any) => {
                                          const tmp = e.value.split('~#~')
                                          // setTempDetail((state: any) => ({ ...state, city: { ...state.city, city_name: '' }, province: { ...state.province, id: tmp[0], region_name: tmp[1] }, request_quantum: 0, request_price: 0, include_ppn: false, shipping_tolerance: 0 }))
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            city: {...state.city, city_name: null},
                                            province: {
                                              ...state.province,
                                              id: tmp[0],
                                              region_name: tmp[1],
                                            },
                                          }))
                                          setProvince(tmp[0])
                                          setChange(!change)
                                          // fieldClearer(5)
                                        }}
                                        options={fullProvince}
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('sub-order-jenis')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Select
                                        size='sm'
                                        aria-label='Default select example'
                                        id='jenis'
                                        onChange={(e: any) => {
                                          const tmp = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            product_name: '',
                                            product_type_desc: tmp[0],
                                            product_type: tmp[1],
                                            material_number: null,
                                          }))
                                          productTypeChange(e.target.value)
                                        }}
                                      >
                                        <option hidden value='~#~'>
                                          {t('Pilih-productType')}
                                        </option>
                                        {fullProductType.map((item: any) => {
                                          return (
                                            <>
                                              {item.id != 12 && (
                                                <>
                                                  {item.material_group_desc ==
                                                  tempDetail?.product_type_desc ? (
                                                    <option
                                                      selected
                                                      value={
                                                        item.material_group_desc +
                                                        '~#~' +
                                                        item.material_group
                                                      }
                                                    >
                                                      {t(item.material_group_desc)}
                                                    </option>
                                                  ) : (
                                                    <option
                                                      value={
                                                        item.material_group_desc +
                                                        '~#~' +
                                                        item.material_group
                                                      }
                                                    >
                                                      {t(item.material_group_desc)}
                                                    </option>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )
                                        })}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  {parseInt(pnumber) == 0 && (
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='fs-6'>Custom Product Name</p>
                                      </Col>
                                      <Col sm={8}>
                                        <Form.Control
                                          placeholder=' Custom Product Name'
                                          size='sm'
                                          defaultValue={pname}
                                          aria-label='Default select example'
                                          type='text'
                                          id='custom'
                                          onChange={(e: any) => setPname(e.target.value)}
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('Kuantum Pengajuan')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col md={8}>
                                      <InputGroup size='sm'>
                                        <CurrencyInput
                                          className='form-control form-control-sm'
                                          id='kuantum'
                                          key={change.toString()}
                                          defaultValue={tempDetail?.request_quantum}
                                          decimalSeparator={language === 'en' ? '.' : ','}
                                          groupSeparator={language === 'en' ? ',' : '.'}
                                          onValueChange={(value: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              request_quantum: value?.replace(/,/g, '.'),
                                              fixed_quantum: value?.replace(/,/g, '.'),
                                            }))
                                            setQuantum(value?.replace(/,/g, '.'))
                                          }}
                                          decimalsLimit={3}
                                        />
                                        <InputGroup.Text id='basic-addon2'>MT</InputGroup.Text>
                                      </InputGroup>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <InputGroup size='sm'>
                                        <Form.Control
                                          type='number'
                                          id='shipping'
                                          defaultValue={tempDetail.shipping_tolerance}
                                          onChange={(e: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              shipping_tolerance: parseInt(e.target.value),
                                            }))
                                            setShipping(parseInt(e.target.value))
                                          }}
                                        />
                                        <InputGroup.Text id='basic-addon2'>
                                          <span className='px-2'>%</span>
                                        </InputGroup.Text>
                                      </InputGroup>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('sub-order-payment1')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Select
                                        size='sm'
                                        aria-label='Default select example'
                                        id='payment1'
                                        onChange={(e: any) => {
                                          const tmp = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            payment_type_1: tmp[0],
                                            payment_type_1_desc: tmp[1],
                                          }))
                                          separateValue(setPay1, e.target.value, setPay1Desc)
                                        }}
                                      >
                                        <option hidden value='~#~'>
                                          {t('Pilih-payment')}
                                        </option>
                                        {fullPayment.map((item: any) => {
                                          return (
                                            <>
                                              {item.code == tempDetail?.payment_type_1 ? (
                                                <option
                                                  selected
                                                  value={item.code + '~#~' + item.payment_desc}
                                                >
                                                  {item.payment_desc}
                                                </option>
                                              ) : (
                                                <option value={item.code + '~#~' + item.payment_desc}>
                                                  {item.payment_desc}
                                                </option>
                                              )}
                                            </>
                                          )
                                        })}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('keterangan')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        as='textarea'
                                        defaultValue={tempDetail?.payment_note}
                                        placeholder={t('keterangan')}
                                        id='keterangan'
                                        size='sm'
                                        style={{height: '40px'}}
                                        onChange={(e: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            payment_note: e.target.value,
                                          }))
                                          setketerangan(e.target.value)
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('End Customer')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        size='sm'
                                        as='textarea'
                                        id='enduser'
                                        style={{height: '40px'}}
                                        placeholder={t('End Customer')}
                                        defaultValue={tempDetail?.end_user}
                                        onChange={(e: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            end_user: e.target.value,
                                          }))
                                          setEnduser(e.target.value)
                                          setEnduserDesc(e.target.value)
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                  { !isRetail(tempDetail?.sector_id) &&
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.amandement_notes}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row> }
                                </Col>
                                <Col md='6'>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={t(tempDetail.sector?.name)}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Select
                                        aria-label='Default select example'
                                        size='sm'
                                        id='incoterm2'
                                        key={idSektor + produsen + fullIncoterm}
                                        onChange={(e: any) => {
                                          const code = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            incoterm2_id: code[0],
                                            incoterm2: {
                                              ...state.incoterm2,
                                              code: code[1],
                                              id: code[0],
                                            },
                                          }))
                                          separateValue2(
                                            setIncoterm2,
                                            e.target.value,
                                            setIncoterm2Desc
                                          )
                                        }}
                                      >
                                        <option value='0'>
                                          {t('pilih')} {t('sub-order-incoterm2')}
                                        </option>
                                        {fullIncoterm.map((items: any) => (
                                          <>
                                            {tempDetail.incoterm2?.code == items.label ? (
                                              <option value={items.value} selected>
                                                {items.label}
                                              </option>
                                            ) : (
                                              <option value={items.value}>{items.label}</option>
                                            )}
                                          </>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-4'>{t('sub-order-kota')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='kota'
                                        placeholder={t('pilih')}
                                        key={province + tempDetail.province.id}
                                        isDisabled={false}
                                        defaultValue={
                                          fullCity[
                                              fullCity.findIndex((item: any) =>
                                                item.label.match(tempDetail.city?.city_name)
                                              )
                                            ]
                                        }
                                        onChange={(e: any) => {
                                          const tmp = e.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            city_id: tmp[0],
                                            city: {...state.city, id: tmp[0], city_name: tmp[1]},
                                          }))
                                          setCity(tmp[0])
                                          setCityDesc(tmp[1])
                                          // fieldClearer(4)
                                        }}
                                        options={fullCity}
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>
                                        {t('sub-order-produk')}
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <Select
                                        id='nama'
                                        placeholder={t('pilih')}
                                        key={ptype + fullProductName + tempDetail.material_number}
                                        value={
                                          fullProductName[
                                            fullProductName.findIndex(
                                              (item: any) =>
                                                item.truevalue ==
                                                parseInt(tempDetail?.material_number)
                                            )
                                          ]
                                        }
                                        onChange={(e: any) => {
                                          // productNameChange(e.target.value)
                                          const tmp = e.value.split('~#~')
                                          const productName = tmp[1]
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            material_number: tmp[0],
                                            unit: tmp[2],
                                            product_name: productName,
                                          }))
                                          setPnumber(tmp[0])
                                          setPunit(tmp[2])
                                          setPname(productName)
                                          // fieldClearer(1)
                                        }}
                                        options={fullProductName}
                                      />
                                    </Col>
                                  </Row>
                                  {pnumber == '0' && (
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                      </Col>
                                      <Col sm={8}>
                                        <Form.Control
                                          as='textarea'
                                          placeholder={t('sub-order-catatan')}
                                          defaultValue={tempDetail?.notes}
                                          id='note'
                                          size='sm'
                                          style={{height: '40px'}}
                                          onChange={(e: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              notes: e.target.value,
                                            }))
                                            setNote(e.target.value)
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  )}

                                  <Row className='mb-4'>
                                    <Col md={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>
                                        {t('Harga Pengajuan')}/MT
                                        <span className='text-danger'>*</span>
                                      </p>
                                    </Col>
                                    <Col sm={8}>
                                      <InputGroup size='sm'>
                                        <InputGroup.Text>
                                          <span className='px-1'>USD</span>
                                        </InputGroup.Text>
                                        <CurrencyInput
                                          className='form-control form-control-sm'
                                          id='hargap'
                                          key={change.toString()}
                                          defaultValue={
                                            tempDetail?.is_formulated_price
                                              ? '0'
                                              : tempDetail.request_price
                                          }
                                          disabled={tempDetail?.is_formulated_price}
                                          decimalSeparator={language === 'en' ? '.' : ','}
                                          groupSeparator={language === 'en' ? ',' : '.'}
                                          onValueChange={(value: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              request_price: value?.replace(/,/g, '.'),
                                            }))
                                            setSubprice(value?.replace(/,/g, '.'))
                                          }}
                                          decimalsLimit={2}
                                          placeholder={t('Harga Pengajuan')}
                                        />
                                      </InputGroup>
                                    </Col>
                                  </Row>

                                  <Row className='my-7'>
                                    <Col sm={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('Formulated Price')}</p>
                                    </Col>
                                    <Col sm={8} className='d-flex justify-content-start'>
                                      <Form.Check
                                        reverse
                                        name='formula_Price'
                                        type='checkbox'
                                        id='formula_Price'
                                        defaultChecked={tempDetail?.is_formulated_price}
                                        onClick={() => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            is_formulated_price: !state.is_formulated_price,
                                          }))
                                        }}
                                      />
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Select
                                        size='sm'
                                        aria-label='Default select example'
                                        id='payment2'
                                        onChange={(e: any) => {
                                          const tmp = e.target.value.split('~#~')
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            payment_type_2: tmp[0],
                                            payment_type_2_desc: tmp[1],
                                          }))
                                          separateValue(setPay2, e.target.value, setPay2Desc)
                                        }}
                                      >
                                        <option value='~#~'>{t('Pilih-payment')}</option>
                                        {fullPayment.map((item: any) => {
                                          return (
                                            <>
                                              {item.code == tempDetail?.payment_type_2 ? (
                                                <option
                                                  selected
                                                  value={item.code + '~#~' + item.payment_desc}
                                                >
                                                  {item.payment_desc}
                                                </option>
                                              ) : (
                                                <option value={item.code + '~#~' + item.payment_desc}>
                                                  {item.payment_desc}
                                                </option>
                                              )}
                                            </>
                                          )
                                        })}
                                      </Form.Select>
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        placeholder={t('sub-order-spek')}
                                        as='textarea'
                                        defaultValue={tempDetail?.product_spec}
                                        id='spek'
                                        size='sm'
                                        style={{height: '40px'}}
                                        onChange={(e: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            product_spec: e.target.value,
                                          }))
                                          setPspec(e.target.value)
                                        }}
                                      />
                                    </Col>
                                  </Row>

                                  {parseInt(pnumber) != 0 && (
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                      </Col>
                                      <Col sm={8}>
                                        <Form.Control
                                          as='textarea'
                                          placeholder={t('sub-order-catatan')}
                                          defaultValue={tempDetail?.notes}
                                          id='note'
                                          size='sm'
                                          style={{height: '40px'}}
                                          onChange={(e: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              notes: e.target.value,
                                            }))
                                            setNote(e.target.value)
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  )}

                                  { !isRetail(tempDetail?.sector_id) && <>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.extension_date}
                                        type={tempDetail?.extension_date ? 'date' : 'text'}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  </>}
                                </Col>
                                <div className='d-flex justify-content-end '>
                                  <Button
                                    className='btn btn-primary'
                                    onClick={() => handleSaveDetail(tempDetail)}
                                  >
                                    {t('save')}
                                  </Button>
                                </div>
                              </Row>
                            )}
                          </>
                        ) : (
                          <>
                            {tempDetail?.sector_id == 1 && (
                              <Row>
                                <Col md='6'>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>Sales Org</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail.produsen?.name}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail.incoterm1?.code}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        type='text'
                                        value={tempDetail.province?.region_name}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail.product_type_desc}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={
                                          i18next.language === 'en'
                                            ? parseFloat(tempDetail?.request_quantum).toLocaleString(
                                                'en',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              ) + ' Ton'
                                            : parseFloat(tempDetail?.request_quantum).toLocaleString(
                                                'id',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              ) + ' Ton'
                                        }
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-kuantumD')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={
                                          i18next.language === 'en'
                                            ? parseFloat(tempDetail?.fixed_quantum).toLocaleString(
                                                'en',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              ) + ' Ton'
                                            : parseFloat(tempDetail?.fixed_quantum).toLocaleString(
                                                'id',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              ) + ' Ton'
                                        }
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        // placeholder={t('Shipping Tolerance')}
                                        size='sm'
                                        type='text'
                                        id='shipping'
                                        value={
                                          tempDetail?.shipping_tolerance == 0
                                            ? ''
                                            : tempDetail?.shipping_tolerance + '%'
                                        }
                                        disabled
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.payment_type_1_desc}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('keterangan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.payment_note}
                                        type='text'
                                        as='textarea'
                                        style={{height: '40px'}}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='fs-6 mt-3'>{t('segment')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={t(tempDetail?.segment_name)}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={
                                          tempDetail?.end_user_multiple
                                            ? handleShowValue(
                                                tempDetail?.end_user,
                                                tempDetail?.end_user_multiple
                                              )
                                            : tempDetail?.end_user
                                        }
                                        as='textarea'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  { !isRetail(tempDetail?.sector_id) &&
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.amandement_notes}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row> }
                                </Col>
                                <Col md='6'>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={t(tempDetail.sector?.name)}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                    </Col>
                                    <Col md={8}>
                                      {tempDetail?.incoterm2 == null ? (
                                        <Form.Control
                                          value={
                                            tempDetail?.incoterm2_id == null ||
                                            tempDetail?.incoterm2_id == '0'
                                              ? ''
                                              : tempDetail?.incoterm2_id
                                          }
                                          type='text'
                                          disabled
                                          size='sm'
                                        />
                                      ) : (
                                        <Form.Control
                                          value={tempDetail?.incoterm2?.code}
                                          type='text'
                                          disabled
                                          size='sm'
                                        />
                                      )}
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        type='text'
                                        value={tempDetail.city?.city_name}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail.product_name}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-2'>
                                    <Col md={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('Harga Pengajuan')}/Ton</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={
                                          'Rp ' + (i18next.language === 'en'
                                            ? parseInt(tempDetail?.request_price).toLocaleString(
                                                'en',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              ) + '/Ton'
                                            : parseInt(tempDetail?.request_price).toLocaleString(
                                                'id',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              ) + '/Ton'
                                        )}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-2'>
                                    <Col md={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('sub-order-hargaD')}/Ton</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={
                                          'Rp ' + (i18next.language === 'en'
                                            ? parseInt(tempDetail?.fixed_price).toLocaleString(
                                                'en',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              ) + '/Ton'
                                            : parseInt(tempDetail?.fixed_price).toLocaleString(
                                                'id',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              ) + '/Ton'
                                        )}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>

                                  <Row className='my-7'>
                                    <Col sm={6} className='d-flex'>
                                      <Row sm={8} className='d-flex align-items-center'>
                                        <p className='fs-6'>{t('termasuk-ppn')}</p>
                                      </Row>
                                      <Row
                                        sm={4}
                                        className='d-flex justify-content-start align-items-center ms-4'
                                      >
                                        <Form.Check
                                          reverse
                                          name='ppn'
                                          type='checkbox'
                                          id='ckbox-ppn'
                                          checked={tempDetail?.include_ppn}
                                        />
                                      </Row>
                                    </Col>

                                    <Col sm={6} className='d-flex'>
                                      <Row sm={8} className='d-flex align-items-center'>
                                        <p className='fs-6'>{t('Formulated Price')}</p>
                                      </Row>
                                      <Row
                                        sm={4}
                                        className='d-flex justify-content-start align-items-center ms-4'
                                      >
                                        <Form.Check
                                          reverse
                                          name='formula_Price'
                                          type='checkbox'
                                          id='formula_Price'
                                          checked={tempDetail?.is_formulated_price}
                                        />
                                      </Row>
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.payment_type_2_desc}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail.product_spec}
                                        type='text'
                                        as='textarea'
                                        style={{height: '40px'}}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        as='textarea'
                                        style={{height: '40px'}}
                                        value={tempDetail?.notes}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  { !isRetail(tempDetail?.sector_id) && <>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.extension_date}
                                        type={tempDetail?.extension_date ? 'date' : 'text'}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  </> }
                                </Col>
                              </Row>
                            )}

                            {tempDetail?.sector_id == 3 && (
                              <Row>
                                <Col md='6'>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>Sales Org</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail.produsen?.name}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail.incoterm1?.code}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        type='text'
                                        value={tempDetail.province?.region_name}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail.product_type_desc}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={
                                          i18next.language === 'en'
                                            ? tempDetail?.request_quantum.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              }) +
                                              ' ' +
                                              'MT'
                                            : tempDetail?.request_quantum.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }) +
                                              ' ' +
                                              'MT'
                                        }
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-kuantumD')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={
                                          i18next.language === 'en'
                                            ? tempDetail?.fixed_quantum.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                              }) +
                                              ' ' +
                                              'MT'
                                            : tempDetail?.fixed_quantum.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                              }) +
                                              ' ' +
                                              'MT'
                                        }
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col sm={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        size='sm'
                                        type='text'
                                        id='shipping'
                                        value={
                                          tempDetail?.shipping_tolerance == 0
                                            ? ''
                                            : tempDetail?.shipping_tolerance + '%'
                                        }
                                        disabled
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.payment_type_1_desc}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4} className='d-flex align-items-center'>
                                      <p className='fs-6'>{t('keterangan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.payment_note}
                                        type='text'
                                        as='textarea'
                                        style={{height: '40px'}}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={
                                          tempDetail?.end_user_multiple
                                            ? handleShowValue(
                                                tempDetail?.end_user,
                                                tempDetail?.end_user_multiple
                                              )
                                            : tempDetail?.end_user
                                        }
                                        as='textarea'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  { !isRetail(tempDetail?.sector_id) &&
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.amandement_notes}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row> }
                                </Col>
                                <Col md='6'>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={t(tempDetail.sector?.name)}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                    </Col>
                                    <Col md={8}>
                                      {tempDetail?.incoterm2 == null ? (
                                        <Form.Control
                                          value={
                                            tempDetail?.incoterm2_id == null ||
                                            tempDetail?.incoterm2_id == '0'
                                              ? ''
                                              : tempDetail?.incoterm2_id
                                          }
                                          type='text'
                                          disabled
                                          size='sm'
                                        />
                                      ) : (
                                        <Form.Control
                                          value={tempDetail?.incoterm2?.code}
                                          type='text'
                                          disabled
                                          size='sm'
                                        />
                                      )}
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        type='text'
                                        value={tempDetail.city?.city_name}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail.product_name}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>

                                  <Row className='mb-2'>
                                    <Col md={4} className='d-flex align-items-center'>
                                      <p className='fs-6 mt-3'>{t('Harga Pengajuan')}/MT</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={
                                          'USD ' + i18next.language === 'en'
                                            ? parseFloat(tempDetail?.request_price).toLocaleString(
                                                'en',
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 2,
                                                }
                                              )
                                            : parseFloat(tempDetail?.request_price).toLocaleString(
                                                'id',
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 2,
                                                }
                                              )
                                        }
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>

                                  <Row className='mb-2'>
                                    <Col md={4} className='d-flex align-items-center'>
                                      <p className='fs-6 mt-3'>{t('sub-order-hargaD')}/MT</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={
                                          'USD ' + i18next.language === 'en'
                                            ? parseFloat(tempDetail?.fixed_price).toLocaleString(
                                                'en',
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 2,
                                                }
                                              )
                                            : parseFloat(tempDetail?.fixed_price).toLocaleString(
                                                'id',
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 2,
                                                }
                                              )
                                        }
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-4'>{t('Formulated Price')}</p>
                                    </Col>
                                    <Col sm={8} className='d-flex justify-content-start'>
                                      <Form.Check
                                        reverse
                                        name='formula_Price'
                                        className='mt-5 mb-2'
                                        type='checkbox'
                                        id='formula_Price'
                                        checked={tempDetail?.is_formulated_price}
                                      />
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.payment_type_2_desc}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail.product_spec}
                                        type='text'
                                        as='textarea'
                                        style={{height: '40px'}}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>

                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.notes}
                                        as='textarea'
                                        style={{height: '40px'}}
                                        type='text'
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>

                                  { !isRetail(tempDetail?.sector_id) && <>
                                  <Row className='mb-4'>
                                    <Col md={4}>
                                      <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                                    </Col>
                                    <Col md={8}>
                                      <Form.Control
                                        value={tempDetail?.extension_date}
                                        type={tempDetail?.extension_date ? 'date' : 'text'}
                                        disabled
                                        size='sm'
                                      />
                                    </Col>
                                  </Row>
                                  </> }
                                </Col>
                              </Row>
                            )}
                          </>
                        )}

                        {isRetail(tempDetail?.sector_id) && (
                          <Row>
                            <Col md='6'>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>Sales Org</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempDetail.produsen?.name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempDetail.incoterm1?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('destination-province')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={tempDetail.province_dest?.region_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('pickup-plant')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempDetail.plant + " - " + tempDetail.plant_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempDetail.product_name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              {/* <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('destination-province')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempDetail.province_dest?.region_name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row> */}
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      i18next.language === 'en'
                                        ? tempDetail?.fixed_quantum.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          }) +
                                          ' ' +
                                          'Ton'
                                        : tempDetail?.fixed_quantum.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          }) +
                                          ' ' +
                                          'Ton'
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempDetail?.payment_type_1_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempDetail?.payment_note}
                                    type='text'
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-3'>{t('commodity')}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    placeholder={t('commodity')}
                                    id='note'
                                    size='sm'
                                    style={{height: '40px'}}
                                    value={tempDetail?.commodity}
                                    disabled
                                  />
                                </Col>
                            </Row>
                            </Col>
                            <Col md='6'>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(tempDetail.sector?.name)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col md={8}>
                                  {tempDetail?.incoterm2 == null ? (
                                    <Form.Control
                                      value={
                                        tempDetail?.incoterm2_id == null ||
                                        tempDetail?.incoterm2_id == '0'
                                          ? ''
                                          : tempDetail?.incoterm2_id
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  ) : (
                                    <Form.Control
                                      value={tempDetail?.incoterm2?.code}
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('destination-city')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={tempDetail.city_dest?.city_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempDetail.product_type_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-spek')}
                                    {/* <span className='text-danger'>*</span> */}
                                  </p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    defaultValue={tempDetail.product_spec}
                                    onChange={(e: any) => setPspec(e.target.value)}
                                    type='text'
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled={!([0,1].includes(tempDetail.status) && roleUser == 'salesAdmin')}
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              {/* <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('destination-city')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempDetail.city_dest?.city_name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row> */}
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='fs-6 mt-3'>{t('Price')}/Ton <span className='text-danger'>*</span></p>
                                </Col>
                                <Col sm={8}>
                                    <InputGroup size='sm'>
                                      <InputGroup.Text id='basic-addon2'>
                                        <span className='px-1'>
                                          {tempDetail.sector_id == 3 ? 'USD ' : 'Rp '}
                                        </span>
                                      </InputGroup.Text>
                                      <CurrencyInput
                                        defaultValue={
                                          tempDetail?.request_price
                                        }
                                        placeholder={t('Price')}
                                        className='form-control form-control-sm'
                                        decimalSeparator={language === 'en' ? '.' : ','}
                                        groupSeparator={language === 'en' ? ',' : '.'}
                                        onValueChange={(value: any) => {
                                          setSubpriceApp(value?.replace(/,/g, '.'))
                                        }}
                                        disabled={!([0,1].includes(tempDetail.status) && roleUser == 'salesAdmin')}
                                        decimalsLimit={tempDetail.sector_id == 3 ? 2 : -1}
                                      />
                                    </InputGroup>
                                  </Col>
                                {/* <Col md={8}>
                                  <Form.Control
                                    value={
                                      'Rp ' + i18next.language === 'en'
                                        ? parseInt(tempDetail?.fixed_price).toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          }) + '/Ton'
                                        : parseInt(tempDetail?.fixed_price).toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          }) + '/Ton'
                                    }
                                    type='text'
                                    disabled={
                                      tempDetail.status != 0
                                      && tempDetail.status != 1
                                      && roleUser != 'salesAdmin'
                                    }
                                    size='sm'
                                  />
                                </Col> */}
                              </Row>
                <Row className='mb-4'>
                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Formulated Price')}</p>
                                </Col>
                                <Col md={8}>
                  <Form.Check
                    name='formula_Price'
                    type='checkbox'
                    defaultChecked={tempDetail?.is_formulated_price}
                    disabled={true}
                    id='formula_Price'
                  />
                                </Col>
                </Row>
               
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('End Customer')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      tempDetail?.end_user_multiple
                                        ? handleShowValue(
                                            tempDetail?.end_user,
                                            tempDetail?.end_user_multiple
                                          )
                                        : tempDetail?.end_user
                                    }
                                    as='textarea'
                                    style={{height: '40px'}}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={tempDetail?.notes}
                                    as='textarea'
                                    style={{height: '40px'}}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202' ? (
                      <>
                        {tempDetail.status === 1 && roleUser == 'salesAdmin' ? (
                          <>
                            <Row>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('kontrak-produsen')}
                                      <span className='text-danger'>*</span>
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Select
                                      aria-label='Default select example'
                                      size='sm'
                                      id='produsen'
                                      onChange={(e: any) => {
                                        const code = e.target.value.split('~#~')
                                        setTempDetail((state: any) => ({
                                          ...state,
                                          produsen: {...state.code, code: code[0], name: code[1]},
                                          request_price: 0,
                                          request_quantum: 0,
                                          product_name: '0',
                                          material_number: null,
                                          include_ppn: false,
                                        }))
                                        setPname('')
                                        setProdusenCode(code[0])
                                        setPnumber('')
                                        setIsProdusen(!isProdusen)
                                        setChange(!change)
                                      }}
                                    >
                                      {fullProdusen.map((items: any) => (
                                        <>
                                          {tempDetail.produsen?.name == items.label ? (
                                            <option value={items.value} selected>
                                              {items.label}
                                            </option>
                                          ) : (
                                            <option value={items.value}>{items.label}</option>
                                          )}
                                        </>
                                      ))}
                                    </Form.Select>
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>Incoterm</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Select
                                      aria-label='Default select example'
                                      size='sm'
                                      id='incoterm1'
                                      key={idSektor + produsen + fullIncoterm}
                                      onChange={(e: any) => {
                                        const code = e.target.value.split('~#~')
                                        setTempDetail((state: any) => ({
                                          ...state,
                                          incoterm1: {
                                            ...state.incoterm1,
                                            code: code[1],
                                            id: code[0],
                                          },
                                        }))
                                        separateValue2(
                                          setIncoterm1,
                                          e.target.value,
                                          setIncoterm1Desc
                                        )
                                      }}
                                    >
                                      <option value='0'>
                                        {t('pilih')} {t('sub-order-incoterm1')}
                                      </option>
                                      {fullIncoterm.map((items: any) => (
                                        <>
                                          {tempDetail.incoterm1?.code == items.label ? (
                                            <option value={items.value} selected>
                                              {items.label}
                                            </option>
                                          ) : (
                                            <option value={items.value}>{items.label}</option>
                                          )}
                                        </>
                                      ))}
                                    </Form.Select>
                                  </Col>
                                </Row>

                                {tempDetail?.sector_id != 3 ? (
                                  <>
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                      </Col>
                                      <Col sm={8}>
                                        <Select
                                          id='provinsi'
                                          placeholder={t('pilih')}
                                          defaultValue={
                                            fullProvince[
                                              fullProvince.findIndex(
                                                (item: any) =>
                                                  item.label === tempDetail?.province?.region_name
                                              )
                                            ]
                                          }
                                          onChange={(e: any) => {
                                            const tmp = e.value.split('~#~')
                                            // setTempDetail((state: any) => ({ ...state, city: { ...state.city, city_name: '' }, province: { ...state.province, id: tmp[0], region_name: tmp[1] }, request_quantum: 0, request_price: 0, include_ppn: false }))
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              city: {...state.city, city_name: ''},
                                              province: {
                                                ...state.province,
                                                id: tmp[0],
                                                region_name: tmp[1],
                                              },
                                            }))
                                            setProvince(tmp[0])
                                            setChange(!change)
                                            // fieldClearer(5)
                                          }}
                                          options={fullProvince}
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : (
                                  ''
                                )}

                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Select
                                      size='sm'
                                      aria-label='Default select example'
                                      id='jenis'
                                      onChange={(e: any) => {
                                        const tmp = e.target.value.split('~#~')
                                        setTempDetail((state: any) => ({
                                          ...state,
                                          product_name: '',
                                          product_type_desc: tmp[0],
                                          product_type: tmp[1],
                                        }))
                                        productTypeChange(e.target.value)
                                      }}
                                    >
                                      <option hidden value='~#~'>
                                        {t('Pilih-productType')}
                                      </option>
                                      {fullProductType.map((item: any) => {
                                        return (
                                          <>
                                            {item.id != 12 && (
                                              <>
                                                {item.material_group_desc ==
                                                tempDetail?.product_type_desc ? (
                                                  <option
                                                    selected
                                                    value={
                                                      item.material_group_desc +
                                                      '~#~' +
                                                      item.material_group
                                                    }
                                                  >
                                                    {t(item.material_group_desc)}
                                                  </option>
                                                ) : (
                                                  <option
                                                    value={
                                                      item.material_group_desc +
                                                      '~#~' +
                                                      item.material_group
                                                    }
                                                  >
                                                    {t(item.material_group_desc)}
                                                  </option>
                                                )}
                                              </>
                                            )}
                                          </>
                                        )
                                      })}
                                    </Form.Select>
                                  </Col>
                                </Row>

                                {parseInt(pnumber) == 0 && (
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        as='textarea'
                                        placeholder={t('sub-order-catatan')}
                                        defaultValue={tempDetail?.notes}
                                        id='note'
                                        size='sm'
                                        style={{height: '40px'}}
                                        onChange={(e: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            notes: e.target.value,
                                          }))
                                          setNote(e.target.value)
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                )}

                                <Row className='mb-4'>
                                  <Col sm={4} className='d-flex align-items-center'>
                                    <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <InputGroup size='sm'>
                                      <CurrencyInput
                                        className='form-control form-control-sm'
                                        id='kuantum'
                                        key={change.toString()}
                                        defaultValue={tempDetail?.request_quantum}
                                        decimalSeparator={language === 'en' ? '.' : ','}
                                        groupSeparator={language === 'en' ? ',' : '.'}
                                        onValueChange={(value: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            request_quantum: value?.replace(/,/g, '.'),
                                          }))
                                          setQuantum(value?.replace(/,/g, '.'))
                                        }}
                                        decimalsLimit={3}
                                      />
                                      <InputGroup.Text id='basic-addon2'>
                                        {tempDetail?.sector_id === 3 ? 'MT' : 'Ton'}
                                      </InputGroup.Text>
                                    </InputGroup>
                                  </Col>
                                </Row>
                                <Row
                                  className='mb-4'
                                  hidden={
                                    regarding == 'PO002' &&
                                    roleUser == 'salesAdmin' &&
                                    (tempDetail.status == 1 || tempDetail.status == 0)
                                      ? false
                                      : true
                                  }
                                >
                                  <Col sm={4} className='d-flex align-items-center'>
                                    <p className='fs-6'>{t('Kuantum PengajuanD')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <InputGroup size='sm'>
                                      <CurrencyInput
                                        defaultValue={
                                          tempDetail.fixed_quantum2 ? tempDetail.fixed_quantum2 : ''
                                        }
                                        id='kuantum'
                                        key={change.toString()}
                                        placeholder={t('Kuantum PengajuanD')}
                                        className='form-control form-control-sm'
                                        decimalSeparator={language === 'en' ? '.' : ','}
                                        groupSeparator={language === 'en' ? ',' : '.'}
                                        onValueChange={(value: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            fixed_quantum2: value?.replace(/,/g, '.'),
                                            fixed_quantum: value?.replace(/,/g, '.'),
                                          }))
                                          setQuantumApp(value?.replace(/,/g, '.'))
                                        }}
                                        decimalsLimit={3}
                                      />
                                      <InputGroup.Text id='basic-addon2'>
                                        {tempDetail?.sector_id === 3 ? 'MT' : 'Ton'}
                                      </InputGroup.Text>
                                    </InputGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('sub-order-endUser')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    {idSektor === 1 ? (
                                      <>
                                        {!isNoEnduser ? (
                                          <MultiSelect
                                            options={fullEndUser?.map((item: any) => {
                                              return {label: t(item.name), value: item.name}
                                            })}
                                            value={arrayEnduser}
                                            onChange={(e: any) => {
                                              let user = handleUser(e)
                                              setEnduserArray(e)
                                              setTempDetail((state: any) => ({
                                                ...state,
                                                end_user: user.toString(),
                                                end_user_multiple: true,
                                              }))
                                            }}
                                            labelledBy='Select'
                                          />
                                        ) : (
                                          <Form.Control
                                            size='sm'
                                            as='textarea'
                                            id='enduser'
                                            style={{height: '40px'}}
                                            placeholder={t('End Customer')}
                                            defaultValue={isNoEnduser ? '' : tempDetail?.end_user}
                                            onChange={(e: any) => {
                                              setTempDetail((state: any) => ({
                                                ...state,
                                                end_user: e.target.value,
                                                end_user_multiple: false,
                                              }))
                                              setEnduser(e.target.value)
                                              setEnduserDesc(e.target.value)
                                            }}
                                          />
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <Form.Control
                                          size='sm'
                                          as='textarea'
                                          id='enduser'
                                          style={{height: '40px'}}
                                          placeholder={t('End Customer')}
                                          defaultValue={tempDetail?.end_user}
                                          onChange={(e: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              end_user: e.target.value,
                                              end_user_multiple: false,
                                            }))
                                            setEnduser(e.target.value)
                                            setEnduserDesc(e.target.value)
                                          }}
                                        />
                                      </>
                                    )}
                                  </Col>
                                </Row>

                                {idSektor === 1 && (
                                  <Row className='mb-4'>
                                    <Col sm={4}></Col>
                                    <Col sm={8} className='d-flex'>
                                      <Form.Check
                                        onClick={() => setIsNoEnduser(!isNoEnduser)}
                                        defaultChecked={isNoEnduser}
                                        disabled={disableCKBOX}
                                        name='ppn'
                                        className='mt-4 mb-2'
                                        type='checkbox'
                                        id='noenduser'
                                      />
                                      {i18next.language == 'en' ? (
                                        <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                      ) : (
                                        <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                      )}
                                    </Col>
                                  </Row>
                                )}
                              </Col>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      value={t(tempDetail.sector?.name)}
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                {parseInt(pnumber) !== 0 && (
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        as='textarea'
                                        placeholder={t('sub-order-catatan')}
                                        defaultValue={tempDetail?.notes}
                                        id='note'
                                        size='sm'
                                        style={{height: '40px'}}
                                        onChange={(e: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            notes: e.target.value,
                                          }))
                                          setNote(e.target.value)
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                )}

                                {tempDetail?.sector_id != 3 ? (
                                  <>
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                      </Col>
                                      <Col sm={8}>
                                        <Select
                                          id='kota'
                                          placeholder={t('pilih')}
                                          key={province}
                                          defaultValue={
                                            fullCity[
                                              fullCity.findIndex(
                                                (item: any) =>
                                                  item.label === tempDetail.city?.city_name
                                              )
                                            ]
                                          }
                                          onChange={(e: any) => {
                                            const tmp = e.value.split('~#~')
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              city_id: tmp[0],
                                              city: {...state.city, id: tmp[0], city_name: tmp[1]},
                                            }))
                                            setCity(tmp[0])
                                            // fieldClearer(4)
                                          }}
                                          options={fullCity}
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : (
                                  ''
                                )}
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Select
                                      id='nama'
                                      placeholder={t('pilih')}
                                      key={ptype + tempDetail.material_number + fullProductName}
                                      defaultValue={
                                        fullProductName[
                                          fullProductName.findIndex(
                                            (item: any) =>
                                              item.truevalue ==
                                              parseInt(tempDetail?.material_number)
                                          )
                                        ]
                                      }
                                      onChange={(e: any) => {
                                        // productNameChange(e.target.value)
                                        const tmp = e.value.split('~#~')
                                        const productName = tmp[1]
                                        setTempDetail((state: any) => ({
                                          ...state,
                                          material_number: tmp[0],
                                          unit: tmp[2],
                                          product_name: productName,
                                        }))
                                        setPnumber(tmp[0])
                                        setPunit(tmp[2])
                                        setPname(productName)
                                        // fieldClearer(1)
                                      }}
                                      options={fullProductName}
                                    />
                                  </Col>
                                </Row>

                                {parseInt(pnumber) == 0 && (
                                  <Row className='mb-4'>
                                    <Col sm={4}>
                                      <p className='fs-6'>Custom Product Name</p>
                                    </Col>
                                    <Col sm={8}>
                                      <Form.Control
                                        placeholder=' Custom Product Name'
                                        size='sm'
                                        defaultValue={pname}
                                        aria-label='Default select example'
                                        type='text'
                                        id='custom'
                                        onChange={(e: any) => setPname(e.target.value)}
                                      />
                                    </Col>
                                  </Row>
                                )}

                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('Harga Pengajuan')}/
                                      {tempDetail?.sector_id === 3 ? 'MT' : 'Ton'}
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    {tempDetail.sector_id != 3 ? (
                                      <InputGroup size='sm'>
                                        <InputGroup.Text>
                                          <span className='px-1'>Rp</span>
                                        </InputGroup.Text>
                                        <CurrencyInput
                                          className='form-control form-control-sm'
                                          id='hargap'
                                          key={change.toString()}
                                          value={tempDetail?.request_price}
                                          decimalSeparator={language === 'en' ? '.' : ','}
                                          groupSeparator={language === 'en' ? ',' : '.'}
                                          onValueChange={(value: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              request_price: value?.replace(/,/g, '.'),
                                            }))
                                            setSubprice(value?.replace(/,/g, '.'))
                                          }}
                                          decimalsLimit={-1}
                                          placeholder={t('Harga Pengajuan')}
                                        />
                                      </InputGroup>
                                    ) : (
                                      <InputGroup size='sm'>
                                        <InputGroup.Text>
                                          <span className='px-1'>USD</span>
                                        </InputGroup.Text>
                                        <CurrencyInput
                                          className='form-control form-control-sm'
                                          id='hargap'
                                          key={change.toString()}
                                          defaultValue={tempDetail?.request_price}
                                          decimalSeparator={language === 'en' ? '.' : ','}
                                          groupSeparator={language === 'en' ? ',' : '.'}
                                          onValueChange={(value: any) => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              request_price: value?.replace(/,/g, '.'),
                                            }))
                                            setSubprice(value?.replace(/,/g, '.'))
                                          }}
                                          decimalsLimit={2}
                                          placeholder={t('Harga Pengajuan')}
                                        />
                                      </InputGroup>
                                    )}
                                  </Col>
                                </Row>
                                <Row
                                  className='mb-4'
                                  hidden={
                                    regarding == 'PO002' &&
                                    roleUser == 'salesAdmin' &&
                                    (tempDetail.status == 1 || tempDetail.status == 0)
                                      ? false
                                      : true
                                  }
                                >
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('sub-order-hargaD')}/
                                      {tempDetail?.sector_id === 3 ? 'MT' : 'Ton'}
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <InputGroup size='sm'>
                                      <InputGroup.Text id='basic-addon2'>
                                        <span className='px-1'>
                                          {tempDetail.sector_id == 3 ? 'USD ' : 'Rp '}
                                        </span>
                                      </InputGroup.Text>
                                      <CurrencyInput
                                        defaultValue={
                                          tempDetail.fixed_price2 ? tempDetail.fixed_price2 : ''
                                        }
                                        id='kuantum'
                                        key={change.toString()}
                                        placeholder={t('sub-order-hargaD')}
                                        className='form-control form-control-sm'
                                        decimalSeparator={language === 'en' ? '.' : ','}
                                        groupSeparator={language === 'en' ? ',' : '.'}
                                        onValueChange={(value: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            fixed_price2: value?.replace(/,/g, '.'),
                                            fixed_price: value?.replace(/,/g, '.'),
                                          }))
                                          setSubpriceApp(value?.replace(/,/g, '.'))
                                        }}
                                        decimalsLimit={tempDetail.sector_id == 3 ? 2 : -1}
                                      />
                                    </InputGroup>
                                  </Col>
                                </Row>

                                {tempDetail?.sector_id != 3 ? (
                                  <>
                                    <Row className='my-7'>
                                      <Col sm={4} className='d-flex align-items-center'>
                                        <p className='fs-6'>{t('termasuk-ppn')}</p>
                                      </Col>
                                      <Col
                                        sm={8}
                                        className='d-flex justify-content-start align-items-center'
                                      >
                                        <Form.Check
                                          reverse
                                          name='ppn'
                                          type='checkbox'
                                          id='ckbox-ppn'
                                          defaultChecked={tempDetail?.include_ppn}
                                          onClick={() => {
                                            setTempDetail((state: any) => ({
                                              ...state,
                                              include_ppn: !state.include_ppn,
                                            }))
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <>
                            <Row>
                              <Col md={6}>
                                <Row className='mb-3'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      value={tempDetail.produsen?.name}
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>Incoterm</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      value={tempDetail?.incoterm1?.code}
                                      type='text'
                                      size='sm'
                                      disabled
                                    />
                                  </Col>
                                </Row>

                                {tempDetail?.sector_id != 3 ? (
                                  <>
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                      </Col>
                                      <Col sm={8}>
                                        <Form.Control
                                          type='text'
                                          size='sm'
                                          value={tempDetail?.province?.region_name}
                                          disabled
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : (
                                  ''
                                )}

                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      value={tempDetail.product_type_desc}
                                      type='text'
                                      size='sm'
                                      disabled
                                    />
                                  </Col>
                                </Row>

                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('Kuantum Pengajuan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <InputGroup size='sm'>
                                      <Form.Control
                                        value={
                                          (i18next.language === 'en'
                                            ? parseFloat(tempDetail?.fixed_quantum).toLocaleString(
                                                'en',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              )
                                            : parseFloat(tempDetail?.fixed_quantum).toLocaleString(
                                                'id',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              )) + (tempDetail?.sector_id === 3 ? ' MT' : ' Ton')
                                        }
                                        type='text'
                                        size='sm'
                                        disabled
                                      />
                                    </InputGroup>
                                  </Col>
                                </Row>
                                <Row
                                  className='mb-3'
                                  hidden={
                                    regarding == 'PO002' &&
                                    roleUser == 'salesAdmin' &&
                                    (tempDetail.status == 1 || tempDetail.status == 0)
                                      ? false
                                      : true
                                  }
                                >
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>{t('Kuantum PengajuanD')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <InputGroup size='sm'>
                                      <CurrencyInput
                                        defaultValue={
                                          tempDetail.fixed_quantum2 ? tempDetail.fixed_quantum2 : ''
                                        }
                                        placeholder={t('Kuantum PengajuanD')}
                                        className='form-control form-control-sm'
                                        decimalSeparator={language === 'en' ? '.' : ','}
                                        groupSeparator={language === 'en' ? ',' : '.'}
                                        onValueChange={(value: any) => {
                                          setQuantumApp(value?.replace(/,/g, '.'))
                                        }}
                                        decimalsLimit={3}
                                      />
                                      <InputGroup.Text id='basic-addon2'>
                                        {tempDetail?.sector_id === 3 ? 'MT' : 'Ton'}
                                      </InputGroup.Text>
                                    </InputGroup>
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('End Customer')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      value={
                                        tempDetail?.end_user_multiple
                                          ? handleShowValue(
                                              tempDetail?.end_user,
                                              tempDetail?.end_user_multiple
                                            )
                                          : tempDetail?.end_user
                                      }
                                      as='textarea'
                                      style={{height: '40px'}}
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col md={6}>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      value={t(tempDetail.sector?.name)}
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      value={tempDetail?.notes}
                                      as='textarea'
                                      size='sm'
                                      style={{height: '40px'}}
                                      disabled
                                    />
                                  </Col>
                                </Row>
                                {tempDetail?.sector_id != 3 ? (
                                  <>
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                      </Col>
                                      <Col sm={8}>
                                        <Form.Control
                                          type='text'
                                          size='sm'
                                          value={tempDetail?.city?.city_name}
                                          disabled
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : (
                                  ''
                                )}
                                <Row className='mb-4'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>{t('sub-order-produk')}</p>
                                  </Col>
                                  <Col sm={8}>
                                    <Form.Control
                                      value={tempDetail.product_name}
                                      type='text'
                                      size='sm'
                                      disabled
                                    />
                                  </Col>
                                </Row>
                                <Row className='mb-3'>
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('Harga Pengajuan')}/
                                      {tempDetail?.sector_id === 3 ? 'MT' : 'Ton'}
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    {tempDetail.sector_id != 3 ? (
                                      <Form.Control
                                        value={
                                          'Rp ' + (i18next.language === 'en'
                                            ? parseInt(tempDetail?.request_price).toLocaleString(
                                                'en',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              )
                                            : parseInt(tempDetail?.request_price).toLocaleString(
                                                'id',
                                                {
                                                  maximumFractionDigits: 4,
                                                }
                                              )
                                        )}
                                        type='text'
                                        size='sm'
                                        disabled
                                      />
                                    ) : (
                                      <Form.Control
                                        value={
                                          'USD ' + i18next.language === 'en'
                                            ? parseFloat(tempDetail?.request_price).toLocaleString(
                                                'en',
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 2,
                                                }
                                              )
                                            : parseFloat(tempDetail?.request_price).toLocaleString(
                                                'id',
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 2,
                                                }
                                              )
                                        }
                                        type='text'
                                        size='sm'
                                        disabled
                                      />
                                    )}
                                  </Col>
                                </Row>
                                <Row
                                  className='mb-3'
                                  hidden={
                                    regarding == 'PO002' &&
                                    roleUser == 'salesAdmin' &&
                                    (tempDetail.status == 1 || tempDetail.status == 0)
                                      ? false
                                      : true
                                  }
                                >
                                  <Col sm={4}>
                                    <p className='fs-6 mt-3'>
                                      {t('sub-order-hargaD')}/
                                      {tempDetail?.sector_id === 3 ? 'MT' : 'Ton'}
                                    </p>
                                  </Col>
                                  <Col sm={8}>
                                    <InputGroup size='sm'>
                                      <InputGroup.Text id='basic-addon2'>
                                        <span className='px-1'>
                                          {tempDetail.sector_id == 3 ? 'USD ' : 'Rp '}
                                        </span>
                                      </InputGroup.Text>
                                      <CurrencyInput
                                        defaultValue={
                                          tempDetail.fixed_price2 ? tempDetail.fixed_price2 : ''
                                        }
                                        placeholder={t('sub-order-hargaD')}
                                        className='form-control form-control-sm'
                                        decimalSeparator={language === 'en' ? '.' : ','}
                                        groupSeparator={language === 'en' ? ',' : '.'}
                                        onValueChange={(value: any) => {
                                          setSubpriceApp(value?.replace(/,/g, '.'))
                                        }}
                                        decimalsLimit={tempDetail.sector_id == 3 ? 2 : -1}
                                      />
                                    </InputGroup>
                                  </Col>
                                </Row>

                                {tempDetail?.sector_id != 3 ? (
                                  <>
                                    <Row className='mb-4'>
                                      <Col sm={4}>
                                        <p className='fs-6 mt-3'>{t('termasuk-ppn')}</p>
                                      </Col>
                                      <Col sm={8} className='d-flex justify-content-start'>
                                        <Form.Check
                                          reverse
                                          name='ppn'
                                          className='mt-3 mb-2'
                                          type='checkbox'
                                          id='ckbox-ppn'
                                          checked={tempDetail.include_ppn}
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </Col>
                            </Row>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {tempDetail.status === 1 && roleUser == 'salesAdmin' ? (
                          <>
                            <Row className='mb-3'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  aria-label='Default select example'
                                  size='sm'
                                  id='produsen'
                                  onChange={(e: any) => {
                                    const code = e.target.value.split('~#~')
                                    setTempDetail((state: any) => ({
                                      ...state,
                                      produsen: {...state.code, code: code[0], name: code[1]},
                                      material_number: null,
                                      product_name: null,
                                    }))
                                    setProdusenCode(code[0])
                                    setIsProdusen(!isProdusen)
                                  }}
                                >
                                  {fullProdusen.map((items: any) => (
                                    <>
                                      {tempDetail.produsen?.name == items.label ? (
                                        <option value={items.value} selected>
                                          {items.label}
                                        </option>
                                      ) : (
                                        <option value={items.value}>{items.label}</option>
                                      )}
                                    </>
                                  ))}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className='mb-3'>
                              <Col sm={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  value={t(tempDetail.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='jenis'
                                  onChange={(e: any) => {
                                    const tmp = e.target.value.split('~#~')
                                    setTempDetail((state: any) => ({
                                      ...state,
                                      product_name: '',
                                      product_type_desc: tmp[0],
                                      product_type: tmp[1],
                                    }))
                                    productTypeChange(e.target.value)
                                  }}
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-productType')}
                                  </option>
                                  {fullProductType.map((item: any) => {
                                    return (
                                      <>
                                        {item.id != 12 && (
                                          <>
                                            {item.material_group_desc ==
                                            tempDetail?.product_type_desc ? (
                                              <option
                                                selected
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            ) : (
                                              <option
                                                value={
                                                  item.material_group_desc +
                                                  '~#~' +
                                                  item.material_group
                                                }
                                              >
                                                {t(item.material_group_desc)}
                                              </option>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='mt-4 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='nama'
                                  placeholder={t('pilih')}
                                  key={ptype + fullProductName}
                                  value={
                                    fullProductName[
                                      fullProductName.findIndex(
                                        (item: any) =>
                                          item.truevalue == parseInt(tempDetail?.material_number)
                                      )
                                    ]
                                  }
                                  onChange={(e: any) => {
                                    // productNameChange(e.target.value)
                                    const tmp = e.value.split('~#~')
                                    const productName = tmp[1]
                                    setTempDetail((state: any) => ({
                                      ...state,
                                      material_number: tmp[0],
                                      unit: tmp[2],
                                      product_name: productName,
                                    }))
                                    setPnumber(tmp[0])
                                    setPunit(tmp[2])
                                    setPname(productName)
                                    // fieldClearer(1)
                                  }}
                                  options={fullProductName}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('sub-order-catatan')}
                                  defaultValue={tempDetail?.notes}
                                  id='note'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => {
                                    setTempDetail((state: any) => ({
                                      ...state,
                                      notes: e.target.value,
                                    }))
                                    setNote(e.target.value)
                                  }}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-endUser')}</p>
                              </Col>
                              <Col sm={8}>
                                {idSektor === 1 ? (
                                  <>
                                    {tempDetail.end_user_multiple ? (
                                      <MultiSelect
                                        options={fullEndUser?.map((item: any) => {
                                          return {label: t(item.name), value: item.name}
                                        })}
                                        value={arrayEnduser}
                                        onChange={(e: any) => {
                                          let user = handleUser(e)
                                          setEnduserArray(e)
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            end_user: user.toString(),
                                            end_user_multiple: true,
                                          }))
                                        }}
                                        labelledBy='Select'
                                      />
                                    ) : (
                                      <Form.Control
                                        size='sm'
                                        as='textarea'
                                        id='enduser'
                                        style={{height: '40px'}}
                                        placeholder={t('End Customer')}
                                        defaultValue={
                                          tempDetail.end_user_multiple ? '' : tempDetail?.end_user
                                        }
                                        onChange={(e: any) => {
                                          setTempDetail((state: any) => ({
                                            ...state,
                                            end_user: e.target.value,
                                            end_user_multiple: false,
                                          }))
                                          setEnduser(e.target.value)
                                          setEnduserDesc(e.target.value)
                                        }}
                                      />
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <Form.Control
                                      size='sm'
                                      as='textarea'
                                      id='enduser'
                                      style={{height: '40px'}}
                                      placeholder={t('End Customer')}
                                      defaultValue={tempDetail?.end_user}
                                      onChange={(e: any) => {
                                        setTempDetail((state: any) => ({
                                          ...state,
                                          end_user: e.target.value,
                                          end_user_multiple: false,
                                        }))
                                        setEnduser(e.target.value)
                                        setEnduserDesc(e.target.value)
                                      }}
                                    />
                                  </>
                                )}
                              </Col>
                            </Row>

                            {idSektor === 1 && (
                              <Row className='mb-4'>
                                <Col sm={4}></Col>
                                <Col sm={8} className='d-flex'>
                                  <Form.Check
                                    onChange={(e: any) => {
                                      setTempDetail((state: any) => ({
                                        ...state,
                                        end_user_multiple: !tempDetail.end_user_multiple,
                                        end_user: null,
                                      }))
                                      setEnduserArray([])
                                    }}
                                    defaultChecked={isNoEnduser}
                                    disabled={disableCKBOX}
                                    name='ppn'
                                    className='mt-4 mb-2'
                                    type='checkbox'
                                    id='noenduser'
                                  />
                                  {i18next.language == 'en' ? (
                                    <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                  ) : (
                                    <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                  )}
                                </Col>
                              </Row>
                            )}
                            <div className='d-flex justify-content-end'>
                              <Button
                                variant='primary'
                                onClick={() => handleSaveDetailNonSalesType()}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/arrows/arr075.svg'
                                  className='svg-icon-3'
                                />
                                {t('order-kirim')}
                              </Button>
                            </div>
                          </>
                        ) : (
                          <>
                            <Row className='mb-3'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  value={tempDetail.produsen?.name}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-3'>
                              <Col sm={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  value={t(tempDetail.sector?.name)}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  value={tempDetail.product_type_desc}
                                  type='text'
                                  size='sm'
                                  disabled
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='mt-4 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  value={tempDetail.product_name}
                                  type='text'
                                  size='sm'
                                  disabled
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  value={tempDetail?.notes}
                                  as='textarea'
                                  size='sm'
                                  style={{height: '40px'}}
                                  disabled
                                />
                              </Col>
                            </Row>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}

                { roleUser == 'salesAdmin' && <>
                  { ((showPurchaseForm && tempDetail.sector_id != 2 && tempDetail.status === 1)) ? <></> :
                    <div className='d-flex justify-content-end'>
                      <Button
                        hidden={
                          (regarding == 'PO002' &&
                          (tempDetail.status == 1 || tempDetail.status == 0) &&
                          (nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202'))
                          && hakAkses?.update
                          ||
                          (
                            regarding == 'PO001' &&
                            (tempDetail.status == 1 || tempDetail.status == 0)
                            && tempDetail.sector_id == 2
                            && hakAkses?.update
                          )
                            ? false
                            : true
                        }
                        variant='primary'
                        onClick={() => handleSaveDetailNonSales()}
                      >
                        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                        {t('order-kirim')}
                      </Button>
                    </div>
                  }
                </> }
              </>
            )}
          </Modal.Body>
        </Modal>

        {/* modal jadwal local*/}
        <Modal
          show={show3}
          onHide={() => {
            handleClose3()
            setTempTanggal(0)
            sessionStorage.removeItem('isCustomer')
          }}
          centered
          size='xl'
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {sektorID != 3 ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
              {pname} | {fixedQuantum2} Ton
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            <div hidden={revisiIndex != 0 || numberRevised > 0 ? true : false}>
              <AddRemoveJadwal id={subOrderID} is_amendment={is_amendment} isDisable={isDisable} />
            </div>
            <div hidden={revisiIndex != 0 || numberRevised > 0 ? false : true}>
              <div className='table-responsive bdr mt-1'>
                <table className='table-border w-100'>
                  <thead>
                    <tr className='d-flex'>
                      {/* <th style={{ width: '60px' }} className="text-center">{t('order-aksi')}</th> */}
                      <th style={{width: '165.5px'}} className='text-center'>
                        {t('order-pengambilan')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-tanggal')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-minggu')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-bulan')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-tahun')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-tonase')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <div>
                      <tr className='d-flex'>
                        <td style={{width: '165.5px'}} className='text-center'>
                          <p className='mt-2'>
                            {detailOrder[temporaryIndex]?.schedules?.length + 1}
                          </p>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <Form.Select
                            aria-label='Default select example'
                            id='jadwaltanggal'
                            key={tempJadwal}
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            onChange={(e: any) => setTempTanggal(parseInt(e.target.value))}
                          >
                            <option selected value={0} disabled hidden>
                              {t('Pilih-Tanggal')}
                            </option>
                            {daysInMonth != 0 ? loopTanggal(daysInMonth) : ''}
                          </Form.Select>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          {/* <Form.Select
                            aria-label='Default select example'
                            style={{ padding: '0.775rem 3rem 0.4rem 1rem' }}
                            id='jadwalminggu'
                            onChange={(e: any) => setTempMinggu(parseInt(e.target.value))}
                          >
                            <option selected disabled>
                              {t('Pilih-minggu')}
                            </option>
                            <option value='1'>{t('Week')}1</option>
                            <option value='2'>{t('Week')}2</option>
                            <option value='3'>{t('Week')}3</option>
                            <option value='4'>{t('Week')}4</option>
                          </Form.Select> */}
                          <Form.Control
                            aria-label='Default select example'
                            id='jadwalminggu'
                            placeholder={t('order-minggu')}
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            value={tempTanggal == 0 ? '' : t('Week') + Math.ceil(tempTanggal / 7)}
                          />
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <Form.Select
                            aria-label='Default select example'
                            id='jadwalbulan'
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            onChange={(e: any) => setTempBulan(parseInt(e.target.value))}
                          >
                            <option selected disabled>
                              {t('Pilih-Month')}
                            </option>
                            <option value='1'>{t('Januari')}</option>
                            <option value='2'>{t('Februari')}</option>
                            <option value='3'>{t('Maret')}</option>
                            <option value='4'>{t('April')}</option>
                            <option value='5'>{t('Mei')}</option>
                            <option value='6'>{t('Juni')}</option>
                            <option value='7'>{t('Juli')}</option>
                            <option value='8'>{t('Agustus')}</option>
                            <option value='9'>{t('September')}</option>
                            <option value='10'>{t('Oktober')}</option>
                            <option value='11'>{t('November')}</option>
                            <option value='12'>{t('Desember')}</option>
                          </Form.Select>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <Form.Select
                            aria-label='Default select example'
                            id='jadwaltahun'
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            onChange={(e: any) => setTempTahun(parseInt(e.target.value))}
                          >
                            <option selected disabled>
                              {t('Pilih-Year')}
                            </option>
                            {listYear.map((data: string, index: number) => {
                              return (
                                <option key={data ?? index} value={data}>
                                  {data}
                                </option>
                              )
                            })}
                            {/* <option value='2023'>2023</option>
                      <option value='2024'>2024</option>
                      <option value='2025'>2025</option>
                      <option value='2026'>2026</option>
                      <option value='2027'>2027</option>
                      <option value='2028'>2028</option>
                      <option value='2029'>2029</option>
                      <option value='2030'>2030</option>
                      <option value='2031'>2031</option> */}
                          </Form.Select>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <CurrencyInput
                            id='jadwalton'
                            className='form-control form-control-sm'
                            placeholder={t('order-tonase')}
                            key={tempTahun}
                            style={{width: '90%'}}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setTempTon(parseFloat(value?.replace(/,/g, '.')))
                            }}
                            decimalsLimit={3}
                          />
                        </td>
                      </tr>
                    </div>
                  </tbody>
                </table>
              </div>

              <div className='mt-5 mb-5'>
                <div className='d-flex justify-content-end mt-3'>
                  <Button
                    variant='primary'
                    onClick={() => {
                      sendJadwal()
                    }}
                  >
                    {t('order-kirim')}
                  </Button>
                </div>
              </div>
              <div
                className='table-responsive bdr mt-3'
                hidden={
                  detailOrder[temporaryIndex]?.schedules?.length < 1 ||
                  detailOrder[temporaryIndex]?.schedules == undefined
                    ? true
                    : false
                }
              >
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='border-bottom'>
                    <tr className='fw-bold d-flex'>
                      <th className='text-center' style={{width: '156.3px'}}>
                        {t('order-pengambilan')}
                      </th>
                      <th className='text-center' style={{width: '156.3px'}}>
                        {t('order-tanggal')}
                      </th>
                      <th className='text-center' style={{width: '156.3px'}}>
                        {t('order-minggu')}
                      </th>
                      <th className='text-center' style={{width: '156.3px'}}>
                        {t('order-bulan')}
                      </th>
                      <th className='text-center' style={{width: '156.3px'}}>
                        {t('order-tahun')}
                      </th>
                      <th className='text-center' style={{width: '156.3px'}}>
                        {t('order-tonase')}
                      </th>
                      <th className='text-center' style={{width: '156.3px'}}>
                        {t('order-aksi')}
                      </th>
                    </tr>
                  </thead>
                  {detailOrder[temporaryIndex]?.schedules?.map((data: any, _index: number) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className='d-flex'>
                        <td className='text-center' style={{width: '156.3px'}}>
                          <label className='mt-3'>{_index + 1}</label>
                        </td>
                        <td className='text-center' style={{width: '156.3px'}}>
                          <label className='mt-3'>{data.date}</label>
                        </td>
                        <td className='text-center' style={{width: '156.3px'}}>
                          <label className='mt-3'>
                            {t('Week') + Math.ceil(data.date / 7)}
                            {/* {data.week} */}
                          </label>
                        </td>
                        <td className='text-center' style={{width: '156.3px'}}>
                          <label className='mt-3'>{t(bulan[data.month - 1])}</label>
                        </td>
                        <td className='text-center' style={{width: '156.3px'}}>
                          <label className='mt-3'>{data.year}</label>
                        </td>
                        <td className='text-center' style={{width: '156.3px'}}>
                          {editedIndex == _index ? (
                            <CurrencyInput
                              id='ton'
                              placeholder={t('order-tonase')}
                              className='form-control form-control-sm'
                              defaultValue={data.tonnage}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                setTempTon(parseFloat(value?.replace(/,/g, '.')))
                              }}
                              decimalsLimit={3}
                            />
                          ) : (
                            <label className='mt-3'>
                              {(i18next.language === 'en'
                                ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                                : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                                ' ' +
                                'Ton'}
                            </label>
                          )}
                        </td>
                        <td style={{width: '156.3px'}} className='text-center'>
                          {editedIndex == _index ? (
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Approve')}
                              onClick={() => rubahSchedule(_index, tempTon, data.tonnage)}
                            >
                              <KTSVG
                                path='/media/icons/duotune/check-square.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          ) : (
                            <ActionIcon
                              className='me-1'
                              title={t('ubah')}
                              iconPath='/media/icons/duotune/pencil-fill.svg'
                              onClick={() => {
                                setEditedIndex(_index)
                                setTempTon(data.tonnage)
                              }}
                            />
                          )}

                          <ActionIcon
                            iconPath='/media/icons/duotune/trash-fill.svg'
                            title={t('Hapus')}
                            onClick={() => hapusSchedule(_index)}
                          />
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* modal jadwal dari db */}
        <Modal
          show={showJadwal2}
          onHide={() => {
            setShowJadwal2(false)
            sessionStorage.removeItem('isCustomer')
          }}
          centered
          size='xl'
          backdrop='static'
          keyboard={false}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {sektorID != 3 ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
              {pname} | {fixedQuantum2} Ton
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            {allJadwal.length < 1 ? (
              <div className='text-center fs-4 fw-semibold'>{t('no schedule')}</div>
            ) : (
              <div className='table-responsive bdr mt-2'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='border-bottom'>
                    <tr className='fw-bold '>
                      <th className='text-center'>{t('order-pengambilan')}</th>
                      <th className='text-center'>{t('order-tanggal')}</th>
                      <th className='text-center'>{t('order-minggu')}</th>
                      <th className='text-center'>{t('order-bulan')}</th>
                      <th className='text-center'>{t('order-tahun')}</th>
                      <th className='text-center'>{t('order-tonase')}</th>
                    </tr>
                  </thead>
                  {allJadwal.map((data, _index) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.date}</label>
                        </td>
                        <td className='text-center'>
                          <label>
                            {t('Week')} {Math.ceil(data.date / 7)}
                          </label>
                        </td>
                        <td className='text-center'>
                          <label>{t(bulan[data.month - 1])}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.year}</label>
                        </td>
                        <td className='text-center'>
                          <label>
                            {(i18next.language === 'en'
                              ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                              : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                              ' ' +
                              'Ton'}
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* modal comment */}
        <Modal
          show={showCommentCust}
          onHide={() => setShowCommentCust(false)}
          centered
          backdrop='static'
          size='lg'
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Comment')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {fullcomment?.length < 1 ? (
              <div>{t('No Comment')}</div>
            ) : (
              <div className='table-responsive mt-10 bdr'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold w-100 align-items-center'>
                      <th className='td-3 text-center'>{t('no')}</th>
                      <th className='td-3 text-center'>{t('order-tanggal')}</th>
                      <th className='td-3 text-center'>{t('order-user')}</th>
                      <th className='td-3 text-center'>Status</th>
                      <th className='td-3 text-center'>{t('Comment')}</th>
                    </tr>
                  </thead>
                  {fullcomment?.map((item: any, _index: number) => (
                    <tbody key={item?.id ?? _index}>
                      <tr className='w-100 align-items-center'>
                        <td className='td-150 text-center'>{_index + 1}</td>
                        <td className='td-150 text-center'>{item.created_at?.slice(0, 10)}</td>
                        <td className='td-150 text-center'>{item.user?.name}</td>
                        <td className='td-150 text-center'>
                          {item.type == 1
                            ? t('order-revisi')
                            : item.type == 2
                            ? t('order-tolak')
                            : item.type == 10
                            ? t('revisi amandemen')
                            : item.type == 11
                            ? t('reject amandemen')
                            : ''}
                        </td>
                        <td className='td-60 text-center'>
                          <div style={{textAlign: 'justify', padding: '0 0.775rem'}}>
                            {item.comment}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
                {/* End Table Head */}
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* modal reason */}
        <Modal
          size='lg'
          show={showReason}
          onHide={() => setShowReason(false)}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('notes')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='text-center'>{reason}</div>
          </Modal.Body>
          {/* <Modal.Body>
          <FloatingLabel controlId='floatingTextarea2' label={t('Comment')}>
            <Form.Control
              as='textarea'
              id='areacomment'
              disabled={(roleUser == 'null' || roleUser == null) || indexedComment.find((element : any) => element == temporaryIndex) == temporaryIndex ? true : false }
              placeholder={t('Tinggal-pesan')}
              style={{height: '100px'}}
              onChange={(e: any) => setReason(e.target.value)}
            />
          </FloatingLabel>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' className='mt-3 mb-3' onClick={() => handlePostComment()}>
              {t('submit')}
            </Button>
          </div>
          {fullComment?.length < 1 ? (
            ''
          ) : (
            <div className='table-responsive mt-10 bdr'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold w-100 align-items-center'>
                    <th className='td-3 text-center'>{t('no')}</th>
                    <th className='td-3 text-center'>{t('order-tanggal')}</th>
                    <th className='td-3 text-center'>{t('order-user')}</th>
                    <th className='td-3 text-center'>{t('Comment')}</th>
                  </tr>
                </thead>
                {fullComment?.map((item: any, _index: any) => (
                  <tbody>
                    <tr className='w-100 align-items-center'>
                      <td className='td-150 text-center'>{_index + 1}</td>
                      <td className='td-150 text-center'>{item.created_at?.slice(0, 10)}</td>
                      <td className='td-150 text-center'>{item.user?.name}</td>
                      <td className='td-60 text-center text-truncate'>
                        <label
                          className='text-truncate'
                          onClick={() => handleCommentClick(item.comment)}
                          style={{
                            width: '200px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {item.comment}
                        </label>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          )}
        </Modal.Body> */}
        </Modal>

        {/* modal tambah product */}
        <Modal
          show={showAddProduct}
          onHide={() => {
            setShowAddProduct(false)
            clearState()
          }}
          centered
          backdrop='static'
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('+tambah product')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <Row>
                {showPurchaseForm ? (
                  <>
                    <FormDetailAddProduct
                      separateValueProdusen={separateValueProdusen}
                      separateValue2={separateValue2}
                      separateValue={separateValue}
                      separator2={separator2}
                      fieldClearer={fieldClearer}
                      setProdusenCode={setProdusenCode}
                      setProdusenDesc={setProdusenDesc}
                      setIncoterm1={setIncoterm1}
                      setIncoterm1Desc={setIncoterm1Desc}
                      setProvince={setProvince}
                      setProvinceDesc={setProvinceDesc}
                      setDestinationProvince={setDestinationProvince}
                      setDestinationProvinceDesc={setDestinationProvinceDesc}
                      setPtype={setPtype}
                      setPtype2={setPtype2}
                      sektorID={sektorID}
                      idSektor={idSektor}
                      produsen={produsen}
                      pnumber={pnumber}
                      setPname={setPname}
                      quantum={quantum}
                      language={language}
                      setQuantum={setQuantum}
                      pname={pname}
                      ptype={ptype}
                      setShipping={setShipping}
                      setPay1={setPay1}
                      setPay1Desc={setPay1Desc}
                      setketerangan={setketerangan}
                      setSegment={setSegment}
                      setSegmentDesc={setSegmentDesc}
                      setEnduser={setEnduser}
                      setEnduserDesc={setEnduserDesc}
                      setEnduserArray={setEnduserArray}
                      setIsNoEnduser={setIsNoEnduser}
                      setIncoterm2={setIncoterm2}
                      setIncoterm2Desc={setIncoterm2Desc}
                      province={province}
                      setDestinationCity={setDestinationCity}
                      setDestinationCityDesc={setDestinationCityDesc}
                      setPnumber={setPnumber}
                      setNote={setNote}
                      formulaPrice={formulaPrice}
                      subprice={subprice}
                      setSubprice={setSubprice}
                      setIncludePpn={setIncludePpn}
                      setFormulaPrice={setFormulaPrice}
                      setPay2={setPay2}
                      setPay2Desc={setPay2Desc}
                      setPspec={setPspec}
                      setCity={setCity}
                      city={city}
                      warehouse={warehouse}
                      warehouseDesc={warehouseDesc}
                      setCityDesc={setCityDesc}
                      plantChange={plantChange}
                      isNoEnduser={isNoEnduser}
                      includePpn={includePpn}
                      fullProvince={fullProvince}
                      fullProductType={fullProductType}
                      fullProdusen={fullProdusen}
                      fullIncoterm={fullIncoterm}
                      fullPayment={fullPayment}
                      fullSegment={fullSegment}
                      fullEndUser={fullEndUser}
                      arrayEnduser={arrayEnduser}
                      fullDestinationCity={fullDestinationCity}
                      fullProductName={fullProductName}
                      fullCity={fullCity}
                      fullPlant={fullPlant}
                    />
                  </>
                ) : (
                  <>
                    {nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202' ? (
                      <>
                        <Row>
                          <Col md={6}>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='produsen'
                                  placeholder={t('pilih')}
                                  onChange={(e: any) => {
                                    separateValueProdusen(
                                      setProdusenCode,
                                      e?.value,
                                      setProdusenDesc
                                    )
                                    fieldClearer(8)
                                  }}
                                  options={fullProdusen}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>Incoterm</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  aria-label='Default select example'
                                  size='sm'
                                  id='incoterm1'
                                  key={idSektor + produsen + fullIncoterm}
                                  onChange={(e: any) => {
                                    separateValue2(setIncoterm1, e.target.value, setIncoterm1Desc)
                                  }}
                                >
                                  <option value='0'>
                                    {t('pilih')} {t('sub-order-incoterm1')}
                                  </option>
                                  {fullIncoterm.map((items: any, index: number) => (
                                    <option key={items?.value ?? index} value={items.value}>
                                      {items.label}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className='mb-4' hidden={sektorID == 3 ? true : false}>
                              <Col sm={4}>
                                <p className='mt-3 fs-6'>
                                  {t('sub-order-provinsi')}
                                  <span className='text-danger'>*</span>{' '}
                                </p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='provinsi'
                                  key={idSektor + produsen}
                                  placeholder={t('pilih')}
                                  onChange={(e: any) => {
                                    setFullCity([])
                                    cityData(e?.value)
                                  }}
                                  options={fullProvince}
                                />
                              </Col>
                            </Row>

                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Select
                                  size='sm'
                                  aria-label='Default select example'
                                  id='jenis'
                                  onChange={(e: any) => {
                                    productTypeChange(e.target.value)
                                  }}
                                >
                                  <option hidden value='~#~'>
                                    {t('Pilih-productType')}
                                  </option>
                                  {fullProductType.map((item: any) => {
                                    return (
                                      <>
                                        {item.id != 12 && (
                                          <option
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        )}
                                      </>
                                    )
                                  })}
                                </Form.Select>
                              </Col>
                            </Row>

                            <Row className='mb-4'>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                              </Col>
                              <Col sm={8}>
                                <InputGroup size='sm'>
                                  <CurrencyInput
                                    className='form-control form-control-sm'
                                    id='kuantum'
                                    key={change.toString()}
                                    decimalSeparator={language === 'en' ? '.' : ','}
                                    groupSeparator={language === 'en' ? ',' : '.'}
                                    onValueChange={(value: any) => {
                                      setQuantum(value?.replace(/,/g, '.'))
                                    }}
                                    decimalsLimit={3}
                                  />
                                  <InputGroup.Text id='basic-addon2'>
                                    {sektorID === 3 ? 'MT' : 'Ton'}
                                  </InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Row>

                            <Row>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-endUser')}</p>
                              </Col>
                              <Col sm={8}>
                                {isNoEnduser || idSektor == 3 ? (
                                  <Form.Control
                                    size='sm'
                                    as='textarea'
                                    id='enduser'
                                    style={{height: '40px'}}
                                    placeholder={t('End Customer')}
                                    onChange={(e: any) => {
                                      setEnduser(e.target.value)
                                      setEnduserDesc(e.target.value)
                                    }}
                                  />
                                ) : (
                                  <MultiSelect
                                    options={fullEndUser?.map((item: any) => {
                                      return {label: t(item.name), value: item.name}
                                    })}
                                    value={arrayEnduser}
                                    onChange={(e: any) => {
                                      setEnduserArray(e)
                                    }}
                                    labelledBy='Select'
                                  />
                                )}
                              </Col>
                            </Row>

                            {idSektor == 1 && (
                              <Row className='mb-4'>
                                <Col sm={4}></Col>
                                <Col sm={8} className='d-flex'>
                                  <Form.Check
                                    onClick={() => setIsNoEnduser(!isNoEnduser)}
                                    defaultChecked={isNoEnduser}
                                    disabled={disableCKBOX}
                                    name='ppn'
                                    id='noenduser'
                                    className='mt-4 mb-2'
                                    type='checkbox'
                                  />
                                  {i18next.language == 'en' ? (
                                    <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                  ) : (
                                    <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                                  )}
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <Col md={6}>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  value={sektorID === 1 ? t('Domestik Korperasi') : t('Export')}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                              </Col>
                              <Col sm={8}>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('sub-order-catatan')}
                                  id='note'
                                  size='sm'
                                  style={{height: '40px'}}
                                  onChange={(e: any) => setNote(e.target.value)}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4' hidden={sektorID == 3 ? true : false}>
                              <Col sm={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='kota'
                                  placeholder={t('pilih')}
                                  isDisabled={sektorID == 3 ? true : false}
                                  key={province}
                                  onChange={(e: any) => {
                                    const tmp = e.value.split('~#~')
                                    setCity(tmp[0])
                                    // fieldClearer(4)
                                  }}
                                  options={fullCity}
                                />
                              </Col>
                            </Row>
                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                              </Col>
                              <Col sm={8}>
                                <Select
                                  id='nama'
                                  placeholder={t('pilih')}
                                  key={ptype + tempEdit.material_number + fullProductName}
                                  onChange={(e: any) => {
                                    // productNameChange(e.target.value)
                                    const tmp = e.value.split('~#~')
                                    const productName = tmp[1]
                                    setPnumber(tmp[0])
                                    setPunit(tmp[2])
                                    setPname(productName)
                                    // fieldClearer(1)
                                  }}
                                  options={fullProductName}
                                />
                              </Col>
                            </Row>

                            <Row className='mb-4'>
                              <Col sm={4}>
                                <p className='fs-6 mt-3'>
                                  {t('Harga Pengajuan')}/{sektorID === 3 ? 'MT' : 'Ton'}
                                </p>
                              </Col>
                              <Col sm={8}>
                                <InputGroup size='sm'>
                                  <InputGroup.Text>
                                    <span className='px-1'>{sektorID == 3 ? 'USD ' : 'Rp '}</span>
                                  </InputGroup.Text>
                                  <CurrencyInput
                                    className='form-control form-control-sm'
                                    id='hargap'
                                    key={change.toString()}
                                    defaultValue={tempEdit?.request_price}
                                    decimalSeparator={language === 'en' ? '.' : ','}
                                    groupSeparator={language === 'en' ? ',' : '.'}
                                    onValueChange={(value: any) => {
                                      setSubprice(value?.replace(/,/g, '.'))
                                    }}
                                    decimalsLimit={sektorID == 3 ? 2 : -1}
                                    placeholder={t('Harga Pengajuan')}
                                  />
                                </InputGroup>
                              </Col>
                            </Row>
                            <Row className='my-7' hidden={sektorID == 3 ? true : false}>
                              <Col sm={4} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('termasuk-ppn')}</p>
                              </Col>
                              <Col
                                sm={8}
                                className='d-flex justify-content-start align-items-center'
                              >
                                <Form.Check reverse name='ppn' type='checkbox' id='ckbox-ppn' />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row className='mb-3'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='produsen'
                              placeholder={t('pilih')}
                              onChange={(e: any) => {
                                separateValueProdusen(setProdusenCode, e?.value, setProdusenDesc)
                                fieldClearer(1)
                              }}
                              options={fullProdusen}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col sm={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              value={sektorID === 1 ? t('Domestik Korperasi') : t('Export')}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='jenis'
                              onChange={(e: any) => {
                                productTypeChange(e.target.value)
                              }}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-productType')}
                              </option>
                              {fullProductType.map((item: any) => {
                                return (
                                  <>
                                    {item.id != 12 && (
                                      <>
                                        {item.material_group_desc == tempEdit?.product_type_desc ? (
                                          <option
                                            selected
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        ) : (
                                          <option
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        )}
                                      </>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-4 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='nama'
                              placeholder={t('pilih')}
                              key={ptype + fullProductName}
                              defaultValue={
                                fullProductName[
                                  fullProductName.findIndex(
                                    (item: any) =>
                                      item.truevalue == parseInt(tempEdit?.material_number)
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                // productNameChange(e.target.value)
                                const tmp = e.value.split('~#~')
                                const productName = tmp[1]
                                setPnumber(tmp[0])
                                setPunit(tmp[2])
                                setPname(productName)
                                // fieldClearer(1)
                              }}
                              options={fullProductName}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              as='textarea'
                              placeholder={t('sub-order-catatan')}
                              defaultValue={tempEdit?.notes}
                              id='note'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => {
                                setNote(e.target.value)
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-endUser')}</p>
                          </Col>
                          <Col sm={8}>
                            {isNoEnduser || idSektor == 3 ? (
                              <Form.Control
                                size='sm'
                                as='textarea'
                                id='enduser'
                                style={{height: '40px'}}
                                placeholder={t('End Customer')}
                                defaultValue={tempEdit?.end_user_multiple ? '' : tempEdit?.end_user}
                                onChange={(e: any) => {
                                  setEnduser(e.target.value)
                                  setEnduserDesc(e.target.value)
                                }}
                              />
                            ) : (
                              <MultiSelect
                                options={fullEndUser?.map((item: any) => {
                                  return {label: t(item.name), value: item.name}
                                })}
                                value={arrayEnduser}
                                onChange={(e: any) => {
                                  setEnduserArray(e)
                                }}
                                labelledBy='Select'
                              />
                            )}
                          </Col>
                        </Row>
                        {idSektor == 1 && (
                          <Row className='mb-4'>
                            <Col sm={4}></Col>
                            <Col sm={8} className='d-flex'>
                              <Form.Check
                                onClick={() => setIsNoEnduser(!isNoEnduser)}
                                defaultChecked={isNoEnduser}
                                disabled={disableCKBOX}
                                name='ppn'
                                className='mt-4 mb-2'
                                id='noenduser'
                                type='checkbox'
                              />
                              {i18next.language == 'en' ? (
                                <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                              ) : (
                                <p className='fs-6 mt-4 ms-2'>{t('TidakAdaEndUser')}</p>
                              )}
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </>
                )}
                <div className='d-flex justify-content-end '>
                  <Button disabled={btnLoading} className='btn btn-primary' onClick={handleAddProduct}>
                    {t('order-tambah')}
                  </Button>
                </div>
              </Row>
            </Form.Group>
          </Modal.Body>
        </Modal>

        {/* modal chat */}
        <Modal
          show={showFullChat}
          onHide={() => setShowFullChat(false)}
          centered
          backdrop='static'
          size='lg'
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Chat')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FloatingLabel controlId='floatingTextarea2' label={t('Chat')}>
              <Form.Control
                as='textarea'
                id='areachat'
                placeholder={t('Tinggal-pesan')}
                style={{height: '100px'}}
                onChange={(e: any) => setTempChat(e.target.value)}
              />
            </FloatingLabel>
            <div className='d-flex justify-content-end'>
              <Button variant='primary' className='mt-3 mb-3' onClick={() => handlePostChat()}>
                {t('Tambah')}
              </Button>
            </div>
            {fullChat?.length < 1 ? (
              ''
            ) : (
              <div className='table-responsive mt-10 bdr'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold w-100 align-items-center'>
                      <th className='td-3 text-center px-0' style={{width: 70}}>
                        {t('no')}
                      </th>
                      <th className='td-3 text-center'>{t('order-tanggal')}</th>
                      {/* <th className='td-3 text-center'>{t('User Code')}</th> */}
                      <th className='td-3 text-center'>{t('order-user')}</th>
                      <th className='td-3 text-center'>{t('Chat')}</th>
                    </tr>
                  </thead>
                  {fullChat?.map((item: any, _index: number) => (
                    <tbody key={item?.id ?? _index}>
                      <tr className='w-100 align-items-center'>
                        <td className='text-center' style={{width: 70}}>
                          {_index + 1}
                        </td>
                        <td className='td-150 text-center'>{handleClick(item.created_at)}</td>
                        {/* <td className='td-150 text-center'>
                          {item.user?.customer_code || item.user?.nama_pengguna}
                        </td> */}
                        <td className='td-150 text-center'>{item.user?.name}</td>
                        <td className='td-60 text-center'>
                          <div style={{textAlign: 'justify', padding: '0 0.775rem'}}>
                            {item.comment}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* modal jadwal local */}
        <Modal
          show={showJadwal}
          onHide={() => {
            setShowJadwal(false)
            setTempTanggal(0)
          }}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {sektor != '3' ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
              {pname} | {fixedQuantum2} Ton
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <span style={{fontSize: '15px'}} className='fw-bold d-block'>
                {t('Jadwal')}
              </span>
              <div className='table-responsive bdr mt-1'>
                <table className='table-border w-100'>
                  <thead>
                    <tr className='d-flex'>
                      {/* <th style={{ width: '60px' }} className="text-center">{t('order-aksi')}</th> */}
                      <th style={{width: '165.5px'}} className='text-center'>
                        {t('order-pengambilan')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-tanggal')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-minggu')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-bulan')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-tahun')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-tonase')}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <div>
                      <tr className='d-flex'>
                        <td style={{width: '165.5px'}} className='text-center'>
                          <p className='mt-3'>{taking + 1}</p>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <Form.Select
                            aria-label='Default select example'
                            id='jadwaltanggal1'
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            onChange={(e: any) => setTempTanggal(parseInt(e.target.value))}
                          >
                            <option selected value={0} disabled hidden>
                              {t('Pilih-Tanggal')}
                            </option>
                            {daysInMonth != 0 ? loopTanggal(daysInMonth) : ''}
                          </Form.Select>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <Form.Control
                            aria-label='Default select example'
                            id='jadwalminggu'
                            placeholder={t('order-minggu')}
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            value={tempTanggal == 0 ? '' : t('Week') + Math.ceil(tempTanggal / 7)}
                          />
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center  d-flex justify-content-center'
                        >
                          <Form.Select
                            aria-label='Default select example'
                            id='jadwalbulan'
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            onChange={(e: any) => setTempBulan(parseInt(e.target.value))}
                          >
                            <option selected disabled>
                              {t('Pilih-Month')}
                            </option>
                            <option value='1'>{t('Januari')}</option>
                            <option value='2'>{t('Februari')}</option>
                            <option value='3'>{t('Maret')}</option>
                            <option value='4'>{t('April')}</option>
                            <option value='5'>{t('Mei')}</option>
                            <option value='6'>{t('Juni')}</option>
                            <option value='7'>{t('Juli')}</option>
                            <option value='8'>{t('Agustus')}</option>
                            <option value='9'>{t('September')}</option>
                            <option value='10'>{t('Oktober')}</option>
                            <option value='11'>{t('November')}</option>
                            <option value='12'>{t('Desember')}</option>
                          </Form.Select>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center  d-flex justify-content-center'
                        >
                          <Form.Select
                            aria-label='Default select example'
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            id='jadwaltahun'
                            onChange={(e: any) => setTempTahun(parseInt(e.target.value))}
                          >
                            <option selected disabled>
                              {t('Pilih-Year')}
                            </option>
                            {listYear.map((data: string, index: number) => {
                              return (
                                <option key={data ?? index} value={data}>
                                  {data}
                                </option>
                              )
                            })}
                          </Form.Select>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <CurrencyInput
                            id='jadwalton'
                            className='form-control form-control-sm'
                            placeholder={t('order-tonase')}
                            style={{width: '90%'}}
                            key={tempTahun}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setTempTon(parseFloat(value?.replace(/,/g, '.')))
                            }}
                            decimalsLimit={3}
                          />
                        </td>
                      </tr>
                    </div>
                  </tbody>
                  <div className='d-flex justify-content-end mt-5'>
                    <Button
                      variant='primary'
                      onClick={() => {
                        sendJadwalNewProduct()
                      }}
                    >
                      {t('order-kirim')}
                    </Button>
                  </div>
                </table>
              </div>
              <div
                className='table-responsive bdr mt-8'
                hidden={allJadwal?.length < 1 || allJadwal?.length == undefined ? true : false}
              >
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='border-bottom'>
                    <tr className='fw-bold d-flex'>
                      <th className='text-center' style={{width: '156.5px'}}>
                        {t('order-pengambilan')}
                      </th>
                      <th className='text-center' style={{width: '156.5px'}}>
                        {t('order-tanggal')}
                      </th>
                      <th className='text-center' style={{width: '156.5px'}}>
                        {t('order-minggu')}
                      </th>
                      <th className='text-center' style={{width: '156.5px'}}>
                        {t('order-bulan')}
                      </th>
                      <th className='text-center' style={{width: '156.5px'}}>
                        {t('order-tahun')}
                      </th>
                      <th className='text-center' style={{width: '156.5px'}}>
                        {t('order-tonase')}
                      </th>
                      <th className='text-center' style={{width: '156.5px'}}>
                        {t('order-aksi')}
                      </th>
                    </tr>
                  </thead>
                  {allJadwal?.map((data, _index) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className='d-flex'>
                        <td className='text-center' style={{width: '156.5px'}}>
                          <label className='mt-3'>{_index + 1}</label>
                        </td>
                        <td className='text-center' style={{width: '156.5px'}}>
                          <label className='mt-3'>{data.date}</label>
                        </td>
                        <td className='text-center' style={{width: '156.5px'}}>
                          <label className='mt-3'>
                            {t('Week') + Math.ceil(data.date / 7)}
                            {/* {data.week} */}
                          </label>
                        </td>
                        <td className='text-center' style={{width: '156.5px'}}>
                          <label className='mt-3'>{t(bulan[data.month - 1])}</label>
                        </td>
                        <td className='text-center' style={{width: '156.5px'}}>
                          <label className='mt-3'>{data.year}</label>
                        </td>
                        <td className='text-center' style={{width: '156.5px'}}>
                          {editedIndex == _index ? (
                            <CurrencyInput
                              id='ton'
                              placeholder={t('order-tonase')}
                              className='form-control form-control-sm'
                              defaultValue={data.tonnage}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                setTempTon(parseFloat(value?.replace(/,/g, '.')))
                              }}
                              decimalsLimit={3}
                            />
                          ) : (
                            <label className='mt-3'>
                              {(i18next.language === 'en'
                                ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                                : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                                ' ' +
                                'Ton'}
                            </label>
                          )}
                        </td>
                        <td className='text-center' style={{width: '156.5px'}}>
                          {editedIndex == _index ? (
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Approve')}
                              onClick={() => rubahScheduleNewProduct(_index, tempTon, data.tonnage)}
                            >
                              <KTSVG
                                path='/media/icons/duotune/check-square.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          ) : (
                            <ActionIcon
                              className='me-1'
                              title={t('ubah')}
                              iconPath='/media/icons/duotune/pencil-fill.svg'
                              onClick={() => {
                                setEditedIndex(_index)
                                setTempTon(data.tonnage)
                              }}
                            />
                          )}

                          <ActionIcon
                            title={t('Hapus')}
                            iconPath='/media/icons/duotune/trash-fill.svg'
                            onClick={() => hapusScheduleNewProduct(_index)}
                          />
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* modal attachmment revisi*/}
        <Modal
          show={showAttachmentRevisi}
          size='lg'
          onHide={() => {
            setShowAttachmentRevisi(false)
            setIsPrivate(false)
            setTempRole([])
            setAllFiles([])
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {fileBox?.product_name
                ? (fileBox.province ? fileBox.province?.region_name : '') +
                  (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                  (fileBox.province ? ' | ' : '') +
                  fileBox.product_name +
                  (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                : t('File Box')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-fileUnggah')}</h6>
                    </td>
                    <td className='w-75'>
                      <InputFile
                          setFileName={setNamaFile}
                          setFiles={setFiles3}
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-keterangan')}</h6>
                    </td>
                    <td className='w-75'>
                      <Form.Control
                        type='text'
                        id='uploadketerangan'
                        placeholder={t('order-keterangan')}
                        onChange={(e: any) => setDescription(e.target.value)}
                      />
                    </td>
                  </tr>
                </table>
                {roleUser != null || roleUser != 'null' && (
                  <table className='mb-3'>
                    <tr>
                      <td>
                        <h6 className='me-11'>{t('Private')}</h6>
                      </td>
                      <td className='w-75 d-flex justify-content-start'>
                        <Form.Check
                          reverse
                          type='checkbox'
                          className='mt-5 mb-2'
                          onClick={() => {
                            setIsPrivate(!isPrivate)
                            setTempRole([])
                          }}
                          id='isPrivate3'
                        />
                      </td>
                    </tr>
                  </table>
                )}
                <table className='mb-3' hidden={isPrivate ? false : true}>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('Akses Role')}</h6>
                    </td>
                    <td className='w-75' style={{maxWidth: '274px'}}>
                      <MultiSelect
                        key={isPrivate.toString()}
                        options={fullRole?.map((item: any) => {
                          return {label: item.label, value: item.value}
                        })}
                        value={tempRole}
                        onChange={(e: any) => setTempRole(e)}
                        labelledBy='Select'
                      />
                    </td>
                  </tr>
                </table>
                <div className='d-flex justify-content-end'>
                  <Button variant='primary' className='w-100' onClick={() => handleUpload3()}>
                    {t('order-kirim')}
                  </Button>
                </div>
              </Col>
              <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='fw-bold border-bottom'>
                    <tr className=''>
                      <th className='text-center px-2'>{t('order-noo')}</th>
                      <th className='text-center'>{t('order-keterangan')}</th>
                      <th className='text-center'>{t('order-tglUpload')}</th>
                      {/* <th className='text-center'>{t('User Code')}</th> */}
                      <th className='text-center'>{t('order-user')}</th>
                      <th className='text-center'>{t('Akses Role')}</th>
                      <th className='text-center'>{t('order-aksi')}</th>
                    </tr>
                  </thead>
                  {allFile.map((data: any, _index: number) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.description}</label>
                        </td>
                        <td className='text-center'>
                          <label>{dateformat(data.updated_at)}</label>
                        </td>
                        {/* <td className='text-center'>
                          <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                        </td> */}
                        <td className='text-center'>
                          <label>
                            {data.user?.customer_code == null
                              ? data.user?.name
                              : data.user?.customer?.name}
                          </label>
                        </td>
                        <td className='text-center'>
                          {data.private ? (
                            data.roles.length > 0 ? (
                              <PopoverText
                                content={handleShowRoleName(data.roles)}
                                index={_index}
                                className='desc-slice'
                              />
                            ) : (
                              'Private'
                            )
                          ) : (
                            'Public'
                          )}
                        </td>
                        <td className='text-center'>
                          <ActionIcon
                            className='me-1'
                            title={t('unduh')}
                            iconPath='/media/icons/duotune/arrow-down-square-fill.svg'
                            onClick={() =>
                              handleDownloadAttachment(data.file_path)
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  ))}
                  {detailOrder[indexAttac]?.attachments
                    ?.reverse()
                    .map((data: any, _index: number) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1 + allFile.length}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(getCurrentFormattedDate())}</label>
                          </td>
                          <td className='text-center'>
                            <label>{localStorage.getItem('username')}</label>
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleNameFromState(data.roles)}
                                  index={_index}
                                  className='desc-slice'
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <ActionIcon
                              className='me-1'
                              title={t('unduh')}
                              iconPath='/media/icons/duotune/arrow-down-square-fill.svg'
                              onClick={() => download_file(data.file_r, data.name)}
                            />
                            <ActionIcon
                              title={t('Hapus')}
                              iconPath='/media/icons/duotune/trash-fill.svg'
                              onClick={() =>
                                handleDeleteUploadAttac(
                                  detailOrder[indexAttac]?.attachments?.length - 1 - _index,
                                  detailOrder[indexAttac]?.attachments
                                )
                              }
                            />
                          </td>
                        </tr>
                      </tbody>
                    ))}
                </table>
              </div>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    </>
  )
}

export {OrderDetail}
